import { Component, ViewChild, ElementRef, Renderer, OnInit, HostListener, ChangeDetectorRef, Input, NgZone } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, AlertController,
  Platform,ToastController,
  PopoverController,
  Nav} from 'ionic-angular';
import { CajaProvider } from '../../providers/caja/caja'
import { LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Observable } from 'rxjs/Observable';
import  'rxjs/add/observable/interval';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { MesasProvider } from '../../providers/mesas/mesas';
import { DenominacionesProvider } from '../../providers/denominaciones/denominaciones'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { ElectronService } from 'ngx-electron';
import { URL_SERVICIOS_LOCALES, MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, GESTION_PEDIDOS_SALON, NUBE_AWS, URL_REDIRECT_IONIC7 } from "../../config/url.servicio"
import JsBarcode from 'jsbarcode';
import { trigger, state, style, transition, animate} from '@angular/animations';
import { ProductosProvider } from '../../providers/productos/productos'
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { ImprimirPage } from '../imprimir/imprimir'
import { ImpresoraBluetoothPage } from '../impresora-bluetooth/impresora-bluetooth'
import { PushProvider } from '../../providers/push/push'
import { ImpresoraBluePage } from '../impresora-blue/impresora-blue'
import { Http,RequestOptions,Headers } from '@angular/http';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilsProvider } from '../../providers/utils/utils'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { clientes } from '../../models/clientes'
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { Store } from '@ngrx/store';
import * as fromData from '../../store/actions/index'
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import { State } from '../../store/app.reducer'
import { valueDisplay } from '../../models/valueDisplay.model';
import { AppState } from '../../app/app.reducer';
import { ClienteRapidoPage } from '../cliente-rapido/cliente-rapido';
import { WhatsappPage } from '../whatsapp/whatsapp';
import { GestionCambioPrecioPorProductoPage } from '../gestion-cambio-precio-por-producto/gestion-cambio-precio-por-producto';
import { SimuladorCuentasPorCobrarPage } from '../simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar';
import { ClientesVentasComponent } from '../../components/clientes-ventas/clientes-ventas';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { FacturaSelectComponent } from '../../components/factura-select/factura-select';
import { FormaPagoPopoverComponent } from '../forma-pago-popover/forma-pago-popover';
import { ImprimirGlobalComponent } from '../imprimir-global/imprimir-global';
import { DesconectService } from '../../providers/desconect/desconect-service';
import { ProductosCamposAdicionalesCambiarValorComponent } from '../../components/productos-campos-adicionales-cambiar-valor/productos-campos-adicionales-cambiar-valor';
import { CuentasPorCobrarCreditosPage } from '../cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos';
import { ClientesPage } from '../clientes/clientes';
import { ProductosRapidosComponent } from '../../components/productos-rapidos/productos-rapidos';
import { InteresesCreditosPorCostosAdicionalesComponent } from '../intereses-creditos-por-costos-adicionales/intereses-creditosporcostosadicionales';
import { CostosadicionalesPage } from '../costosadicionales/costosadicionales';
import { InteresesCreditosComponent } from '../intereses-creditos/intereses-creditos';
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion';
import { CallcenterProvider } from '../../providers/callcenter/callcenter';
import { CreditosComponent } from '../../components/creditos/creditos';
import { HomePage } from '../home/home';
import { BehaviorSubject } from 'rxjs';
import { ProductosPorGruposDragPage } from '../productos-por-grupos-drag/productos-por-grupos-drag';
import { PersonalizarPage } from '../personalizar/personalizar';
import { InformeReimprimirReciboCajaPage } from '../informe-reimprimir-recibo-caja/informe-reimprimir-recibo-caja';
import { ShortcutConfiguratorComponent } from '../../components/shortcutconfigurator/shortcut-configurator';
import { Content } from 'ionic-angular';
// @IonicPage()
@Component({
  selector: 'page-cajavertical',
  templateUrl: 'cajavertical.html',
  providers: [ AuthService,CajaProvider,ElectronService,
    MesasProvider,DenominacionesProvider,CompaniasProvider,ProductosPorGruposProvider,PushProvider ,InAppBrowser,
    ParametrosGeneralesRedux,DesconectService,CallcenterProvider]
    ,
    animations: [
        trigger('openClose', [
            state('collapsed, void', style({height:'0px'})),
            state('expanded', style({height:'*'})),
            transition('collapsed <=> expanded',[animate(300,style({height:'*'})),
                animate(300)])

        ])
    ]
    })

export class CajaverticalPage  {
  messages: any[] = [];
  message: string = '';
  isMenuOpen: boolean = false; // Variable para controlar el estado del menú
  currentPage: string = '';
  draggedCard: string;
  companies: string[] = [];
  taskGroups: any[] = [];
  estadosGestion: any[] = [];
  seleccionado
  tags = ['Ionic', 'Angular', 'TypeScript'];

  listaGruposProductos = []
  valoresCliente: string = '';
  listaProductos = []
  listaProductosCopia = []
  listaClientes = [];
  filtrogruposProductosId
  // filtroABC
  // loader variable para guardar dialogos de alertas
  loader
  // saber si se esta filtrando
  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  // lista de productos que se van a comprar
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  priceFormaDePago:any = '0'
  valorTotalDevolver = 0
  // saber si se esta realizando una venta
  realizandoUnaVenta: boolean = false
  clienteId = []
  clienteGenerico

  listaMuestra = []
  valormesa = 0
  datosAdicionales:any
  listaDenominaciones = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerCodigoBarra;
  timerVal;
  public picture;
  public codigoBarra:any =""
  cantidadRealCodigoBarra:number = 0
  @ViewChild('canvasOld') canvasElement : ElementRef;
  public formState: string = 'collapsed'
  public formStateDescripcion: string = 'collapsed'
  public formStatebool:boolean= false
  public formStateboolDescripcion:boolean= false
  codigoProducto
  nombreProducto
  valorVenta
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId
  productoId
  listaGrupos
  CheckCredito:boolean = false
  CheckImprimir:boolean = false
  datosCredito = []
  ventasDiarias = []
  valorImpuestosIndividual:number=0
  valorProductoIndividual :number=0
  allItems: any;
  buscar: any = "";
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  listaABC = []
  imagenImprimir:boolean = false
  token:string
  element: HTMLElement;
  blue:string=''
  CheckPorcentajeServicio:boolean = false
  valorTotalServicio:number=0
  porcentajeServicio:PorcentajeServicio[] = []
  porcentajeServicioValor:string="N"
  porcentajeServicioValorPedidosSalon:string="N"
  cambiarFecha:boolean = false
  cambiarFechaArray:cambioDeFecha[] = []
  manejaCajaDinamica:boolean = false
  digitaCantidadEnVenta: boolean = false
  devolverVenta: boolean = false
  creaProductoRapidoDesdeCaja: boolean = false
  manejaCodigoDeBarras: boolean = false
  cantidadImpresionesEnCaja: string = "1"
  cantidadImpresiones: CantidadImpresiones[] = []
  digitaDescripcion: boolean = false
  descripcionVenta: string = ""
  creaClienteDesdeCaja: boolean = false
  estadoFormCrearCliente: boolean = false
  visualizaDetalleReciboEnCaja: boolean = false
  formasDePago: formasDePago[] = []
  formaPagoSeleccionada: string = 'O'
  formaPagoSeleccionadaNombre: string = 'EFECTIVO'

  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  cambiarPrecioEnLosProductos: boolean = false
  refactorizarPedidosSalon: boolean = false
  @ViewChild('cantidadafnprueba') cantidadafnprueba
  companiasId
  fechaVencimiento:Date
  manejaPlanDePagosEnCuentasPorCobrar: boolean = false
  guardarPlanDePagosEnCuentasPorCobrarSimulador: boolean = false
  gestionarSimuladorCuotasExtras: any | string = ''
  usuariosId
  nombreUsuario
  poselectronico: boolean= false;
  CheckDescuento:boolean = false
  inputValueDescuento: number = 0;
  manejaDescuentoPorPorcentaje: boolean = false;
  controlaImpresorasEnRed: boolean = false;
  ip:string = ''
  permiteEliminarPedido: boolean = true;
  creaVentaDesdePedidosSalon: boolean = false;
  planDePagosCreditoCompleto:any = []
  manejaInteresCreditos: boolean= false;
  planSepare: string = 'N'
  storageCreditos:any
  manejaInteresesEnCuentasDeCobro:boolean = false
  sobreGiroEnLosProductos:boolean = false
  mostrarMas = false;
  parametro: any;
  progreso: number = 0;
  barraVisible: boolean = false;
  cantidadPorPagina: number = 30; // La cantidad de registros por página antes 100
  //totalPaginas: number = 0; // Número total de páginas
  totalPaginas: number = Infinity;
  paginaActual: number = 1; // Página actual
  cargando: boolean = false;
  isCollapsed: boolean = false;
  contarProductos: number = 0;
  contarProductosSelect: number = 0;
  private productosSubject = new BehaviorSubject<any[]>([]);
  productos$ = this.productosSubject.asObservable();
  private productosSelectSubject = new BehaviorSubject<any[]>([]);
  productosSelect$ = this.productosSelectSubject.asObservable();
  @Input() showHeader: boolean = true ;
  interesesCorrientesVisualizarPlanDePagos: boolean = false;
  interesesMoraVisualizarPlanDePagos: boolean= false;
  capitalAtrasadoVisualizarPlanDePagos: boolean= false;
  costosAdicionalesVisualizarPlanDePagos: boolean= false;
  fechaVisualizarPlanDePagos: boolean= false;
  visualizaDiaDePago: boolean= false;
  visualizaExonerarInteresPrimeraCuota: boolean= false;
  visualizaNumeroDeCuotasExoneradas: boolean= false;
  montoDeLaCuota: boolean= false;
  montoDeLaCuotaConCostosEintereses: boolean= false;
  cuantoRestaEnLaCuota: boolean= false;
  recorrerVal = []
  clienteObligatorioEnCaja: boolean = false;
  @ViewChild(Nav) nav: Nav;
  turnosArray:any = [];
  mesaSeleccionada:any=0
  deseaImprimir: boolean = false;
  totals: { [key: number]: number } = {};
  groupedProducts: { [key: number]: any[] } = {};
  deDondeViene: any = undefined;
  formasDePagoGeneral: any = []
  assignedShortcuts: { [key: string]: string } = {};
  personalizarVenta:boolean = false
  turnoPersonalizado = 0
  formasDePagoSeGenero:boolean = false
  agrupaProductosEnCaja:boolean = false
  manejaPaginacionEnTendero:boolean = false;
  search:string = ''
  cargandoScroll:boolean = false;
  ultimoTiempoKeyup: number = null;
  entradaRapida: boolean = false;
  codigoTemporal: string = "";
  showBuscarProducto: boolean = false;
  buscarTexto:string = ""
  permitirSeleccion: boolean = true
  buscarTextoProductoRapido:string = ""
  unidad = 'UND'
  tipoImpuesto = "I"
  tipoImpuestoTexto = "Impoconsumo"
  @ViewChild('nombreProductoInput', { read: ElementRef }) nombreProductoInput: ElementRef;
  tipoproducto = 'P';
  showCrearProducto:boolean = false
  ultimoCodigoBarra: string = ""; // Para almacenar el último código leído
  ultimoTiempoEscaneo: number = 0; // Para almacenar el tiempo del último escaneo
  @ViewChild(ShortcutConfiguratorComponent) shortcutConfigurator: ShortcutConfiguratorComponent;
  impuestoPorDefectoAlCambiarNombre: string = 'SIN IMPUESTO'
  cambiarNombreYCambiarValorVentaAlProducto: boolean = false
  public pesoDesdeSocket: number | null = null; // Peso recibido desde el socket
  public urlServerSocket = 'http://localhost:3000'
  private socket: any; // Variable para manejar la conexión del socket
  public serialData: string = ""; // Variable para mostrar los datos en la vista
  pesaLosProductosEnTendero:boolean = false
   @ViewChild(Content) content: Content;
   @ViewChild('inicio') inicio: any;
  constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public alertControllers: AlertController,
        public platforms: Platform,
        public modalControllers: ModalController,
        public servicio: CajaProvider,
        private storage: Storage,
        public loadingCtrl: LoadingController,
        public servicioMesas:MesasProvider,
        public servicioDenominaciones: DenominacionesProvider,
        public auth: AuthService
        ,
        public servicioCompania:CompaniasProvider,
        private _electronService: ElectronService,
        public platform: Platform,
        public servicioProductos:ProductosProvider,
        public servicioProductosPorGruposProvider: ProductosPorGruposProvider,
        public toastControllers:ToastController,
        public push:PushProvider,
        public http: Http,private iab: InAppBrowser,
        public renderer: Renderer,
        private elementRef:ElementRef,
        public utils:UtilsProvider,
        public providerClientes: ClientesProvider,
        private store:Store<State>,
        private storePedidosSalon: Store<AppState>,
        public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
        private popoverCtrl: PopoverController,
        public apiDesconect: DesconectService,

    public callcenterProvider: CallcenterProvider ,
    public storages:Storage,
    private cd: ChangeDetectorRef,
     private zone: NgZone
      ){
        const storedState = localStorage.getItem('isCollapsed');
        this.isCollapsed = storedState === 'true';
      this.parametro = this.navParams.get('parametro');
      if(!MODO_DESCONECTADO){
        this.cambiarFechaArray.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
        this.porcentajeServicio.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
        this.cantidadImpresiones.push({nombre:"1", value:"1"},{nombre:"2", value:"2"},{nombre:"3", value:"3"},{nombre: "4", value:"4"})

        this.resetStore();

        this.storage.get('token').then((val) => {
            this.token = val
        });


        this.changeDate()
      }else {
        this.cambiarFechaArray.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
        this.porcentajeServicio.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
        this.cantidadImpresiones.push({nombre:"1", value:"1"},{nombre:"2", value:"2"},{nombre:"3", value:"3"},{nombre: "4", value:"4"})

        this.resetStore();

        this.storage.get('token').then((val) => {
            this.token = val
        });


        this.changeDate()
      }


          if(!MODO_DESCONECTADO){
            this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
            .then(async (val)=>{

              if(val){
                this.nombreCompaniaHeader = val['nombreCompania']
                this.nombreCargoHeader = val['nombreCargo']
                this.companiasId = val['companiasId']
                this.buscarClientes(this.companiasId);
                this.reiniciarValores()
                this.push.cualquiercosa(`select codigoFormaPago, nombreFormaPago,imagen from formasDePago where companiasId=${this.companiasId}`).subscribe((dataFormasDePago)=>{
                  let valuesFormaDePago = []
                  if(NUBE_AWS) {
                    valuesFormaDePago =  JSON.parse(dataFormasDePago['_body']).data[0]
                  } else {
                    valuesFormaDePago = dataFormasDePago[0]
                  }

                  this.formaPagoSeleccionada = 'O'
                  this.formaPagoSeleccionadaNombre = 'EFECTIVO'

                  for(let y=0;y<valuesFormaDePago.length;y++){
                      this.formasDePago.push({
                          nombre:valuesFormaDePago[y].nombreFormaPago,
                          valor:valuesFormaDePago[y].codigoFormaPago,
                          imagen:valuesFormaDePago[y].imagen
                       })
                  }
                })
                this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
                  if(NUBE_AWS) {
                    let valuesData = JSON.parse(data['_body']).data[0][0]
                    this.bluetooth = valuesData.bluetooth === 'B' ? true : false
                    this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
                    this.imagenImprimir = valuesData.imagen
                    this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
                    this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
                    this.devolverVenta = valuesData.devolverVenta === 'N' ? false : true;
                    this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
                    this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
                    this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
                    this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
                    this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
                    this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
                    this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
                    this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
                    this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
                    this.manejaDescuentoPorPorcentaje = valuesData.manejaDescuentoPorPorcentaje  === 'S' ? true : false;
                    this.controlaImpresorasEnRed = valuesData.controlaImpresorasEnRed  === 'S' ? true : false;
                    this.creaVentaDesdePedidosSalon = valuesData.creaVentaDesdePedidosSalon === 'S' ? true : false;
                    this.ip = valuesData.ip;

                  } else {
                    this.bluetooth = data[0][0].bluetooth === 'B' ? true : false
                    this.manejaImpresoPorDefecto = data[0][0].manejaImpresoPorDefecto == 0 ? false : true
                    this.imagenImprimir = data[0][0].imagen
                    this.manejaCajaDinamica = data[0][0].manejaCajaDinamica === 'N' ? false : true;
                    this.digitaCantidadEnVenta = data[0][0].digitaCantidadEnVenta === 'N' ? false : true;
                    this.devolverVenta = data[0][0].devolverVenta === 'N' ? false : true;
                    this.creaProductoRapidoDesdeCaja = data[0][0].creaProductoRapidoDesdeCaja === 'N' ? false : true;
                    this.manejaCodigoDeBarras = data[0][0].manejaCodigoDeBarras === 'N' ? false : true;
                    this.CheckImprimir = data[0][0].activoImprimir === 'N' ? false : true;
                    this.cantidadImpresionesEnCaja = data[0][0].cantidadImpresonesCaja.toString();
                    this.digitaDescripcion = data[0][0].digitaDescripcionEnCaja === 'N' ? false : true;
                    this.creaClienteDesdeCaja = data[0][0].creaClienteDesdeCaja === 'N' ? false : true;
                    this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
                    this.ip = data[0][0].ip;
                    this.creaVentaDesdePedidosSalon = data[0][0].creaVentaDesdePedidosSalon === 'S' ? true : false;
                  }


                  if(this.manejaImpresoPorDefecto){
                      if(this.bluetooth){
                          this.manejaImpresoPorDefecto = false
                      }
                  }
              },(error)=>{
                  console.log(error)
              })

                let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
                if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
                  this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
                  this.manejaPlanDePagosEnCuentasPorCobrar = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaPlanDePagosEnCuentasPorCobrar
                  let valuesData = buscarParametrosGeneralesStore.parametrosGenerales[0][0]
                  this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
                  this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto
                  this.imagenImprimir = valuesData.imagen
                  this.manejaCajaDinamica = valuesData.manejaCajaDinamica
                  this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta
                  this.devolverVenta = valuesData.devolverVenta
                  this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja
                  this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras
                  this.CheckImprimir = valuesData.activoImprimir
                  this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
                  this.digitaDescripcion = valuesData.digitaDescripcionEnCaja
                  this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja
                  this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja
                  this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar
                  this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos
                  this.manejaDescuentoPorPorcentaje = valuesData.manejaDescuentoPorPorcentaje;
                  this.controlaImpresorasEnRed = valuesData.controlaImpresorasEnRed
                  this.ip = valuesData.ip;
                } else {
                  let companiasId = val['companiasId'];
                  let usuariosId = val['usuariosId'];
                  let nombreUsuario = val['nombreUsuario'];
                  this.usuariosId = usuariosId
                  this.nombreUsuario = nombreUsuario
                  this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesRedux(companiasId, usuariosId, nombreUsuario)
                  buscarParametrosGeneralesStore = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
                  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
                    this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
                    this.manejaPlanDePagosEnCuentasPorCobrar = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaPlanDePagosEnCuentasPorCobrar
                    let valuesData = buscarParametrosGeneralesStore.parametrosGenerales[0][0]
                    this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth === 'B' ? true : false
                    this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
                    this.imagenImprimir = valuesData.imagen
                    this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
                    this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
                    this.devolverVenta = valuesData.devolverVenta == 'N' ? false : true;
                    this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
                    this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
                    this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
                    this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
                    this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
                    this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
                    this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
                    this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
                    this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
                    this.manejaDescuentoPorPorcentaje = valuesData.manejaDescuentoPorPorcentaje;
                    this.controlaImpresorasEnRed = valuesData.controlaImpresorasEnRed
                    this.ip = valuesData.ip;
                  }else {
                    this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
                      if(NUBE_AWS) {
                        let valuesData = JSON.parse(data['_body']).data[0][0]
                        this.bluetooth = valuesData.bluetooth === 'B' ? true : false
                        this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
                        this.imagenImprimir = valuesData.imagen
                        this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
                        this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
                        this.devolverVenta = valuesData.devolverVenta === 'N' ? false : true;
                        this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
                        this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
                        this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
                        this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
                        this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
                        this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
                        this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
                        this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
                        this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
                        this.manejaDescuentoPorPorcentaje = valuesData.manejaDescuentoPorPorcentaje;
                        this.controlaImpresorasEnRed = valuesData.controlaImpresorasEnRed
                        this.ip = valuesData.ip;
                      } else {
                        this.bluetooth = data[0][0].bluetooth === 'B' ? true : false
                        this.manejaImpresoPorDefecto = data[0][0].manejaImpresoPorDefecto == 0 ? false : true
                        this.imagenImprimir = data[0][0].imagen
                        this.manejaCajaDinamica = data[0][0].manejaCajaDinamica === 'N' ? false : true;
                        this.digitaCantidadEnVenta = data[0][0].digitaCantidadEnVenta === 'N' ? false : true;
                        this.devolverVenta = data[0][0].devolverVenta === 'N' ? false : true;
                        this.creaProductoRapidoDesdeCaja = data[0][0].creaProductoRapidoDesdeCaja === 'N' ? false : true;
                        this.manejaCodigoDeBarras = data[0][0].manejaCodigoDeBarras === 'N' ? false : true;
                        this.CheckImprimir = data[0][0].activoImprimir === 'N' ? false : true;
                        this.cantidadImpresionesEnCaja = data[0][0].cantidadImpresonesCaja.toString();
                        this.digitaDescripcion = data[0][0].digitaDescripcionEnCaja === 'N' ? false : true;
                        this.creaClienteDesdeCaja = data[0][0].creaClienteDesdeCaja === 'N' ? false : true;
                        this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
                        this.ip = data[0][0].ip;
                      }


                      if(this.manejaImpresoPorDefecto){
                          if(this.bluetooth){
                              this.manejaImpresoPorDefecto = false
                          }
                      }
                  },(error)=>{
                      console.log(error)
                  })

                  }

              }

              }
            })
          } else{

            this.buscarInformacionModoDesconectadoInicial()
        }


        if(this.manejaCodigoDeBarras){
          this.startTimerCodigoDeBarraUnico()
        }
        this.storage.get('imprimirmesasautomaticamente').then((val)=>{

            if(val){
              if(val == "S"){
                this.startTimer()
              }
            }
          })


         }



    startTimer(){
      // 30000
        this.timerVar = Observable.interval(15000).subscribe( x => {
            this.imprimirMeseroEmpty()
        })
    }

     startTimerCodigoDeBarraUnico(){
       if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
        this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
              this.cantidadafnprueba.nativeElement.focus();
              this.timerCodigoBarra.unsubscribe();
        })
      }
    }

    startTimerCodigoDeBarras(){
      if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
        this.cantidadafnprueba.nativeElement.focus();
      }
    }


    changeDate(){

     this.storage.get('fechaSistema').then((data)=>{

        if(data!==null){

          var f = new Date();
          let fechaSinFormato = f.getFullYear() + "-" +  (f.getMonth() +1) +  "-" + f.getDate()

          let fecha = this.formatearCadena(fechaSinFormato)


          let ano = fecha.substr(0,4)
          let mes = fecha.substr(5,2)
          let dia = fecha.substr(8,2)
          let anocomparar = data.substr(0,4)
          let mescomparar = data.substr(5,2)
          let diacomparar = data.substr(8,2)
          if(ano !== anocomparar || mes !== mescomparar || dia !== diacomparar ){

            this.cambiarFecha = true
          }
        }
     })

      }


      formatearCadena(cadena){
        let valorinicial = cadena.length
        let primero,segundo,ultimo
        primero = cadena.substr(0,4)
        segundo = cadena.substr(5,2)
        ultimo = cadena.substr(valorinicial - 2, valorinicial)
        if(valorinicial != 10){
          let recorrer = cadena.split('-')
          for(var i = 0; i < recorrer.length;i++) {
            if(i == 1 && recorrer[i].length == 1) {
              segundo = `0${recorrer[i]}`
            }
            if(i == 2 && recorrer[i].length == 1){
              ultimo = `0${recorrer[i]}`
            }
          }
        }
        return `${primero}-${segundo}-${ultimo}`
      }

      valoresSelectCambiarFecha(data:string){
        if(data['valor'] === "S"){
          this.cambiarCheckFecha("S")
        }else {
          this.cambiarCheckFecha("N")
        }
      }

      cambiarCheckFecha(valor:any){
          this.storage.set('fechaSistema',undefined)
          if(this.cambiarFecha){
            this.cambiarFecha = false
            this.mensajeToast('Fecha cambiada con exito')
          }

      }


    async ionViewDidLoad() {
      this.storageCreditos = await this.getDatosCreditos();

      if (this.storageCreditos) {
        console.log('Datos obtenidos:', this.storageCreditos);
      } else {
        console.log('No hay datos almacenados');
      }
      let datosCreditos = localStorage.getItem('datosCreditos')
      let datosCredito = JSON.parse(datosCreditos)
      if(datosCredito && datosCredito["manejaInteresesEnCuentasDeCobro"]) {
        this.manejaInteresesEnCuentasDeCobro = datosCredito["manejaInteresesEnCuentasDeCobro"].seleccion === 'S' ? true : false
      }

      if(datosCredito && datosCredito["visualizaDiaDePago"]) {
        this.visualizaDiaDePago = datosCredito["visualizaDiaDePago"].seleccion === 'S' ? true : false
      }

      if(datosCredito && datosCredito["visualizaExonerarInteresPrimeraCuota"]) {
        this.visualizaExonerarInteresPrimeraCuota = datosCredito["visualizaExonerarInteresPrimeraCuota"].seleccion === 'S' ? true : false
      }

      if(datosCredito && datosCredito["visualizaNumeroDeCuotasExoneradas"]) {
        this.visualizaNumeroDeCuotasExoneradas = datosCredito["visualizaNumeroDeCuotasExoneradas"].seleccion === 'S' ? true : false
      }

      if (datosCredito && datosCredito["visualizaEnSimulacion"]) {
        datosCredito["visualizaEnSimulacion"].opciones.forEach(opcion => {
          const key = opcion.key;
          const value = opcion.value[0].visualiza === 'S'; // Asumiendo que solo necesitas el primer valor

            switch (key) {
              case 'interesesCorrientes':
                this.interesesCorrientesVisualizarPlanDePagos = value;
                break;
              case 'interesesMora':
                this.interesesMoraVisualizarPlanDePagos = value;
                break;
              case 'capitalAtrasado':
                this.capitalAtrasadoVisualizarPlanDePagos = value;
                break;
              case 'costosAdicionales':
                this.costosAdicionalesVisualizarPlanDePagos = value;
                break;
              case 'fecha':
                this.fechaVisualizarPlanDePagos = value;
                break;
              case 'montoDeLaCuota':
                  this.montoDeLaCuota = value;
                break;
              case 'montoDeLaCuotaConCostosEintereses':
                  this.montoDeLaCuotaConCostosEintereses = value;
                break;
              case 'cuantoRestaEnLaCuota':
                  this.cuantoRestaEnLaCuota = value;
                break;
              default:
                break;
            }
          });
        }


      let datosGenerales = localStorage.getItem('datosGenerales')
      let datosGeneralesJSON = JSON.parse(datosGenerales)
      if(datosGeneralesJSON && datosGeneralesJSON["sobreGiroEnLosProductos"]) {
        this.sobreGiroEnLosProductos = datosGeneralesJSON["sobreGiroEnLosProductos"].seleccion === 'N' ? true : false
      }
      if(datosGeneralesJSON && datosGeneralesJSON["clienteObligatorioEnCaja"]) {
        this.clienteObligatorioEnCaja = datosGeneralesJSON["clienteObligatorioEnCaja"].seleccion === 'S' ? true : false
      }
      if(datosGeneralesJSON && datosGeneralesJSON["personalizarVenta"]) {
        this.personalizarVenta = datosGeneralesJSON["personalizarVenta"].seleccion === 'S' ? true : false
      }

      if(datosGeneralesJSON && datosGeneralesJSON["agrupaProductosEnCaja"]) {
        this.agrupaProductosEnCaja = datosGeneralesJSON["agrupaProductosEnCaja"].seleccion === 'S' ? true : false
      }

      if(datosGeneralesJSON && datosGeneralesJSON["manejaPaginacionEnTendero"]) {
        this.manejaPaginacionEnTendero = datosGeneralesJSON["manejaPaginacionEnTendero"].seleccion === 'S' ? true : false
      }

      if(datosGeneralesJSON && datosGeneralesJSON["cambiarNombreYCambiarValorVentaAlProducto"]) {
        this.cambiarNombreYCambiarValorVentaAlProducto = datosGeneralesJSON["cambiarNombreYCambiarValorVentaAlProducto"].seleccion === 'S' ? true : false
      }

      if(datosGeneralesJSON && datosGeneralesJSON["impuestoPorDefectoAlCambiarNombre"]) {
        this.impuestoPorDefectoAlCambiarNombre = datosGeneralesJSON["impuestoPorDefectoAlCambiarNombre"].seleccion
      }

              // Verificar si debe activarse la lógica del socket
      if (datosGeneralesJSON && datosGeneralesJSON["pesaLosProductosEnTendero"]) {
        this.pesaLosProductosEnTendero = datosGeneralesJSON["pesaLosProductosEnTendero"].seleccion === 'S';
        console.log('this.pesaLosProductosEnTendero',this.pesaLosProductosEnTendero)
        if (this.pesaLosProductosEnTendero) {
          this.iniciarSocket(); // Inicia el socket solo si pesaLosProductosEnTendero es true
        }
      }

      if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
        this.cantidadafnprueba.nativeElement.focus();
      }
        if(!MODO_DESCONECTADO){
            this.reiniciarValores()
            // this.productosAgrupados()
        }else{
            this.elect()
        }
        if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
          this.cantidadafnprueba.nativeElement.focus();
        }
    }

   async buscarInformacionModoDesconectadoInicial() {
      // let formasDePagoDesconect = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-formas-de-pago')
      let resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoFormasDePago();

      let a = resultado['_body'];
      let b = JSON.parse(a);
      let resultadoFinal = JSON.parse(b.data);
      let res:any = []
      // Validar si no existe información
      if (!resultadoFinal || resultadoFinal.length === 0) {
        this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
      } else {
        res = resultadoFinal
      }

      let responseFormasDePago = res
      if(responseFormasDePago.length> 0) {
        this.formaPagoSeleccionada = 'O'
        this.formaPagoSeleccionadaNombre = 'EFECTIVO'

        for(let y=0;y<responseFormasDePago.length;y++){
            this.formasDePago.push({
                nombre:responseFormasDePago[y].nombreFormaPago,
                valor:responseFormasDePago[y].codigoFormaPago,
                imagen:responseFormasDePago[y].imagen
             })
        }
      }

      let entr =  await this.apiDesconect.getBuscarInformacionMododesconectadoParametrosGenerales();

      let d = entr['_body'];
      let e = JSON.parse(d);
      let resultadoFinalParametros = JSON.parse(e.data);
      let resParametros:any = []
      // Validar si no existe información
      if (!resultadoFinal || resultadoFinal.length === 0) {
        this.utils.mensajeMuestro('Parametros generales','Los datos no se recuperaron...','warning')
      } else {
        resParametros = resultadoFinalParametros
      }

      //let entr = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-parametros-generales')
      let dataDesconect = resParametros
      if(dataDesconect.length>0){
        let valuesData = dataDesconect[0]
        this.bluetooth = valuesData.bluetooth === 'B' ? true : false
        this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
        this.imagenImprimir = valuesData.imagen
        this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
        this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
        this.devolverVenta = valuesData.devolverVenta === 'N' ? false : true;
        this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
        this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
        this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
        this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
        this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
        this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
        this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
        this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
        this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
        this.manejaDescuentoPorPorcentaje = valuesData.manejaDescuentoPorPorcentaje;
        this.controlaImpresorasEnRed = valuesData.controlaImpresorasEnRed
      }
    }

    reiniciarValores(){
        this.buscarParametrosGenerales()
        this.buscarGruposProductosParaCaja()
        this.buscarDatosListaMuestra()
        this.buscarDenominaciones()
        this.buscarVentasdiariasCaja()
        this.limpiarImpresion()
        this.limpiarPorcentajeServicio()
        if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
          this.cantidadafnprueba.nativeElement.focus();
        }
        this.CheckDescuento = false
        this.formasDePagoGeneral =[]
    }



    ionViewLoaded() {


   }

   async llenarGruposProductosDesconect(){

      let resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoListagruposproductosCaja();

      let a = resultado['_body'];
      let b = JSON.parse(a);
      let resultadoFinal = JSON.parse(b.data);
      let res:any = []
      // Validar si no existe información
      if (!resultadoFinal || resultadoFinal.length === 0) {
        this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
      } else {
        res = resultadoFinal
        this.listaGrupos = res
      }
        // let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-listagruposproductos-caja',RUTA_MODO_DESCONECTADO)

        // if(!resultado){
        //   }else {
        //         this.listaGrupos = resultado
        //     }
    }


    async elect(){
        this.CheckCredito = true
        this.cambiarCheckCredito()

        // let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-listagruposproductos-caja',RUTA_MODO_DESCONECTADO)


        // if(!resultado){
        //   }else {
        //         this.listaGruposProductos = resultado
        //     }

        let resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoListagruposproductosCaja();

        let a = resultado['_body'];
        let b = JSON.parse(a);
        let resultadoFinal = JSON.parse(b.data);
        let res:any = []
        // Validar si no existe información
        if (!resultadoFinal || resultadoFinal.length === 0) {
          this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
        } else {
          res = resultadoFinal
          this.listaGruposProductos = res
        }

      //  let resultadolistaProductos = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-caja',RUTA_MODO_DESCONECTADO)

      //   if(!resultadolistaProductos){
      //   }else {
      //       // this.listaProductos =JSON.parse(resultadolistaProductos)
      //       this.listaProductos = resultadolistaProductos
      //   }

        resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoProductosCaja();

        a = resultado['_body'];
        b = JSON.parse(a);
        resultadoFinal = JSON.parse(b.data);

        // Validar si no existe información
        if (!resultadoFinal || resultadoFinal.length === 0) {
          this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
        } else {
          res = resultadoFinal
          this.listaProductos = res
        }


        // let clienteGenerico = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-clienteGenerico',RUTA_MODO_DESCONECTADO)
        // if(!clienteGenerico){
        // }else {
        //     this.clienteGenerico =JSON.parse(clienteGenerico)
        // }

        resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoClienteGenerico();

        a = resultado['_body'];
        b = JSON.parse(a);
        resultadoFinal = JSON.parse(b.data);

        // Validar si no existe información
        if (!resultadoFinal || resultadoFinal.length === 0) {
          this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
        } else {
          res = resultadoFinal
          this.clienteGenerico = res
        }

        resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoMesas();

        a = resultado['_body'];
        b = JSON.parse(a);
        resultadoFinal = JSON.parse(b.data);

        // Validar si no existe información
        if (!resultadoFinal || resultadoFinal.length === 0) {
          this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
        } else {
          res = resultadoFinal
          this.listaMuestra = res
        }

        // let denominaciones = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-denominaciones',RUTA_MODO_DESCONECTADO)

        // if(!denominaciones){
        // }else {
        //     this.listaDenominaciones =JSON.parse(denominaciones)
        // }
        resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoDenominaciones();

        a = resultado['_body'];
        b = JSON.parse(a);
        resultadoFinal = JSON.parse(b.data);

        // Validar si no existe información
        if (!resultadoFinal || resultadoFinal.length === 0) {
          this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
        } else {
          res = resultadoFinal
          this.listaDenominaciones = res
          //this.listaDenominaciones =this.listaDenominaciones.slice().reverse();
        }


      }

    actualizarrecibo(datos:any){
        let valor = datos.valorDenominacion
        let nuevoValor = 0
        let nuevoValorBillete = 0
        let result =  0
        let val = this.price.toString();
        try {
            nuevoValor = Number(val.replace(/,/g, ''))
        } catch (e) {
            nuevoValor = 0
        }
        let val2 = valor.toString();
        try {
            nuevoValorBillete = Number(val2.replace(/,/g, ''))
        } catch (e) {
            nuevoValorBillete = 0
        }
        result = nuevoValor + nuevoValorBillete
        if(isNaN(result)){
            result = nuevoValorBillete
        }
        this.price = result
        this.format(this.price)

    }
    buscarDenominaciones(){
      this.storage.get('companiasId').then((val)=>{

        this.servicioDenominaciones.buscar(val)
        .subscribe((res)=> {
        //   if(this.platform.is('android') || this.platform.is('ios')){

        //     let listaDenominacionesTemporal = []
        //     let resDenominacionesData = []
        //     if(NUBE_AWS){
        //       resDenominacionesData = JSON.parse(res['_body']).data[0]
        //     } else {
        //       resDenominacionesData = res
        //     }

        //     for(let y=0;y<resDenominacionesData.length;y++){
        //         let imagenNueva =resDenominacionesData[y].imagenLocal
        //         imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace(`file:///C:/bd/imagenes/`,'assets/imgs/')

        //         listaDenominacionesTemporal.push({
        //             denominacionesId: resDenominacionesData[y].denominacionesId,
        //             codigoDenominacion: resDenominacionesData[y].codigoDenominacion,
        //             nombreDenominacion: resDenominacionesData[y].nombreDenominacion,
        //             valorDenominacion: resDenominacionesData[y].valorDenominacion,
        //             tipoDenominacion: resDenominacionesData[y].tipoDenominacion,
        //             imagen: resDenominacionesData[y].imagen,
        //             imagenLocal:imagenNueva
        //         })
        //     }
        //     this.listaDenominaciones = listaDenominacionesTemporal

        // }else{

            let listaDenominacionesTemporal = []
            let resDenominacionesData = []
            if(NUBE_AWS){
              resDenominacionesData = res.data[0]
            } else {
              resDenominacionesData = res
            }

            for(let y=0;y<resDenominacionesData.length;y++){
                let imagenNueva =resDenominacionesData[y].imagenLocal

                listaDenominacionesTemporal.push({
                    denominacionesId: resDenominacionesData[y].denominacionesId,
                    codigoDenominacion: resDenominacionesData[y].codigoDenominacion,
                    nombreDenominacion: resDenominacionesData[y].nombreDenominacion,
                    valorDenominacion: resDenominacionesData[y].valorDenominacion,
                    tipoDenominacion: resDenominacionesData[y].tipoDenominacion,
                    imagen: resDenominacionesData[y].imagen,
                    imagenLocal:resDenominacionesData[y].imagenLocal
                })
            }
            this.listaDenominaciones = listaDenominacionesTemporal

        // }


        })
      })
      }

    buscarDatosListaMuestra(){
        this.storage.get('companiasId').then((val)=>{
        this.servicioMesas.buscarMesasPorCompaniaUnico(val)
        .debounceTime(2)
        .subscribe(
          rest => {
            let res = !NUBE_AWS ? rest[0] : rest.data[0]
            this.listaMuestra = []

            for(var k = 0; k < res.length;k++){

                this.listaMuestra.push({
                    'left':res[k].leftt,
                    'width':res[k].width,
                    'top':res[k].topp,
                    'height':res[k].height,
                    'id': res[k].id,
                    'color': res[k].color,
                    'Uuid': res[k].Uuid,
                    'name' : "dataDynamicCrud",
                    'queHago' : "I",
                    'nombreTabla' : "mesas"
                  })



            }
          },
          error => {
            console.log(error)
          }
        )
       })

      }

      sacarMensajeBoton(id:any,queHago:string, item:any){
       this.traerDatosGuardados(id,item)
      }


    traerDatosGuardados(id:any,itemTurno:any){
        let mesa = id
        this.storage.get('companiasId').then(async (val) => {
            this.cancelarVenta()
            this.listaProductosSeleccionados = []
            this.valorTotalImpuestos = 0
            this.valorTotalVenta = 0
            this.valorTotalProductos = 0
            this.valorTotalDevolver = 0
            this.valorTotalVenta = 0
            this.descripcionVenta = ""

            if(MODO_DESCONECTADO){

                 let resultado =  await this.apiDesconect.getbuscarInformacionMododesconectadoMesasComandas();

                 let a = resultado['_body'];
                 let b = JSON.parse(a);
                 let resultadoFinal = JSON.parse(b.data);
                 let res:any = []
                 // Validar si no existe información
                 if (!resultadoFinal || resultadoFinal.length === 0) {
                   this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
                 } else {
                   res = resultadoFinal
                   let result = res
                   this.manipularMesas(result, mesa, id);
                 }
                // let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-mesas-comandas',mesa)

                // let result = JSON.parse(resultado)

                // if(result.length>0){
                //     this.manipularMesas(result, mesa, id);
                // }
              return false
            }
            this.setProductosSelect(this.listaProductosSeleccionados);
            if(itemTurno.Uuid === 'Turno' || itemTurno.Uuid === 'Domicilio') {
              this.traerDatosTurnos(itemTurno.id,val)
              this.turnoPersonalizado = itemTurno.id
            } else {
              this.servicio.buscarComandasMesero(mesa,val)
              .subscribe((val)=>{

                if(NUBE_AWS) {
                  val =  JSON.parse(val['_body']).data[0]
                }
                this.manipularMesas(val, mesa, id);
              }
            )
        }

      })

      }

      traerDatosTurnos(turnoId,companiasId) {
        let turno = turnoId
        this.servicio.buscarComandasturnoPorCompania(turno,companiasId)
        .subscribe((val: any)=>{
          this.listaProductosSeleccionados = []
          let entrarDatos = false;
          let dataJson = NUBE_AWS ? JSON.parse(val['_body']) : val
          let dataResponse = NUBE_AWS ? dataJson.data : val
          val = dataResponse
          if(val.length>0 && val[0].length>0) {
            this.realizandoUnaVenta = true

            for(var k = 0;k < val[0].length;k++){
                this.listaProductosSeleccionados.push(val[0][k])
                this.valorTotalImpuestos += Number(val[0][k].valorImpuesto)
                this.valorTotalVenta += Number(val[0][k].valorTotalVenta)
                this.valorTotalProductos+= Number(val[0][k].valorProducto)
                this.valorTotalDevolver += Number(val[0][k].valorTotalVenta)
                this.listaProductosSeleccionados[k]['valorImpuesto'] += k == 0 ?  0 : Number(val[0][k]['valorImpuestosIndividual'])
                this.listaProductosSeleccionados[k]['valorProducto'] += k == 0 ?  0 : Number(val[0][k]['valorProductoIndividual'])
                this.listaProductosSeleccionados[k]['domicilio'] = val[0][k].domicilio
                this.listaProductosSeleccionados[k]['formaDePago'] = val[0][k].formaDePago
                this.listaProductosSeleccionados[k]['incluirServicio'] = val[0][k].incluirServicio
                this.datosAdicionales = {
                  valorTotalVenta: this.valorTotalVenta,
                  totalPagado: this.valorTotalDevolver,
                  valorTotalDevolver: 0,
                  usuariosId: val[0][k].usuariosId,
                  companiasId: val[0][k].companiasId,
                  clientesId: val[0][k].clientesId,
                  turno:val[0][k].turno,
                  comandasId: val[0][k].comandasId
              };
          }
          this.setProductosSelect(this.listaProductosSeleccionados);
          this.valormesa = turno;
          entrarDatos = true
          }
        })
  }

    private manipularMesas(val: any, mesa: any, id: any) {
        this.cancelarVenta();
        this.listaProductosSeleccionados = [];
        this.valorTotalImpuestos = 0;
        this.valorTotalVenta = 0;
        this.valorTotalProductos = 0;
        this.valorTotalDevolver = 0;
        this.valorTotalVenta = 0;
        this.descripcionVenta = "";
        if (val.length > 0) {
            for (var k = 0; k < val.length; k++) {
                if (mesa == val[k].numeromesa) {
                    this.listaProductosSeleccionados.push(val[k]);
                    this.valorTotalImpuestos += Number(val[k].valorImpuesto);
                    this.valorTotalVenta += Number(val[k].valorTotalVenta);
                    this.valorTotalProductos += Number(val[k].valorProducto);
                    this.clienteId = val[k].clientesIds;
                    this.valormesa = val[k].numeromesa;
                    this.valorImpuestosIndividual += k == 0 ? 0 : Number(val[k].valorImpuestosIndividual);
                    this.valorProductoIndividual += k == 0 ? 0 : Number(val[k].valorProductoIndividual);
                    this.datosAdicionales = {
                        valorTotalVenta: this.valorTotalVenta,
                        totalPagado: 0,
                        valorTotalDevolver: 0,
                        usuariosId: val[k].usuariosId,
                        companiasId: val[k].companiasId,
                        clientesId: val[k].clientesId
                    };
                }
            }
            this.setProductosSelect(this.listaProductosSeleccionados);
            this.realizandoUnaVenta = true;
        }
        else {
            this.cancelarVenta();
            this.realizandoUnaVenta = false;
            // this.mostrarMensajes(`la mesa # ${id} no tiene asignado una comanda`, 'Verifique');
            this.mensajeToast(`la mesa # ${id} no tiene asignado una comanda`)
        }
    }

    pagarmesas(formasDePagoGeneral:any=[]){

        // hacer validaciones para finalizar la venta

        this.datosAdicionales['totalPagado'] = this.valorTotalDevolver
        let valorTotalVentaValidar: number = Number(this.valorTotalDevolver) - Number(this.valorTotalVenta)
        if( valorTotalVentaValidar < 0 ){
        // || isNaN(this.valorTotalDevolver) || (this.datosAdicionales['totalPagado']===0) ){
        // this.mostrarMensajeDeError('Valor a devolver no valido!')
            this.mensajeToast(`Valor a devolver no valido!`)
            return
        } else if ( this.valorTotalVenta < 0){
            this.mensajeToast(`Valor total venta no valido!`)
            return
        }

        this.getMultiple(['usuariosId','companiasId'])
        .then( async (res) => {

            // mostrar cargando
            this.loader = this.loadingCtrl.create({});
            this.loader.present();

            let busquedaGestion = 'G'
            let valoreslistaProductosSeleccionados = []
            if(GESTION_PEDIDOS_SALON && !this.formasDePagoSeGenero){
                valoreslistaProductosSeleccionados  = this.listaProductosSeleccionados.filter(e => e.estado.indexOf(busquedaGestion) != -1)
                if(valoreslistaProductosSeleccionados.length==0){
                    this.comandaNoValida()
                    return false
                }
            }else{
                valoreslistaProductosSeleccionados = this.listaProductosSeleccionados[0]
            }

            let codigo = valoreslistaProductosSeleccionados['codigo']

           if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
            // envia el cliente que este seleccionado
            this.datosAdicionales['clientesId'] = this.clienteId[0]['value']
            }
            if(this.formaPagoSeleccionada == 'C' && this.datosAdicionales['clientesId'] == 0){
                this.mensajeToast(`Para generar una cuenta por cobrar debe asignar un cliente`)
                if (this.loader) {
                  this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                }
                return
            }
            if(!this.CheckCredito && this.datosAdicionales['clientesId'] == 0){
                if(this.clienteObligatorioEnCaja) {
                  this.utils.mensajeMuestro('Advertencia','Debe seleccionar un cliente','warning')
                  if (this.loader) {
                    this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                  }
                  return
                }
                this.datosAdicionales['clientesId'] = 1
            }

            this.datosAdicionales['tipoVenta'] = this.formaPagoSeleccionada
            let cantidadActual = this.listaProductosSeleccionados.length
            this.datosAdicionales['descripcion'] = this.descripcionVenta,
            this.datosAdicionales['servicio'] = this.porcentajeServicioValorPedidosSalon == 'S' ? this.porcentajeServicioValorPedidosSalon : this.porcentajeServicioValor['valor']
            if(MODO_DESCONECTADO){
                let listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(this.listaProductosSeleccionados)

                this.servicio.guardarVentasdiariasModoDesconectado(listaProductosSeleccionadosNuevosValores, this.datosAdicionales)
                .then( async (data)=>{
                  if (this.loader) {
                    this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                  }
                this.mostrarMensajeGeneral(data)
                }).catch((error)=>{
                  if (this.loader) {
                    this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                  }
                    console.log(error)
                })
                this.imprimirMesero(listaProductosSeleccionadosNuevosValores[0].codigo)
                if (this.loader) {
                  this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                }
                this.limpiarImpresion()
                this.elect()

                let resultado =  await this.apiDesconect.getBuscarInformacionMododesconectadoMesasDelete();

                let a = resultado['_body'];
                let b = JSON.parse(a);
                let resultadoFinal = JSON.parse(b.data);
                let res:any = []
                // Validar si no existe información
                if (!resultadoFinal || resultadoFinal.length === 0) {
                  this.utils.mensajeMuestro('Mesas','Los datos no se recuperaron...','warning')
                } else {
                  res = resultadoFinal
                  this.listaMuestra  = res
                }
                // let mesas = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-mesas-delete',RUTA_MODO_DESCONECTADO)

                // if(!mesas){

                // }else {

                //     this.listaMuestra =JSON.parse(mesas)
                // }

             return false
            }


            this.servicio.buscarComandasFacturaPorCompania(codigo)
            .subscribe(async (data)=>{
                if(NUBE_AWS) {
                  data = JSON.parse(data['_body']).data[0]
                }
                let cantidadReal = data.length
                let esUnTurnoGuardado = false
                if((this.listaProductosSeleccionados.length>0 && this.listaProductosSeleccionados[0]['esUnTurnoGuardado']=== "S")){
                  this.datosAdicionales['clientesId'] = this.listaProductosSeleccionados[0]['clientesId']
                  esUnTurnoGuardado = true
                }
                if(cantidadReal == cantidadActual || esUnTurnoGuardado === true || this.formasDePagoSeGenero){
                    let listaProductosSeleccionadosNuevosValores = []
                    // let refactorizarPedidosSalon = this.refactorizarPedidosSalon
                    // if(refactorizarPedidosSalon) {
                    //   listaProductosSeleccionadosNuevosValores = this.listaProductosSeleccionados
                    // } else {
                    //   listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(this.listaProductosSeleccionados)
                    // }
                    listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(this.listaProductosSeleccionados)

                    this.storage.get('fechaSistema').then(async (val) => {

                        if(val!=undefined){
                            this.datosAdicionales['fechaVenta'] = val
                        }
                        let elaboradosContenido = ''
                        let turno = undefined
                        let comandasId = undefined
                        if(this.datosAdicionales.turno != undefined && this.datosAdicionales.turno > 0) {
                          turno = this.datosAdicionales.turno
                          comandasId =  this.datosAdicionales.comandasId
                        }

                        this.datosAdicionales['codigo'] = listaProductosSeleccionadosNuevosValores[0].codigo

                        let usuarioIngreso = await this.storage.get('usuariosId');
                        let usuarioId = usuarioIngreso;
                        if(usuarioId) {
                          this.datosAdicionales['usuariosId'] = usuarioId
                        }
                        if(this.CheckDescuento) {
                          this.inputValueDescuento = await this.presentPrompt();

                          if (this.inputValueDescuento !== null) {
                            if(this.inputValueDescuento < 0 || this.inputValueDescuento > 100) {
                              this.utils.mensajeMuestro('Advertencia','El % de descuento no es valido','warning')
                              return
                            }
                            this.listaProductosSeleccionados = await this.recalcularValorDeLosProductosSeleccionados(this.listaProductosSeleccionados,this.inputValueDescuento)
                            this.setProductosSelect(this.listaProductosSeleccionados);
                          } else {
                            this.utils.mensajeMuestro('Advertencia','El usuario canceló la venta','warning')
                            return
                          }
                          this.datosAdicionales['porcentajeDescuento'] = this.listaProductosSeleccionados[0].porcentajeDescuento
                        }
                        let metodosDePago:any = '{}'
                          if(formasDePagoGeneral.length>0){
                              formasDePagoGeneral = formasDePagoGeneral.map((forma:any) => ({
                                codigoFormaPago: forma.codigoFormaPago,
                                valorFormaPago: forma.valor,
                                persona: forma.persona,
                                formaPago: forma.nombreFormaPago, // renombrar nombreFormaPago a formaPago
                                imagen: forma.imagen,
                                formattedValor: forma.formattedValor
                                }));

                              metodosDePago = formasDePagoGeneral
                              this.datosAdicionales['formasDePago'] = JSON.stringify(metodosDePago)
                          }
                        this.servicio.guardarVenta(listaProductosSeleccionadosNuevosValores, this.datosAdicionales,elaboradosContenido,'','',metodosDePago).subscribe(
                            resVenta => {
                              if (this.loader) {
                                this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                              }
                                    for(var k =0;k < listaProductosSeleccionadosNuevosValores.length;k++){
                                        if(this.valormesa == listaProductosSeleccionadosNuevosValores[k].numeromesa || this.valormesa === Number(listaProductosSeleccionadosNuevosValores[k].turno )) {
                                            let datosComanda = {
                                                comandasId: listaProductosSeleccionadosNuevosValores[k].comandasId,
                                                estado: 'F',
                                                imagen: null,
                                                color: '#006400',
                                                queHago: "A",
                                                nombreTabla: "comandas",
                                                name: "dataDynamicCrud"

                                              }
                                              let consecutivo = JSON.parse(resVenta['_body']).data[0]

                                              let numeroFactura: string = ''; // Variable donde se guardará el número de factura
                                              consecutivo.forEach(item => {
                                              if (item.reciboCaja.includes("Factura de Venta Nro:")) {
                                                // Extraer el número de factura
                                                const regex = /Factura de Venta Nro: (\d+)/;
                                                const match = item.reciboCaja.match(regex);
                                                if (match) {
                                                    numeroFactura = match[1]; // El número de factura se guarda en la variable
                                                    datosComanda['consecutivo'] = numeroFactura
                                                }
                                            }})
                                           this.servicio.actualizarComandas(datosComanda)
                                              .subscribe((data)=>{
                                                let datacomandanueva = datosComanda
                                                this.storage.get('companiasId').then((val) => {
                                                this.servicio.actualizarSeguimientoReserva(val,datacomandanueva.comandasId, numeroFactura)
                                              .subscribe((data)=>{
                                              })})

                                                this.buscarDatosListaMuestra()
                                                this.buscarGruposProductosParaCaja()
                                              },(error)=>{
                                                this.buscarDatosListaMuestra()
                                                this.buscarGruposProductosParaCaja()
                                                  console.log(error)
                                              })
                                        } else {
                                          if(this.valormesa == turno && listaProductosSeleccionadosNuevosValores[k].comandasId === comandasId){
                                                let consecutivoArray = JSON.parse(resVenta['_body']).data[0]
                                                let numeroFactura: string = ''; // Variable donde se guardará el número de factura
                                                consecutivoArray.forEach(item => {
                                                if (item.reciboCaja.includes("Factura de Venta Nro:")) {
                                                  // Extraer el número de factura
                                                  const regex = /Factura de Venta Nro: (\d+)/;
                                                  const match = item.reciboCaja.match(regex);
                                                  if (match) {
                                                      numeroFactura = match[1]; // El número de factura se guarda en la variable
                                                  }
                                              }})
                                              let companiasId = this.datosAdicionales.companiasId
                                              let turnonuevo = turno
                                              let numeroFacturanueva = numeroFactura
                                              this.servicio.ActualizarComandasPorTurno(this.datosAdicionales.companiasId,turno, numeroFactura)
                                              .subscribe((data)=>{
                                                this.servicio.actualizarReservasPorTurno(companiasId,turnonuevo, numeroFacturanueva)
                                                .subscribe((data)=>{
                                                      console.log('reserva actualizada')
                                                },(error)=>{
                                                  this.buscarDatosListaMuestra()
                                                  this.buscarGruposProductosParaCaja()
                                                    console.log(error)
                                                })
                                                this.buscarDatosListaMuestra()
                                                this.buscarGruposProductosParaCaja()
                                              },(error)=>{
                                                this.buscarDatosListaMuestra()
                                                this.buscarGruposProductosParaCaja()
                                                  console.log(error)
                                              })
                                        }
                                        }
                                    }

                                this.cancelarVenta()
                                this.buscarVentasdiariasCaja()
                                this.mostrarMensajeGeneral(resVenta.json())
                                this.limpiarImpresion()
                                this.buscarDatosListaMuestra()
                                this.buscarVentasdiariasCaja()
                                this.buscarGruposProductosParaCaja()
                                if(this.manejaCodigoDeBarras && this.cantidadafnprueba) {
                                  this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
                                    this.cantidadafnprueba.nativeElement.focus();
                                    this.timerCodigoBarra.unsubscribe();
                                  })
                                }
                            },
                            errVenta => {

                              if (this.loader) {
                                this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                              }
                                this.cancelarVenta()
                                this.limpiarImpresion()
                                this.buscarDatosListaMuestra()
                                this.buscarVentasdiariasCaja()
                                this.buscarGruposProductosParaCaja()
                                // this.mostrarMensajeDeError('Error Guardando Venta')
                                this.mensajeToast(`Error Guardando Venta`)
                                if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
                                  this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
                                    this.cantidadafnprueba.nativeElement.focus();
                                    this.timerCodigoBarra.unsubscribe();
                                  })
                                }
                            }
                        )
                    });
                }else{
                  this.comandaNoValida()
                  if (this.loader) {
                    this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                  }
                }
            },(error)=> {
              console.log(error)
              if (this.loader) {
                this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
              }
            })

        })
        if (this.loader) {
          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
        }
    }

    refactorizarValoresMesas(data:any){
        this.listaProductosSeleccionados = []
        for(let i=0;i <data.length;i++){
            this.listaProductosSeleccionados.push({
                productosId:Number(data[i].productosId),
                tipoProducto:data[i].tipoProducto,
                cantidad:Number(data[i].cantidad),
                valorProducto: data[i].valorProductoIndividual !== undefined && data[i].valorProductoIndividual > 0 ? Number(data[i].valorProductoIndividual) : Number(data[i].valorVenta),
                valorImpuesto: data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
                ubicacionesPorSalonesId:data[i].ubicacionesPorSalonesId,
                valorTotalImpuestos : data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
                valorTotalVenta : Number(data[i].valorTotalVenta),
                valorTotalProductos :  data[i].valorProductoIndividual == undefined ? Number(data[i].valorProducto) : Number(data[i].valorProductoIndividual),
                valorTotalDevolver: Number(data[i].valorTotalVenta),
                clienteId: data[i].clientesId,
                valormesa: data[i].numeromesa,
                comandasId: Number(data[i].comandasId),
                numeromesa:data[i].numeromesa,
                codigo:data[i].codigo,
                valorImpuestoCalculo: data[i].valorImpuestoCalculo
            });

        }
        this.setProductosSelect(this.listaProductosSeleccionados);
        return this.listaProductosSeleccionados
    }

    comandaNoValida(){
      if (this.loader) {
        this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
      }
        this.alertControllers.create({
            title:'Advertencia',
            message: 'No puede guardar la venta por que existen productos que no estan gestionados',
            buttons: ['ok']
    }).present()
    }

    mostrarMensajes(mensaje,advertencia) {
        let alert = this.alertControllers.create({
          title: advertencia,
          subTitle: mensaje,
          buttons: ['Ok']
        });
        alert.present()
      }

    DECIMAL_SEPARATOR  = '.'
    GROUP_SEPARATOR = ','

    format(valString) {
        if (!valString) {
            this.valorTotalDevolver = 0
            return '';
        }
        let val = valString.toString();
        try {
            this.valorTotalDevolver = Number(val.replace(/,/g, ''))
        } catch (e) {
            this.valorTotalDevolver = 0
        }

        const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
        return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
    };

    unFormat(val) {
        if (!val) {
            return '';
        }
        val = val.replace(/^0+/, '');

        if (this.GROUP_SEPARATOR === ',') {
            return val.replace(/,/g, '');
        } else {
            return val.replace(/\./g, '');
        }
    };

    seleccionarTodo(ev) {
        if(ev && ev['target'] && ev.target['select']){
            ev.target.select();
        }
    }

    async buscarParametrosGenerales () {
        let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
        if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
          this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
          this.manejaPlanDePagosEnCuentasPorCobrar = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaPlanDePagosEnCuentasPorCobrar
        } else {
          this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesRedux(this.companiasId, this.usuariosId, this.nombreUsuario)
                  buscarParametrosGeneralesStore = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
                  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
                    this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
                    this.manejaPlanDePagosEnCuentasPorCobrar = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaPlanDePagosEnCuentasPorCobrar
                  }
        // buscar el id de la compania en la que esta logueado
        // this.storage.get('companiasId').then((val) => {
        //   this.servicio.buscarParametrosGenerales(val).subscribe(
        //       (res: any) => {
        //           if(NUBE_AWS) {
        //             this.manejaImpresoPorDefecto = JSON.parse(res['_body']).data[0][0].manejaImpresoPorDefecto
        //             this.manejaPlanDePagosEnCuentasPorCobrar = JSON.parse(res['_body']).data[0][0].manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;

        //           } else {
        //             this.manejaImpresoPorDefecto = res[0].manejaImpresoPorDefecto
        //           }
        //       })
        //   })
        }
    }


    async buscarGruposProductosParaCaja () {
      if(this.manejaPaginacionEnTendero || this.agrupaProductosEnCaja) {
        let companiasId = await localStorage.getItem('companiasId')
        let resultado = await this.servicio.buscarGruposProductosParaCajaVertical(companiasId)
        let resultadoJson = JSON.parse(resultado['_body'])
        if(resultadoJson && resultadoJson.data && resultadoJson.data[0] && resultadoJson.data[0][0]) {
            let resultadoTendero = resultadoJson.data
            let listaGruposProductosTemporal = []
            let resData = []
            resData = resultadoTendero[0]

            for(let k=0;k<resData.length;k++){
                  listaGruposProductosTemporal.push({
                      gruposProductosId:resData[k].gruposProductosId,
                      codigoGrupoProducto:resData[k].codigoGrupoProducto,
                      nombreGrupoProducto:resData[k].nombreGrupoProducto,
                      companiasId:resData[k].companiasId,
                      imagen:resData[k].imagen,
                      imagenLocal: resData[k].imagenLocal
                  })
            }
            this.listaGruposProductos = listaGruposProductosTemporal

            let listaProductosTemporal = []
            let resProductoData = []
            resProductoData = resultadoTendero[1]

            for(let y=0;y<resProductoData.length;y++){
                listaProductosTemporal.push({
                    gruposProductosId:resProductoData[y].gruposProductosId,
                    imagen:resProductoData[y].imagen,
                    imagenLocal:resProductoData[y].imagenLocal,
                    nombreProducto:resProductoData[y].nombreProducto,
                    productosId:resProductoData[y].productosId,
                    tipoProducto:resProductoData[y].tipoProducto,
                    valorImpuesto:resProductoData[y].valorImpuesto,
                    valorProducto:resProductoData[y].valorProducto,
                    valorVenta:resProductoData[y].valorVenta,
                    existenciasActuales:resProductoData[y].existenciasActuales,
                    nombreUbicacion:resProductoData[y].nombreUbicacion,
                    nombreContenedor:resProductoData[y].nombreContenedor,
                    valorImpuestoCalculo:resProductoData[y].valorImpuestoCalculo
                    ,codigoBarra: resProductoData[y].codigoBarra,
                    concatenado:resProductoData[y].concatenado,
                    display:resProductoData[y].display,
                    unidad:resProductoData[y].unidad,
                    tipoImpuesto: resProductoData[y].tipoImpuesto
                  })
            }

            let listaProductosTemporalDinamico = []
            let resProductoDataDinamico = []
            resProductoDataDinamico = resultadoTendero[3]

            for(let y=0;y<resProductoDataDinamico.length;y++){
                listaProductosTemporalDinamico.push({
                    imagen:resProductoDataDinamico[y].imagen,
                    imagenLocal:resProductoDataDinamico[y].imagenLocal,
                    nombreProducto:resProductoDataDinamico[y].nombreProducto,
                    productosId:resProductoDataDinamico[y].productosId,
                    tipoProducto:'E',
                    valorImpuesto:resProductoDataDinamico[y].valorImpuesto,
                    valorProducto:resProductoDataDinamico[y].valorProducto,
                    valorVenta:resProductoDataDinamico[y].valorVenta,
                    valorImpuestoCalculo:resProductoDataDinamico[y].valorImpuestoCalculo
                })
            }

            this.storage.set('datosDinamicos',JSON.stringify(resProductoDataDinamico))

            this.listaProductos = listaProductosTemporal
            this.clienteGenerico = []
            this.clienteGenerico =  resultadoTendero[2]
            this.contarProductos = this.listaProductos.length;
        }
        return
      }
        // buscar el id de la compania en la que esta logueado
        this.storage.get('companiasId').then((val) => {
            // buscar los grupos y los productos
            this.servicio.buscarGruposProductosParaCaja(val).subscribe(
                res => {

                        let listaGruposProductosTemporal = []
                        let resData = []
                        if(NUBE_AWS){
                          resData =  JSON.parse(res['_body']).data[0]
                        } else {
                          resData = res[0]
                        }
                        for(let k=0;k<resData.length;k++){
                            let imagenNueva =resData[k].imagenLocal
                            // imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','assets/imgs/')
                            // imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','file:///C:/bd/imagenes/')
                            listaGruposProductosTemporal.push({
                                gruposProductosId:resData[k].gruposProductosId,
                                codigoGrupoProducto:resData[k].codigoGrupoProducto,
                                nombreGrupoProducto:resData[k].nombreGrupoProducto,
                                companiasId:resData[k].companiasId,
                                imagen:resData[k].imagen,
                                imagenLocal: resData[k].imagenLocal
                            })
                        }
                        this.listaGruposProductos = listaGruposProductosTemporal

                        let listaProductosTemporal = []
                        let resProductoData = []
                        if(NUBE_AWS){
                          resProductoData =  JSON.parse(res['_body']).data[1]
                        } else {
                          resProductoData = res[1]
                        }

                        for(let y=0;y<resProductoData.length;y++){

                            //let imagenNueva =resProductoData[y].imagenLocal
                            //imagenNueva = MODO_DESCONECTADO ? imagenNueva : imagenNueva.replace('file:///C:/bd/imagenes/','assets/imgs/')
                            listaProductosTemporal.push({
                                gruposProductosId:resProductoData[y].gruposProductosId,
                                imagen:resProductoData[y].imagen,
                                imagenLocal:resProductoData[y].imagenLocal,
                                nombreProducto:resProductoData[y].nombreProducto,
                                productosId:resProductoData[y].productosId,
                                tipoProducto:resProductoData[y].tipoProducto,
                                valorImpuesto:resProductoData[y].valorImpuesto,
                                valorProducto:resProductoData[y].valorProducto,
                                valorVenta:resProductoData[y].valorVenta,
                                existenciasActuales:resProductoData[y].existenciasActuales,
                                nombreUbicacion:resProductoData[y].nombreUbicacion,
                                nombreContenedor:resProductoData[y].nombreContenedor,
                                valorImpuestoCalculo:resProductoData[y].valorImpuestoCalculo,
                                camposAdicionales:resProductoData[y].camposAdicionales === 'S' ? true : false
                            })
                        }

                        let listaProductosTemporalDinamico = []
                        let resProductoDataDinamico = []
                        if(NUBE_AWS){
                          resProductoDataDinamico =  JSON.parse(res['_body']).data[3]
                        } else {
                          resProductoDataDinamico = res[3]
                        }

                        for(let y=0;y<resProductoDataDinamico.length;y++){
                            listaProductosTemporalDinamico.push({
                                imagen:resProductoDataDinamico[y].imagen,
                                imagenLocal:resProductoDataDinamico[y].imagenLocal,
                                nombreProducto:resProductoDataDinamico[y].nombreProducto,
                                productosId:resProductoDataDinamico[y].productosId,
                                tipoProducto:'E',
                                valorImpuesto:resProductoDataDinamico[y].valorImpuesto,
                                valorProducto:resProductoDataDinamico[y].valorProducto,
                                valorVenta:resProductoDataDinamico[y].valorVenta,
                                valorImpuestoCalculo:resProductoDataDinamico[y].valorImpuestoCalculo,
                                camposAdicionales:resProductoDataDinamico[y].camposAdicionales === 'S' ? true : false
                            })
                        }

                        this.storage.set('datosDinamicos',JSON.stringify(resProductoDataDinamico))

                        this.listaProductos = listaProductosTemporal
                        this.listaProductos = listaProductosTemporal
                        this.contarProductos = this.listaProductos.length;
                    // }




                    // this.listaProductos = res[1]
                    // agregar cliente generico si lo trae
                    this.clienteGenerico = []
                    if(NUBE_AWS){
                      this.clienteGenerico =  JSON.parse(res['_body']).data[2]
                    } else {
                      this.clienteGenerico =  res[2]
                    }
                },
                err => {
                    // this.mostrarMensajeDeError('No se puedieron traer los grupos ni los productos, intente luego.')
                    this.mensajeToast(`No se puedieron traer los grupos ni los productos, intente luego.`)
                }
            )
        })
    }

    mostrarMensajeDeError(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
    }

    mostrarMensajeAdvertencia(mensaje,titulo) {
        let alert = this.alertControllers.create({
          title: titulo,
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
    }

    mostrarMensajeExito(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Registro generado con exito',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
    }

    imprimirMesero(codigo:any){

      if(this.platform.is('android') || this.platform.is('ios')){
        let item = {
          codigo
        }
        this.printD(item,true,true)
      }else{
        if(this.CheckImprimir){
          this.storage.get('companiasId').then((val) => {

          this.servicio.imprimirComandasMesas(codigo,val)
          .subscribe((data)=>{
            let values = JSON.parse(data['_body'])
            this.reemprimirRecibo(values.data)
          },
           error=>{
             console.log(error)
           })
          })}else{

            this.buscarDatosListaMuestra()
            this.buscarVentasdiariasCaja()
            this.buscarGruposProductosParaCaja()
          }
        }
     }


     imprimirMeseroEmpty(){

        // if(this.imprimir){
          this.storage.get('companiasId').then((val) => {
          this.servicio.imprimirComandasMesasEmpty(val)
          .debounceTime(3000)
          .subscribe((data)=>{
            this.buscarDatosListaMuestra()
            this.buscarGruposProductosParaCaja()
            let valor = JSON.parse(data['_body']).data[0]
            if(valor != undefined && valor.length>0){

                this.reemprimirRecibo(JSON.parse(data['_body']).data)
            }
          },
           error=>{
             console.log(error)
           })
          })
     }


    async mostrarMensajeGeneral(mensaje) {
        let recibo = ''
        let reciboBlue = ''
        let nuevovalorjsonBlue = ''
        if(MODO_DESCONECTADO){
            // for (let index:any = 0; index < mensaje.length; index++) {
            //     recibo += mensaje[index]['reciboCaja'] + '\n'
            // }
            for (let index:any = 0; index < mensaje.length; index++) {
              //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
              const textoRecibo = mensaje[index]['reciboCaja'];

              // Comandos ESC/POS para negrita y tamaño de fuente
              const negritaOn = '\x1b\x45\x01'; // Activar negrita
              const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
              const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
              const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
              const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

              if (textoRecibo !== null && textoRecibo.includes("TOTAL A PAGAR")) {
                recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
              } else {
                if(textoRecibo !== null && textoRecibo.includes("CAMBIO")) {
                  recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
                } else {
                  recibo += '   ' + textoRecibo + '\n';
                }
              }
            }
        }else{
            let newMensaje = NUBE_AWS ? mensaje : mensaje[0];
            let cambiarConsulta = false
            if(newMensaje != undefined && newMensaje['data'] != undefined) {
              newMensaje = newMensaje['data']
              cambiarConsulta = true
            }
            if(newMensaje){

                let mensajes = NUBE_AWS ? Object.keys(mensaje).map(key => mensaje[key]) : mensaje[0]
                if(cambiarConsulta){
                  mensajes = mensajes != undefined && mensajes[1] != undefined && mensajes[1][0] != undefined ? mensajes[1][0] : mensajes
                }
                for (let index:any = 0; index < mensajes.length; index++) {

                    //recibo += mensajes[index]['reciboCaja'] + '\n'
                    reciboBlue +=   `{"reciboCaja":"${mensajes[index]['reciboCaja']}"},`;
                }
                for (let index:any = 0; index < mensajes.length; index++) {
                  //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
                  const textoRecibo = mensajes[index]['reciboCaja'];

                  // Comandos ESC/POS para negrita y tamaño de fuente
                  const negritaOn = '\x1b\x45\x01'; // Activar negrita
                  const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
                  const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
                  const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
                  const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal
                  if (textoRecibo !== undefined && textoRecibo !== null && textoRecibo && textoRecibo.indexOf("TOTAL A PAGAR") !== -1) {
                    recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
                  } else {
                    if(textoRecibo !== undefined && textoRecibo !== null && textoRecibo && textoRecibo.indexOf("CAMBIO") !== -1) {
                      recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
                    } else {
                      recibo += '   ' + textoRecibo + '\n';
                    }
                  }
                }

                var jsoncadena = reciboBlue;
                jsoncadena = jsoncadena.substr(jsoncadena.length - 1, 1) == ',' ? jsoncadena.substring(0, jsoncadena.length - 1) : jsoncadena;
                nuevovalorjsonBlue =  "[" + jsoncadena + "]";
           }
        }




        // limpiar todo el formulario
        this.cancelarVenta()

        // mandar a imprimir


        let blue = ''

        if(!this.CheckImprimir){
            // let alert = this.alertControllers.create({
            //     title: '',
            //     subTitle: recibo,
            //     buttons: ['Cerrar']
            // });
            // alert.present();
            this.mensajeToast(`${recibo}`)
            this.limpiarImpresion()
        }else{
          let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
          if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
            blue = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
                if(blue =="B"){

                  let dat = JSON.parse(nuevovalorjsonBlue)
              this.guardarBlu(dat)
              }else{
                if (this.cantidadImpresionesEnCaja == undefined) {
                this.cantidadImpresionesEnCaja = "1"
                }
                for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
                  this.servicio.imprimirRecibo(recibo).subscribe(
                    res => {

                    },
                    err => {
                        // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                        if(this.platform.is('android') || this.platform.is('ios')){
                            this.mensajeToast(`${recibo}`)
                            // this.limpiarImpresion()

                        }else{

                            this.mensajeToast(`${recibo}`)
                            // this.limpiarImpresion()

                        }

                    }
                )
                }

                this.limpiarImpresion()
              }
          } else {
            this.storage.get('companiasId').then((val) => {
                this.servicio.buscarParametrosGenerales(val)
                .subscribe((data)=>{
                  if(NUBE_AWS) {
                    blue = JSON.parse(data['_body']).data[0][0].bluetooth
                  } else {
                    blue = data[0].bluetooth
                  }

                   if(blue =="B"){

                       let dat = JSON.parse(nuevovalorjsonBlue)
                    this.guardarBlu(dat)
                   }else{
                     if (this.cantidadImpresionesEnCaja == undefined) {
                      this.cantidadImpresionesEnCaja = "1"
                     }
                     for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
                        this.servicio.imprimirRecibo(recibo).subscribe(
                          res => {

                          },
                          err => {
                              // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                              if(this.platform.is('android') || this.platform.is('ios')){
                                  this.mensajeToast(`${recibo}`)
                                  // this.limpiarImpresion()

                              }else{

                                  this.mensajeToast(`${recibo}`)
                                  // this.limpiarImpresion()

                              }

                          }
                      )
                     }

                     this.limpiarImpresion()
                   }
                })
            })
          }


        }



    }


    reemprimirRecibo(mensaje) {
        let recibo = ''


        if(MODO_DESCONECTADO){
            for (let index:any = 0; index < mensaje.length; index++) {
                recibo += mensaje[index]['reciboCaja'] + '\n'
            }
        }else{
            if(mensaje && mensaje[0] && mensaje[0][0]){
                let mensajes = mensaje[0]
                // for (let index:any = 0; index < mensajes.length; index++) {
                //     recibo += mensajes[index]['reciboCaja'] + '\n'
                // }
                for (let index:any = 0; index < mensaje.length; index++) {
                  //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
                  const textoRecibo = mensaje[index]['reciboCaja'];

                  // Comandos ESC/POS para negrita y tamaño de fuente
                  const negritaOn = '\x1b\x45\x01'; // Activar negrita
                  const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
                  const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
                  const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
                  const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

                  if (textoRecibo.includes("TOTAL A PAGAR")) {
                    recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
                  } else {
                    if(textoRecibo.includes("CAMBIO")) {
                      recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
                    } else {
                      recibo += '   ' + textoRecibo + '\n';
                    }
                  }
                }
            }
        }


        // mandar a imprimir
        this.servicio.imprimirRecibo(recibo).subscribe(
            res => {
                if(!MODO_DESCONECTADO){
                    this.buscarDatosListaMuestra()
                    this.buscarVentasdiariasCaja()
                    this.buscarGruposProductosParaCaja()
                    // this.reiniciarValores()
                }else{
                    this.elect()
                }

            },
            err => {
                // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                if(this.platform.is('android') || this.platform.is('ios')){
                    if(!MODO_DESCONECTADO){
                        this.buscarDatosListaMuestra()
                        this.buscarVentasdiariasCaja()
                        // this.reiniciarValores()
                    }else{
                        this.elect()
                    }

                    this.mensajeToast(`${recibo}`)
                }else{

                    this.mensajeToast(`${recibo}`)

                    if(!MODO_DESCONECTADO){
                        this.buscarDatosListaMuestra()
                        this.buscarVentasdiariasCaja()
                        this.buscarGruposProductosParaCaja()

                    }else{
                        this.elect()
                    }

                }

            }
        )


    }

    filtrarProductos(item) {

        this.filtroGruposActivo = true
        this.nombreFiltroGrupo = item.nombreGrupoProducto
        if(MODO_DESCONECTADO){

                this.filtrogruposProductosId = item.nombreGrupoProducto
        }else{
            this.filtrogruposProductosId = item.gruposProductosId
        }
        let productosCoincidencias: any = this.listaProductos.filter(producto => producto.gruposProductosId === this.filtrogruposProductosId);
        this.setProductos(productosCoincidencias);
        this.contarProductos = productosCoincidencias.length

    }


    quitarFiltroGrupos() {
        this.filtroGruposActivo = false,
        this.filtrogruposProductosId = undefined
        this.nombreFiltroGrupo = ''
        this.setProductos(this.listaProductos);
        this.contarProductos = this.listaProductos.length
    }

    agregarAlCarrito(item) {
      if(this.sobreGiroEnLosProductos) {
        let existenciasActuales = Number(item.existenciasActuales)
        let cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
        cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1

        if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
          this.utils.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
          return
        }
      }

        if(!MODO_DESCONECTADO){
            this.realizandoUnaVenta = true
            // verificar si el producto ya no esta agregado
            let productosId = item['productosId']
            // let contarProductosConElMismoId = this.listaProductosSeleccionados.filter( item => item.productosId === productosId )
            let tipoProducto = item['tipoProducto']
            let contarProductosConElMismoId = this.listaProductosSeleccionados.filter( item => item.productosId === productosId && item.tipoProducto === tipoProducto )
            if(contarProductosConElMismoId.length > 0){

              //Si el parametro esta en S, se devuelve y no acumula productos
              if(this.digitaCantidadEnVenta){
                return
              }

              let indiceExisteProducto = this.listaProductosSeleccionados.indexOf(item);

              // el producto ya existe en el carrito se aumenta un registro la cantidad.
              this.aumentarUnProducto(item,indiceExisteProducto);
              return
            }
            // el producto aun no ha sido agregado
            item['cantidad'] = 1
            this.listaProductosSeleccionados.unshift(item)
            let valorTotalVentaNum =  0
            let valorTotalProductosNum =  0
            let valorTotalImpuestosNum =  0
            valorTotalVentaNum =  Number(this.valorTotalVenta) +  Number(item['valorVenta'])
            valorTotalProductosNum =  Number(this.valorTotalProductos) +  Number(item['valorProducto'])
            valorTotalImpuestosNum =  Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
            this.valorTotalVenta = valorTotalVentaNum
            this.valorTotalProductos = valorTotalProductosNum
            this.valorTotalImpuestos = valorTotalImpuestosNum
            this.setProductosSelect(this.listaProductosSeleccionados);
          }else{
            this.realizandoUnaVenta = true


            let productosIdBuscar = item['productosId']

            if(productosIdBuscar ==="0"){
                productosIdBuscar = item['productoId']
            }
            let tipoProductoBuscar = item['tipoProducto'] === undefined ? item['tipo'] : item['tipoProducto']

            let contarProductosConElMismoId = this.listaProductosSeleccionados.filter(
                item => item.productosId ==="0" ? item.productoId === productosIdBuscar : item.productosId === productosIdBuscar && item.tipo === tipoProductoBuscar )
            if(contarProductosConElMismoId.length > 0){

                return
            }

            item['cantidad'] = 1
            this.listaProductosSeleccionados.unshift(item)
            let valorTotalVentaNum =  0
            let valorTotalProductosNum =  0
            let valorTotalImpuestosNum =  0
            valorTotalVentaNum =  Number(this.valorTotalVenta) +  Number(item['valorVenta'])
            valorTotalProductosNum =  Number(this.valorTotalProductos) +  Number(item['valorProducto'])
            valorTotalImpuestosNum =  Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
            this.valorTotalVenta = valorTotalVentaNum
            this.valorTotalProductos = valorTotalProductosNum
            this.valorTotalImpuestos = valorTotalImpuestosNum

            if (this.listaProductosSeleccionados) {
              this.setProductosSelect(this.listaProductosSeleccionados);
            }
          }
         this.cambiarCheckPorcentaje(this.valorTotalProductos + this.valorTotalImpuestos,this.valorTotalProductos + this.valorTotalImpuestos)
          if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
            this.cantidadafnprueba.nativeElement.focus();
          }

    }

    disminuirUnProducto(item, index) {

      let nuevaCantidad = 0

      let manejaCajaDinamica = this.manejaCajaDinamica
      if(manejaCajaDinamica && item['productosElaboradosDinamicosId']!== undefined){
        item['valorVenta'] = item['valorProducto'] + item['valorImpuesto']
          nuevaCantidad = Number(item['cantidad']) - 10000
          let id = Number(item['productosElaboradosDinamicosId'])
          this.listaProductosSeleccionados[index].color = "#FFFFFF"
          this.cambiarEstadoProductoDinamico(id,index)
       }

        nuevaCantidad+= Number(item['cantidad']) - 1
        // si la cantidad es menor o igual a cero debe quitar el producto
        if(nuevaCantidad <= 0){


            this.listaProductosSeleccionados.splice(index, 1)

          this.valorTotalVenta = this.valorTotalVenta - item['valorVenta']
          this.valorTotalProductos = this.valorTotalProductos - item['valorProducto']
          this.valorTotalImpuestos = this.valorTotalImpuestos - item['valorImpuesto']
          this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
            // validar si no hay productos seleccionados
            if(this.listaProductosSeleccionados.length <= 0){
                this.realizandoUnaVenta = false
            }
            if(MODO_DESCONECTADO){
              this.valorTotalImpuestos = 0;
              this.valorTotalProductos = 0;
            }
            this.setProductosSelect(this.listaProductosSeleccionados);
        }
        else{
            // this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad

            this.restarProductosVenta(item,index,1)
            if(MODO_DESCONECTADO){
              this.valorTotalImpuestos = 0;
              this.valorTotalProductos = 0;
            }
        }

    }

  restarProductosVenta(item:any,index:any,cantidad:number){

    let cantidadActual = Number(item['cantidad'])
    let nuevaCantidad = cantidadActual - cantidad
    let valorVentaProducto = Number(item['valorVenta'])
    let porcentajeImpuesto = Number(item['valorImpuestoCalculo'])
    //Hallo el valor del impuesto actual, para saber qué impuesto debo adicionar a la venta total
    let valorVentaTotalProductoACtual = valorVentaProducto * cantidadActual
    let valorRestoVentas = Math.round(valorVentaTotalProductoACtual / ((porcentajeImpuesto / 100)+1))
    let valorRestoImpuesto = valorVentaTotalProductoACtual - Math.round(valorVentaTotalProductoACtual / ((porcentajeImpuesto / 100)+1))

    //Hallo el valor del impuesto nuevo, para restarle los valores actuales
    let valorVentasTotalProductoNuevo = valorVentaProducto * nuevaCantidad
    let ValorSumoVentas = Math.round(valorVentasTotalProductoNuevo / ((porcentajeImpuesto / 100)+1))
    let ValorSumoImpuesto =  valorVentasTotalProductoNuevo - ValorSumoVentas

     this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad
     let valorTotalVentaNum = 0
     valorTotalVentaNum = Number(this.valorTotalVenta) -  (valorVentaProducto * cantidad)
     this.valorTotalVenta = valorTotalVentaNum

     let valorTotalProductosNum = 0
     valorTotalProductosNum = Number(this.valorTotalProductos) - (valorRestoVentas-ValorSumoVentas) //(Number(item['valorProducto'])
     this.valorTotalProductos = valorTotalProductosNum
     let valorTotalImpuestosNum =  0
     valorTotalImpuestosNum =Number(this.valorTotalImpuestos) - (valorRestoImpuesto-ValorSumoImpuesto)// Number(item['valorImpuesto'])
     this.valorTotalImpuestos = valorTotalImpuestosNum
     this.setProductosSelect(this.listaProductosSeleccionados);
     this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
  }
    buscarIndex(item:any,index:any){
        let id  = Number(index)

        let tipoProducto  = item['tipoProducto']
        let productosId = item['productosId']
        let indexNuevo = 0


                for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
                  if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){
                      indexNuevo = k
                      k = this.listaProductosSeleccionados.length + 1
                  }
                  }


        return indexNuevo
      }

    aumentarUnProducto(item:any, index:any) {
      if(this.sobreGiroEnLosProductos) {
        let existenciasActuales = Number(item.existenciasActuales)
        let cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
        cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1

        if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
          this.utils.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
          return
        }
      }
      let manejaCajaDinamica = this.manejaCajaDinamica
      if(manejaCajaDinamica && item['productosElaboradosDinamicosId']!== undefined){

        item['cantidad'] =  Number(item['cantidad']) + 1

        this.ProductosDinamicos(item,index)
         return
       }

       this.incrementarProductosEnVenta(item, index, 1)

        this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
        if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
          this.cantidadafnprueba.nativeElement.focus();
        }
      }

      incrementarProductosEnVenta(item:any, index:any, cantidad:number){
        if(MODO_DESCONECTADO) {

          let cantidadActual = Number(item['cantidad'])
          let nuevaCantidad = Number(cantidadActual) + Number(cantidad)

          var valorVentaProducto = Number(item['valorVenta'])
          var porcentajeImpuesto = Number(item['valorImpuestoCalculo'])

          //Hallo el valor del impuesto actual, para saber qué impuesto debo adicionar a la venta total
          let valorVentaTotalProductoACtual = Number(valorVentaProducto) * Number(cantidadActual)
          let valorRestoVentas = Math.round(Number(valorVentaTotalProductoACtual) / ((Number(porcentajeImpuesto) / 100)+1))
          let valorRestoImpuesto = Number(valorVentaTotalProductoACtual) - Math.round(Number(valorVentaTotalProductoACtual) / ((Number(porcentajeImpuesto) / 100)+1))

          //Hallo el valor del impuesto nuevo, para restarle los valores actuales
          let valorVentasTotalProductoNuevo = Number(valorVentaProducto) * Number(nuevaCantidad)
          let ValorSumoVentas = Math.round(Number(valorVentasTotalProductoNuevo) / ((Number(porcentajeImpuesto) / 100)+1))
          let ValorSumoImpuesto =  Number(valorVentasTotalProductoNuevo) - Math.round(Number(valorVentasTotalProductoNuevo) / ((Number(porcentajeImpuesto) / 100)+1))

           this.listaProductosSeleccionados[index]['cantidad'] = Number(nuevaCantidad)
           let valorTotalVentaNum = 0
           valorTotalVentaNum = Number(this.valorTotalVenta) +  (Number(valorVentaProducto) * Number(cantidad))
           this.valorTotalVenta = valorTotalVentaNum

           let valorTotalProductosNum = 0
           valorTotalProductosNum = Number(this.valorTotalProductos) + (ValorSumoVentas - valorRestoVentas) //(Number(item['valorProducto'])
           this.valorTotalProductos = isNaN( valorTotalProductosNum) ? 0 :  valorTotalProductosNum;
           let valorTotalImpuestosNum =  0
           valorTotalImpuestosNum =Number(this.valorTotalImpuestos) + (ValorSumoImpuesto-valorRestoImpuesto)// Number(item['valorImpuesto'])
           this.valorTotalImpuestos = valorTotalImpuestosNum
           this.valorTotalImpuestos = isNaN( this.valorTotalImpuestos) ? 0 :  this.valorTotalImpuestos;
           this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
        } else {
          let cantidadActual = Number(item['cantidad'])
          let nuevaCantidad = cantidadActual + cantidad
          let valorVentaProducto = Number(item['valorVenta'])
          let porcentajeImpuesto = Number(item['valorImpuestoCalculo'])
          //Hallo el valor del impuesto actual, para saber qué impuesto debo adicionar a la venta total
          let valorVentaTotalProductoACtual = valorVentaProducto * cantidadActual
          let valorRestoVentas = Math.round(valorVentaTotalProductoACtual / ((porcentajeImpuesto / 100)+1))
          let valorRestoImpuesto = valorVentaTotalProductoACtual - Math.round(valorVentaTotalProductoACtual / ((porcentajeImpuesto / 100)+1))

          //Hallo el valor del impuesto nuevo, para restarle los valores actuales
          let valorVentasTotalProductoNuevo = valorVentaProducto * nuevaCantidad
          let ValorSumoVentas = Math.round(valorVentasTotalProductoNuevo / ((porcentajeImpuesto / 100)+1))
          let ValorSumoImpuesto =  valorVentasTotalProductoNuevo - Math.round(valorVentasTotalProductoNuevo / ((porcentajeImpuesto / 100)+1))

           this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad
           let valorTotalVentaNum = 0
           valorTotalVentaNum = Number(this.valorTotalVenta) +  (valorVentaProducto * cantidad)
           this.valorTotalVenta = valorTotalVentaNum

           let valorTotalProductosNum = 0
           valorTotalProductosNum = Number(this.valorTotalProductos) + (ValorSumoVentas - valorRestoVentas) //(Number(item['valorProducto'])
           this.valorTotalProductos = valorTotalProductosNum
           let valorTotalImpuestosNum =  0
           valorTotalImpuestosNum =Number(this.valorTotalImpuestos) + (ValorSumoImpuesto-valorRestoImpuesto)// Number(item['valorImpuesto'])
           this.valorTotalImpuestos = valorTotalImpuestosNum

           this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
        }
      }

      aumentarUnProductoCodigoDeBarrasExiste(item,index){
        let existe = false

        let id  = Number(item['productosId'])
        let tipoProducto  = item['tipoProducto']
        for(let i =0;i <this.listaProductos.length;i++){
          if(this.listaProductos[i].productosId == id && this.listaProductos[i].tipoProducto == tipoProducto){
            this.listaProductosSeleccionados[index]['valorImpuesto'] = this.listaProductos[i]['valorImpuesto']
            this.listaProductosSeleccionados[index]['valorProducto'] = this.listaProductos[i]['valorProducto']
            // this.listaProductosSeleccionados[index]['queHago'] = true
            i = this.listaProductos.length + 1
          }
        }

        return existe
      }
      aumentarUnProductoCodigoDeBarras(item, index) {

        let manejaCajaDinamica = this.manejaCajaDinamica
        if(manejaCajaDinamica && item['productosElaboradosDinamicosId']!== undefined){

          item['cantidad'] =  Number(item['cantidad']) + 1

          this.ProductosDinamicos(item,index)
           return
         }

          let nuevaCantidad = Number(item['cantidad']) + 1

          this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad
          let valorTotalVentaNum = 0
          valorTotalVentaNum = Number(this.valorTotalVenta) +  Number(item['valorVenta'])
          this.valorTotalVenta = valorTotalVentaNum

          let valorTotalProductosNum = 0
          valorTotalProductosNum = Number(this.valorTotalProductos) +  Number(item['valorProducto'])
          this.valorTotalProductos = valorTotalProductosNum
          let valorTotalImpuestosNum =  0
          valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
          this.valorTotalImpuestos = valorTotalImpuestosNum
          this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
          if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
            this.cantidadafnprueba.nativeElement.focus();
          }
        }

    searchSimple(cantidadafnSimple:any,item,index){
        setTimeout(() => {
          let cantidad;
          // Verificar si el valor ingresado es 0 o no es un número
          if (Number(cantidadafnSimple['_value']) == 0 || isNaN(cantidadafnSimple['_value'])) {
            if (this.pesoDesdeSocket) {
              cantidad = this.pesoDesdeSocket;
            } else {
              return; // Se mantiene el retorno en caso de que no haya pesoDesdeSocket
            }
          } else {
            cantidad = Number(cantidadafnSimple['_value']);
          }

          this.pesoDesdeSocket = null; // Reiniciar el peso desde el socket para evitar reutilización accidental


           if(this.sobreGiroEnLosProductos) {
            let existenciasActuales = Number(item.existenciasActuales)
            let cantidadActual = 0
            let nuevaCantidadProductos = this.listaProductosSeleccionados.filter((value)=> value.productosId == item.productosId)
            if(nuevaCantidadProductos.length>0) {item['cantidad']
              cantidadActual = nuevaCantidadProductos[0].cantidad
              cantidadActual = cantidadActual + 1
            } else {
              cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
              cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1
            }

            if(existenciasActuales<=0 || existenciasActuales <= cantidadActual) {
              this.utils.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
              return
            }
          }

           let nuevaCantidad = Number(cantidad)
           let manejaCajaDinamica = this.manejaCajaDinamica
           if(manejaCajaDinamica && item['productosElaboradosDinamicosId']!== undefined){

            item['cantidad'] =  nuevaCantidad

            this.ProductosDinamicos(item,index)
            cantidadafnSimple['_value'] = ''
             return
           }
           index = this.buscarIndex(item,index)

           let cantidadOld = this.listaProductosSeleccionados[index]['cantidad']
           cantidad = cantidad - cantidadOld
           if (cantidad<0){
             cantidad = cantidad * -1
            this.restarProductosVenta(item,index,cantidad)
           }else{
            this.incrementarProductosEnVenta(item,index,cantidad)
           }
           return


         },1000)
       }

       actualizarReal(item:any,index:any){
        let id  = Number(item['productosId'])
        let tipoProducto  = item['tipoProducto']
        for(let i =0;i <this.listaProductos.length;i++){
          if(this.listaProductos[i].productosId == id && this.listaProductos[i].tipoProducto == tipoProducto){
            this.listaProductosSeleccionados[index]['valorImpuesto'] = this.listaProductos[i]['valorImpuesto']
            this.listaProductosSeleccionados[index]['valorProducto'] = this.listaProductos[i]['valorProducto']
            // this.listaProductosSeleccionados[index]['queHago'] = true
            i = this.listaProductos.length + 1
          }
        }
      }


      CancelarVentaActual(){
        this.utils.mensajeConfirmacionDos('Venta Actual','¿Está Seguro de Cancelar la venta actual?','question','Si','No')
        .then((cancelarLaVentaActual: boolean) => {
          if (cancelarLaVentaActual) {
            this.cancelarVenta()
          }
        })
      }

    cancelarVenta() {
        this.listaProductosSeleccionados = []
        this.valorTotalVenta = 0
        this.valorTotalProductos = 0
        this.valorTotalImpuestos = 0
        this.realizandoUnaVenta = false
        this.valorTotalDevolver = 0
        this.clienteId = []
        this.limpiarNombreCliente()
        this.resetStore();
        this.clienteGenerico = undefined
        this.price = 0
        this.valormesa = 0
        this.CheckCredito = true
        this.formaPagoSeleccionada = 'O'
        this.formaPagoSeleccionadaNombre = 'EFECTIVO'
        this.CheckPorcentajeServicio = true
        this.buscar =""
        this.allItems = undefined
        this.valorTotalServicio = 0
        this.descripcionVenta = ""
        this.CheckDescuento = false
        this.planSepare = 'N'
        this.turnoPersonalizado = 0
        this.formasDePagoGeneral =[]
        if(!MODO_DESCONECTADO){
            this.cambiarCheckCredito()
            this.buscarDatosListaMuestra()
            this.buscarGruposProductosParaCaja()
            this.cambiarCheckPorcentajeServicio()
            // this.reiniciarValores()
        }else{
            this.elect()
        }
        if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
          this.startTimerCodigoDeBarras()
          this.cantidadafnprueba.nativeElement.focus();
        }
        this.setProductosSelect(this.listaProductosSeleccionados);
    }


    limpiarImpresion(){
      return
    }



    async pagar() {
        if(this.valormesa!=0){
               this.pagarmesas(this.formasDePagoGeneral)
                return
        }
        if(this.formaPagoSeleccionada.trim() !== 'C' && this.formasDePagoGeneral.length === 0) {
            // hacer validaciones para finalizar la venta
            if( (this.valorTotalDevolver - this.valorTotalVenta) < 0){
              this.utils.mensajeMuestro('Valor a devolver no válido','No se guardó la venta','error')
              return
          } else if ( this.valorTotalVenta <= 0){
              // this.mostrarMensajeDeError('Valor total venta no valido!')
              this.utils.mensajeMuestro('Valor total venta no válido','No se guardó la venta','error')
              // this.mensajeToast(`Valor total venta no valido!`)
              return
          }
          if(isNaN(this.valorTotalDevolver)) {
            console.log('(`Valor a devolver no valido!`)', (`Valor a devolver no valido!`))
          }
        } else {
         // this.valorTotalDevolver = this.valorTotalVenta
        }
        var VentaUuid = require('uuid/v4');


        let datosAdicionales = {
            valorTotalVenta: this.valorTotalVenta,
            totalPagado: this.valorTotalDevolver,
            valorTotalDevolver: (this.valorTotalDevolver - this.valorTotalVenta),
            // tipoVenta: this.CheckCredito === true ? 'C' : 'O',
            tipoVenta: this.formaPagoSeleccionada,
            servicio : this.porcentajeServicioValorPedidosSalon == 'S' ? this.porcentajeServicioValorPedidosSalon : this.porcentajeServicioValor['valor'],
            descripcion: this.descripcionVenta,
            ventaDiariaUuid: VentaUuid(),
            planSepare: this.planSepare
          }
          let clienteCaja = await this.buscarClienteStore();

          this.getMultiple(['usuariosId','companiasId'])
        .then( res => {

            datosAdicionales['usuariosId'] = res['usuariosId']
            datosAdicionales['companiasId'] = res['companiasId']

            if(datosAdicionales['usuariosId']==null){
                datosAdicionales['usuariosId'] = 1
            }
            // saber si tiene cliente seleccionado
            if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
                // envia el cliente que este seleccionado
                datosAdicionales['clientesId'] = clienteCaja['valuedisplay'][0].value
            } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {
                if(this.clienteObligatorioEnCaja) {
                  this.utils.mensajeMuestro('Advertencia','Debe seleccionar un cliente','warning')
                  return
                }
                // si tiene un cliente generico seleccionado
                datosAdicionales['clientesId'] = this.clienteGenerico[0]['clientesId']
            } else {
                if(this.clienteObligatorioEnCaja) {
                  this.utils.mensajeMuestro('Advertencia','Debe seleccionar un cliente','warning')
                  return
                }
                // envia un cliente null
                datosAdicionales['clientesId'] = 0

                if(this.CheckCredito){
                    // this.mostrarMensajeAdvertencia('Para generar una cuenta por cobrar debe asignar un cliente','Advertencia')
                    this.mensajeToast(`Para generar una cuenta por cobrar debe asignar un cliente','Advertencia`)
                     return
             }
            }

            if(MODO_DESCONECTADO){

              let listaProductosSeleccionados =  this.listaProductosSeleccionados

              let data = this.servicio.guardarVentaDesconectUnica(listaProductosSeleccionados, datosAdicionales)
              if(data){
                this.mostrarMensajeGeneral(data)
                if(listaProductosSeleccionados.length>0) {
                  datosAdicionales['fechaVenta'] = listaProductosSeleccionados[0].afnFecha
                  listaProductosSeleccionados.forEach(producto => {
                    producto.tipoProducto = producto.tipo;
                    producto.fechaVenta = producto.afnFecha;
                  });
                }
                this.servicio.guardarVentasdiariasModoDesconectado(listaProductosSeleccionados, datosAdicionales)
                this.reemprimirReciboDia(data)
              }


            }else{
            this.loader = this.loadingCtrl.create({});
            this.loader.present();
            this.storage.get('fechaSistema').then((val) => {

                if(val!=undefined){
                    datosAdicionales['fechaVenta'] = val
                }

                this.devolverValoresCajaDinamica()
                .then( async (elaboradosContenido)=>{
                  if(datosAdicionales.tipoVenta === 'C' && this.manejaPlanDePagosEnCuentasPorCobrar) {
                    datosAdicionales['fechaVencimiento'] = this.fechaVencimiento
                  }
                  if(this.guardarPlanDePagosEnCuentasPorCobrarSimulador && this.gestionarSimuladorCuotasExtras.length> 0) {
                    datosAdicionales['tipoVenta'] = 'C'
                    var VentaUuid = require('uuid/v4');
                    datosAdicionales['ventaDiariaUuid'] = VentaUuid()
                  }
                  if(this.CheckDescuento) {
                    this.inputValueDescuento = await this.presentPrompt();

                    if (this.inputValueDescuento !== null) {
                      if(this.inputValueDescuento < 0 || this.inputValueDescuento > 100) {
                        this.utils.mensajeMuestro('Advertencia','El % de descuento no es valido','warning')
                        return
                      }
                      this.listaProductosSeleccionados = await this.recalcularValorDeLosProductosSeleccionados(this.listaProductosSeleccionados,this.inputValueDescuento)
                    } else {
                      this.utils.mensajeMuestro('Advertencia','El usuario canceló la venta','warning')
                      return
                    }
                    datosAdicionales['porcentajeDescuento'] = this.listaProductosSeleccionados[0].porcentajeDescuento
                  }
                  let cuentasPorCobrarCredito = this.planDePagosCreditoCompleto
                  if(this.manejaInteresCreditos) {
                    datosAdicionales['tipoVenta'] = 'C'
                    var VentaUuid = require('uuid/v4');
                    datosAdicionales['ventaDiariaUuid'] = VentaUuid()
                  }

                  if(this.formasDePagoGeneral.length > 0) {

                    await this.generarVentaFormasDePagoSinAsignarTurno(datosAdicionales,this.listaProductosSeleccionados,this.formasDePagoGeneral)
                    if (this.loader) {
                      this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                    }
                    // mostar la venta
                    this.cancelarVenta()
                    this.buscarVentasdiariasCaja()
                    this.buscarDatosListaMuestra()
                    this.buscarGruposProductosParaCaja()
                    return
                  }
                  this.servicio.guardarVenta(this.listaProductosSeleccionados, datosAdicionales,elaboradosContenido,this.gestionarSimuladorCuotasExtras,
                    cuentasPorCobrarCredito
                  ).subscribe(
                    (resVenta: any) => {
                        // cerrar modal load
                        if (this.loader) {
                          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                        }
                        // mostar la venta
                        this.cancelarVenta()
                        this.buscarVentasdiariasCaja()
                        this.buscarDatosListaMuestra()
                        this.buscarGruposProductosParaCaja()
                        let data = NUBE_AWS ? JSON.parse(resVenta['_body']) : resVenta.json()
                        this.mostrarMensajeGeneral(data)

                        if(this.manejaCodigoDeBarras && this.cantidadafnprueba ){
                          this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
                            this.cantidadafnprueba.nativeElement.focus();
                            this.timerCodigoBarra.unsubscribe();
                          })
                        }
                    },
                    errVenta => {
                        // cerrar modal load
                        if (this.loader) {
                          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                        }
                        // this.mostrarMensajeDeError('Error Guardando Venta')
                        // this.mensajeToast(`Error Guardando Venta`)
                        this.utils.mensajeMuestro('Error en venta','Error al guardar la venta. Por favor intente nuevamente','error')

                        if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
                          this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
                            this.cantidadafnprueba.nativeElement.focus();
                            this.timerCodigoBarra.unsubscribe();
                          })
                        }
                    }
                )
                })

            });
            }
            if (this.loader) {
              this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
            }
        })
        if (this.loader) {
          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
        }
    }

    getMultiple(keys: string[]) {
        const promises = [];

        keys.forEach( key => promises.push(this.storage.get(key)) );

        return Promise.all(promises).then( values => {
          const result = {};

          values.map( (value, index) => {
            result[keys[index]] = value;
          });

          return result;
        });
    }

    public requestAutocompleteItems = (text: string): Observable<Response> => {
        return  this.servicio.buscarClientesPorCompania(text)
    };
    public onTextChange(text) {
        console.log('text changed: value is ' + text);
    }
    cerrarSession(){
        // this.auth.logout()
        // this.navCtrl.setRoot('LoginPage');

      }


      ngAfterViewInit() {
        this.canvasNoDefinido()
    }

    canvasNoDefinido(){
      if(this.manejaCodigoDeBarras){
          JsBarcode(this.canvasElement.nativeElement, "No definido", {
              fontSize: 20,
              background: "#AF7AC5",
              lineColor: "#990000",
              margin: 20,
              marginLeft: 20
            });
      }
    }

    canvasElementcodigo(codigo){
      if(this.manejaCodigoDeBarras && this.canvasElement){
          this.canvasElement.nativeElement.style ="display:block"
          JsBarcode(this.canvasElement.nativeElement, codigo);
      }
    }

    toggleFormCrearCliente(){
        let modal = this.modalControllers.create(ClienteRapidoPage, { data: this.listaClientes }
          )
        modal.present();

        modal.onDidDismiss(data => {
          if (data && data.length>0) {
            this.limpiarClienteRapido()
            this.buscarClientes(this.companiasId)
            this.buscarClientesUnico(this.companiasId)
          }
        })
      }
    labelCrearCliente(){
        return (!this.estadoFormCrearCliente) ? 'Mostrar Crear Cliente Rápido' : 'Ocultar Crear Cliente Rápido'
    }
    iconCrarCliente(){
      return (!this.estadoFormCrearCliente) ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
    }

    guardarClienteRapido(){

      let datosCliente: clientes = {
        tipoIdentificacion : 'C',
        identificacion : '0',
        digito : '0',
        fechaExpedicion : '',
        primerApellido : '',
        numeroTelefono : this.telefonoClienteRapido,
        segundoApellido : '',
        primerNombre : this.nombreClienteRapido,
        segundoNombre : '',
        nombreCompleto : this.nombreClienteRapido,
        fechaIngreso : '',
        estado : 'A',
        direccion : this.direccionClienteRapido,
        queHago: "I",
        nombreTabla: "clientes",
        name: "dataDynamicCrud"
      }
      this.storage.get('companiasId').then((val) => {
        datosCliente['companiasId']  = val
      this.providerClientes.guardar(datosCliente)
        .subscribe(
        res => {
          this.utils.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
          this.limpiarClienteRapido()
          this.buscarClientes(val)
        },
        err => {
          console.log(err)}
        )
      })

    }

    limpiarClienteRapido(){

      this.telefonoClienteRapido = ""
      this.nombreClienteRapido = ""
      this.direccionClienteRapido = ""
      this.estadoFormCrearCliente = false

    }

    toggleForm(){
        this.formState = (this.formState == 'collapsed') ? 'expanded' : 'collapsed'
        this.formStatebool = !this.formStatebool
    }
    label(){
        return (this.formState == 'collapsed') ? 'Agregar Producto rapido' : 'Ocultar Producto rapido'
    }
    icon(){
      return (this.formState == 'collapsed') ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
    }

  toggleFormDescripcion(){
      this.formStateDescripcion = (this.formStateDescripcion == 'collapsed') ? 'expanded' : 'collapsed'
      this.formStateboolDescripcion = !this.formStateboolDescripcion
  }
  labelDescripcion(){
      return (this.formStateDescripcion == 'collapsed') ? 'Descripción' : 'Ocultar Descripción'
  }
  iconDescripcion(){
    return (this.formState == 'collapsed') ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
  }

    guardarProducto(){

        if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" && this.valorVenta !== 0){


        this.storage.get('companiasId').then((val) => {
        let datosProducto: any = {
            codigoProducto: this.codigoProducto,
            nombreProducto: this.nombreProducto,
            valorVenta: this.valorVenta,
            existenciasMinimas:0,
            existenciasActuales: 0,
            visualizaEnCaja: true,
            controlaEnInventario: true,
            tipoImpuesto:'I',
            valorImpuesto: this.valorImpuesto,
            centroDeCostosId: 1,
            imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
            codigoBarra:this.codigoBarra,
            companiasId:val,
            costo:this.costo,
            queHago: "I",
            nombreTabla: "productos",
            name: "dataDynamicCrud"
          }
          // if(MODO_DESCONECTADO){
          //   this.storage.get('companiasId').then((val) => {
          //     datosProducto['companiasId'] = val
          //   let codigo =  this.codigoBarra

          //   datosProducto['codigoBarra'] = codigo

          //   datosProducto['productosId'] = "0"
          //   let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosProducto,'c:\\bd','productos')

          //   this.mensajeToast(`Producto guardado.. recuerde ingresar este producto en productos por grupos para poder interactuar con este producto en la caja`)
          //   this.formState = 'collapsed'
          //   this.formStatebool = false

          //     })
          // }else{
          this.servicioProductos.guardarProducto(datosProducto)
          .subscribe(
            res => {
                // this.mostrarMensajeAdvertencia('Producto guardado..','Registro Exitoso')
                this.mensajeToast(`Producto guardado..`)

                this.productoId =  JSON.parse(res['_body']).data.response[0][0].productosId
                this.guardarGruposProductos(this.productoId)
                this.limpiarProducto()
                this.buscarGruposProductosParaCaja()

                this.startTimerCodigoDeBarras()
            },
            err => {
                // this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
                this.startTimerCodigoDeBarras()
                this.mensajeToast(`No se pudo guardar el producto, intente luego`)
                this.limpiarProducto()
            }
          )
        // }

        })
    }else{
        // this.mostrarMensajeAdvertencia('No se pudo guardar el producto existen campos obligatorios','Verifique')
        this.mensajeToast(`No se pudo guardar el producto existen campos obligatorios`)
        this.limpiarProducto()
    }
    }

    limpiarProducto(){

        this.codigoBarra =""
        this.nombreProducto = ""
        this.codigoProducto = ""
        this.valorVenta = 0
        this.costo = 0
        if(this.manejaCodigoDeBarras){
          this.canvasNoDefinido()
          this.canvasElement.nativeElement.style ="display:none"
        }
        this.formState = 'collapsed'
        this.formStatebool = false
        this.productoId = ""
        this.cantidadRealCodigoBarra = 0
        if(this.manejaCodigoDeBarras){
          this.startTimerCodigoDeBarras()
        }
    }

    searchCodigoBarra(cantidadafn:any,i:any){

         setTimeout(() => {

        if(cantidadafn['value']!==""){
            this.codigoBarra = cantidadafn['value']

        }else{
            cantidadafn['value'] = ""
            return
        }
         if(this.codigoBarra===""){
             return false
         }


        this.storage.get('companiasId').then((val) => {
            if(!MODO_DESCONECTADO){
                this.servicioCompania.buscarCodigoBarra(val,this.codigoBarra)
                .debounceTime(3000)
                .subscribe((data)=>{


                    if(NUBE_AWS){
                      let items = JSON.parse(data['_body']).data[0]

                      if(items.length){

                        let valores = items[0]
                        // || items[0].codigoBarra !== ""
                        if(this.codigoBarra !== ""){
                          // this.codigoBarra = items[0].codigoBarra
                          this.aumentarUnProductoCodigoBarra(valores)
                        }
                        this.codigoBarra = ""

                    }else{
                        this.formState = 'expanded'
                        this.formStatebool = true
                        this.cargarGrupos()
                    }
                  } else {
                    if(data[0].length){

                      let valores = data[0][0]
                      //valores['cantidad'] = 0
                      if(this.codigoBarra !== ""){
                        this.aumentarUnProductoCodigoBarra(valores)
                      }
                      this.codigoBarra = ""

                  }else{
                      this.formState = 'expanded'
                      this.formStatebool = true
                      this.cargarGrupos()
                  }
                  }

                },(error)=>{
                  this.startTimerCodigoDeBarras()
                    console.log(error)
                })}else{
                    this.formState = 'expanded'
                    this.formStatebool = true
                    this.llenarGruposProductosDesconect()
                }

          });
        }, 1000);
      }




      aumentarUnProductoCodigoBarra(item:any){
        if(this.sobreGiroEnLosProductos) {
          let existenciasActuales = Number(item.existenciasActuales)
          let cantidadActual = 0
          let nuevaCantidadProductos = this.listaProductosSeleccionados.filter((value)=> value.productosId == item.productosId)
          if(nuevaCantidadProductos.length>0) {item['cantidad']
            cantidadActual = nuevaCantidadProductos[0].cantidad
            cantidadActual = cantidadActual + 1
          } else {
            cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
            cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1
          }

          if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
            this.utils.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
            return
          }
        }
        this.cantidadRealCodigoBarra += 1
        let codigoBarra  = Number(item['codigoBarra'])
        let productosId  = Number(item['productosId'])
        let existeProducto = 0
        let posicion = 0
        let existeProductoUnico = 0
        let posicionUnico = 0
        this.realizandoUnaVenta = true
        let itemselectvalorProducto = 0;
        let itemselectvalorImpuesto = 0;
        let itemcantidad = 0;

        for(let i =0;i <this.listaProductos.length;i++){
            if(this.listaProductos[i].productosId == productosId){
              existeProductoUnico = 1
              posicionUnico = i

              item['valorProducto'] = this.listaProductos[i].valorProducto
              item['valorImpuesto'] = this.listaProductos[i].valorImpuesto
              i = this.listaProductos.length + 1
            }
          }

        for(let i =0;i <this.listaProductosSeleccionados.length;i++){
          if(this.listaProductosSeleccionados[i].productosId == productosId){

            itemselectvalorProducto = this.listaProductosSeleccionados[i].valorProducto
            itemselectvalorImpuesto = this.listaProductosSeleccionados[i].valorImpuesto
            itemcantidad = this.listaProductosSeleccionados[i].cantidad + 1
            existeProducto = 1
            posicion = i
            i = this.listaProductosSeleccionados.length + 1
          }
        }

        if(existeProducto == 0){

            item['cantidad'] = 1
            this.listaProductosSeleccionados.unshift(item)
            item['tipoProducto'] = 'P'
            let valorTotalVentaNum = 0
            valorTotalVentaNum = Number(this.valorTotalVenta) +  Number(item['valorVenta'])
            this.valorTotalVenta = valorTotalVentaNum

            let valorTotalProductosNum = 0
            item['valorProducto'] = Number(item['valorVenta']) - Number(item['valorImpuesto'])
            valorTotalProductosNum = Number(this.valorTotalProductos) +  Number(item['valorProducto'])
            this.valorTotalProductos = valorTotalProductosNum
            let valorTotalImpuestosNum =  0
            valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
            this.valorTotalImpuestos = valorTotalImpuestosNum

            this.valorTotalVenta = valorTotalVentaNum
            this.valorTotalProductos = valorTotalProductosNum
            this.valorTotalImpuestos = valorTotalImpuestosNum

            this.setProductosSelect(this.listaProductosSeleccionados);

         }
        else{

          let nuevaCantidad  = Number(itemcantidad)
          this.listaProductosSeleccionados[posicion]['cantidad'] = nuevaCantidad
          item['tipoProducto'] = 'P'
          let valorTotalVentaNum = 0
          valorTotalVentaNum = Number(this.valorTotalVenta) +  Number(item['valorVenta'])
          this.valorTotalVenta = valorTotalVentaNum

          let valorTotalProductosNum = 0
          item['valorProducto'] = Number(item['valorVenta']) - Number(item['valorImpuesto'])
          valorTotalProductosNum = Number(this.valorTotalProductos) +  Number(itemselectvalorProducto)
          this.valorTotalProductos = valorTotalProductosNum
          let valorTotalImpuestosNum =  0
          valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  Number(itemselectvalorImpuesto)
          this.valorTotalImpuestos = valorTotalImpuestosNum

          this.valorTotalVenta = valorTotalVentaNum
          this.valorTotalProductos = valorTotalProductosNum
          this.valorTotalImpuestos = valorTotalImpuestosNum

          if(item['cantidad']==0){
              return
          }else{
            this.cantidadRealCodigoBarra = 0
          }

        }
      }

      guardarGruposProductos(productosId:any) {

        this.loader = this.loadingCtrl.create({});
        this.loader.present();
        let datosGruposProductos: any = {
          gruposProductosId: this.gruposProductosId,
          tipoProducto:  "P",
          productoId:  productosId,
          queHago: "I",
          nombreTabla: "productosPorGrupos",
          name: "dataDynamicCrud"
        }

        this.storage.get('companiasId').then((val) => {

          datosGruposProductos['companiasId'] = val

            this.guardarProductosPorGrupos(datosGruposProductos)

        });
      }



      async guardarProductosPorGrupos(datos){


        if(MODO_DESCONECTADO){

            // let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos-guardar',datosGruposProductos)

            // let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datos,'c:\\bd','productosPorGrupos')

            // let valoresnuevos = resultado

            let resultado =  await this.apiDesconect.guardarMododesconectadoTodos(datos);

            let a = resultado['_body'];
            let b = JSON.parse(a);
            let resultadoFinal = JSON.parse(b.data);
            let res:any = []
            // Validar si no existe información
            if (!resultadoFinal || resultadoFinal.length === 0) {
              this.utils.mensajeMuestro('Forma de pago','Los datos no se recuperaron...','warning')
            } else {
              res = resultadoFinal
            }


           }else{

        this.servicioProductosPorGruposProvider.guardar(datos)
        .subscribe(
          res => {
              console.log('guardo bien el producto por grupo')
              this.limpiarProducto()
              if (this.loader) {
                this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
              }
              this.buscarGruposProductosParaCaja()
          },
          err => {
        //   this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
        this.mensajeToast(`No se pudo guardar el producto, intente luego`)
          this.limpiarProducto()
          if (this.loader) {
            this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
          }
        }
        )
        }


      }
      cargarGrupos() {
        this.listaGrupos = []

        this.storage.get('companiasId').then((val) => {
         let companiasId = val
        this.servicioProductosPorGruposProvider.buscarGruposCompaniasId(companiasId)
        .subscribe(
          res => {
            this.listaGrupos = res
            if(NUBE_AWS){
              this.listaGrupos  =  JSON.parse(res['_body']).data[0]
            } else {
              this.listaGrupos = res
            }
          },
          err => {
            let alert = this.alertControllers.create({
              title: 'Error',
              subTitle: 'No se pudieron listar los grupos, intente luego',
              buttons: ['Cerrar']
            });
            alert.present();
          }
        )
      })

      }

      cambiarCheckCredito(){
        this.CheckCredito = !this.CheckCredito
      }

      cambiarCheckImprimir(){
        this.CheckImprimir = !this.CheckImprimir
      }



      buscarVentasdiariasCaja(){
        this.storage.get('companiasId').then((val) => {



              this.servicio.buscarVentasdiariasCajaPrincipal(val)
              .subscribe((data)=>{
                if(NUBE_AWS){
                  this.ventasDiarias = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
                } else {
                  this.ventasDiarias = JSON.parse(data['_body'])
                }
              },(error)=>{
                  console.log(error)
              })

          });
      }

      imprimirFacturadia(codigo:any){
        if(this.platform.is('android') || this.platform.is('ios')){
          this.printD(codigo,true,true)
        }else{

          this.storage.get('companiasId').then((val) => {
            let factura:number
            factura = Number(codigo.factura)

            this.servicio.buscarVentasDiarias(factura,val)
            .subscribe((data)=>{
              let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
              if(this.cantidadImpresionesEnCaja == undefined) {
                this.cantidadImpresionesEnCaja = "1"
                console.log('validar this.cantidadImpresionesEnCaja')
              }
              for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
                this.reemprimirReciboDia(response)
              }

            },
            error=>{
              console.log(error)
            })
          })
        }
    }

    devolverFactura(codigo:any){

     this.storage.get('companiasId').then((val) => {
          let factura:number
          factura = Number(codigo.factura)

          this.utils.mensajeConfirmacionDos('Factura','¿Está Seguro de devolver la factura ?','question','Si','No')
     .then((eliminarFactura: boolean) => {
      if (eliminarFactura) {

        this.servicio.devolverVenta(val,factura)
        .subscribe((data)=>{
          this.utils.mensajeMuestro(`Factura`,'Devuelta Exitosamente!','success')
          this.buscarVentasdiariasCaja()
        },
         error=>{
           console.log(error)
         })


      }
      else {
        this.utils.mensajeMuestro('Factura','No se eliminó la factura','warning')
      }
    })

      })
  }


  visualizarDetalleVenta(reciboCaja: any){
    let textoHtmlReciboCaja = reciboCaja.factura

    this.storage.get('companiasId').then((val) => {
      let factura:number
      factura = Number(textoHtmlReciboCaja)

      this.servicio.buscarVentasDiarias(factura,val)
      .subscribe((elReciboDeCaja)=>{
        this.utils.mostrarReciboDeCajaEnPantalla(textoHtmlReciboCaja, elReciboDeCaja)
      },
      error=>{
        console.log(error)
      })
    })
  }

    reemprimirReciboDia(mensaje) {
        let recibo = ''

      // for (let index:any = 0; index < mensaje.length; index++) {
      //   recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
      // }
      for (let index:any = 0; index < mensaje.length; index++) {
        //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
        const textoRecibo = mensaje[index]['reciboCaja'];

        // Comandos ESC/POS para negrita y tamaño de fuente
        const negritaOn = '\x1b\x45\x01'; // Activar negrita
        const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
        const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
        const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
        const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

        if (textoRecibo.includes("TOTAL A PAGAR")) {
          recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
        } else {
          if(textoRecibo.includes("CAMBIO")) {
            recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
          } else {
            recibo += '   ' + textoRecibo + '\n';
          }
        }
      }

        this.servicio.imprimirRecibo(recibo).subscribe(
            res => {

            },
            err => {
              this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

                })
      }


      onEvent(event: string, item: any){
        if (event === 'onTextChange') {

         let valor = this.getItems(this.buscar);
         if(valor){
              item = valor
        }
        }
        }

        getItems(event: any): void {
            if(!this.allItems){
              let valores = this.listaProductos
              this.allItems = valores;
            }
              this.listaProductos = this.allItems.filter((item) => {
                return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
              });

            }


            print(item:any,imagen:boolean,canvas:boolean): void {
                this.storage.get('companiasId').then((companiasId)=>{
                    this.imprimirDataCualquiera(item,companiasId)
                })
            }

            printB(item:any,imagenes:boolean,canvas:boolean): void {
                this.storage.get('companiasId').then((companiasId)=>{
                    this.imprimirData(item,companiasId)
                })
            }

            printC(item:any,imagenes:boolean,canvas:boolean): void {
                let codigo = 0
                let queImprimo = 0

                codigo =  item.codigo
                if(codigo===undefined){
                codigo =  item.factura
                queImprimo = 1
                }


                this.storage.get('companiasId').then((companiasId)=>{
                     this.servicio.imprimirFactura(codigo,companiasId)
                    // this.servicio.imprimirComandaBlue(codigo,companiasId)

                    .subscribe((data)=>{
                    let mensajeafn = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
                    let mensajes = mensajeafn[0]

                    let item = mensajes
                    this.modalPrintCualquieraBlu(item)
                    })
                })

            }


            printD(item:any,imagenes:boolean,canvas:boolean): void {

                let codigo = 0
                let queImprimo = 0

                codigo =  item.codigo
                if(codigo===undefined){
                codigo =  item.factura
                queImprimo = 1
                }


                this.storage.get('companiasId').then((companiasId)=>{
                     this.servicio.imprimirComandaBlue(codigo,companiasId)

                    .subscribe((data)=>{



                    let items = JSON.parse(data['_body']).data
                    this.modalPrintCualquieraBlutooth(items)
                    })
                })

            }

           async imprimirData(mensaje:any,companiasId:any){

                let codigo = 0
                let queImprimo = 0
                codigo =  mensaje.codigo
                if(codigo===undefined){
                codigo =  mensaje.factura
                queImprimo = 1
                }
                let val = companiasId
                let valores

                let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
                if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
                  let imagen = buscarParametrosGeneralesStore.parametrosGenerales[0][0].imagen
                    if(queImprimo==1){

                      this.servicio.imprimirFactura(codigo,val)
                      .subscribe((data)=>{

                      let mensajeafn = JSON.parse(data['_body'])
                      let mensajes = mensajeafn[0]

                      let item = mensajes
                      this.modalPrint(item,imagen,codigo)
                      })
                    }else{
                    this.servicio.imprimirComandasMesas(codigo,val)
                    .subscribe((data)=>{

                        let mensajeafn = JSON.parse(data['_body'])
                        let mensajes = mensajeafn[0]

                        let item = mensajes
                        this.modalPrint(item,imagen,codigo)
                    },
                    )
                  }
                } else {
                    this.servicio.buscarParametrosGenerales(val)
                    .subscribe((data)=>{
                      let imagen = data[0].imagen
                      if(NUBE_AWS) {
                        imagen = JSON.parse(data['_body']).data[0][0].imagen
                      } else {
                        imagen = data[0].imagen
                      }

                    if(queImprimo==1){

                        this.servicio.imprimirFactura(codigo,val)
                        .subscribe((data)=>{

                        let mensajeafn = JSON.parse(data['_body'])
                        let mensajes = mensajeafn[0]

                        let item = mensajes
                        this.modalPrint(item,imagen,codigo)

                        },
                    )
                    }else{
                    this.servicio.imprimirComandasMesas(codigo,val)
                    .subscribe((data)=>{

                        let mensajeafn = JSON.parse(data['_body'])
                        let mensajes = mensajeafn[0]

                        let item = mensajes
                        this.modalPrint(item,imagen,codigo)
                    },
                    )}

                    })

              }

            }

            async imprimirDataCualquiera(mensaje:any,companiasId:any){

                let codigo = 0
                let queImprimo = 0
                codigo =  mensaje.codigo
                if(codigo===undefined){
                codigo =  mensaje.factura
                queImprimo = 1
                }
                let val = companiasId
                let valores
                let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
                if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
                  this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
                  let imagen = buscarParametrosGeneralesStore.parametrosGenerales[0][0].imagen
                    if(queImprimo==1){

                      this.servicio.imprimirFactura(codigo,val)
                      .subscribe((data)=>{
                      // let mensajeafn = NUBE_AWS ? JSON.parse(data['_body'])[0] : JSON.parse(data['_body'])
                      let mensajeafn = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
                      let mensajes = mensajeafn[0]

                      let item = mensajes
                      this.modalPrintCualquiera(item,imagen,codigo)

                      },
                  )
                  }else{
                  this.servicio.imprimirComandasMesas(codigo,val)
                  .subscribe((data)=>{

                      let mensajeafn = JSON.parse(data['_body'])
                      let mensajes = mensajeafn[0]

                      let item = mensajes
                      this.modalPrintCualquiera(item,imagen,codigo)
                  },
                  )}
                } else {
                this.servicio.buscarParametrosGenerales(val)
                .subscribe((data)=>{
                let imagen = ''
                if(NUBE_AWS) {
                  imagen = JSON.parse(data['_body']).data[0][0].imagen
                } else {
                  imagen = data[0].imagen
                }
                if(queImprimo==1){

                    this.servicio.imprimirFactura(codigo,val)
                    .subscribe((data)=>{
                    // let mensajeafn = NUBE_AWS ? JSON.parse(data['_body'])[0] : JSON.parse(data['_body'])
                    let mensajeafn = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
                    let mensajes = mensajeafn[0]

                    let item = mensajes
                    this.modalPrintCualquiera(item,imagen,codigo)

                    },
                )
                }else{
                this.servicio.imprimirComandasMesas(codigo,val)
                .subscribe((data)=>{

                    let mensajeafn = JSON.parse(data['_body'])
                    let mensajes = mensajeafn[0]

                    let item = mensajes
                    this.modalPrintCualquiera(item,imagen,codigo)
                },
                )}

                })
              }

            }



            modalPrint(item:any,imagen:any,codigo:any){
                let modal = this.modalControllers.create(ImpresoraBluetoothPage,{ item, imagen,codigo})
                modal.present();

                modal.onDidDismiss(data => {
                  if (data) {
                    data.name = ""
                    }
                })
            }
            modalPrintCualquiera(item:any,imagen:any,codigo:any){
                let modal = this.modalControllers.create(ImprimirPage,{ item, imagen,codigo})
                modal.present();

                modal.onDidDismiss(data => {
                  if (data) {
                    data.name = ""
                    }
                })
            }

            modalPrintCualquieraBlutooth(item:any){

              this.guardarBlutooth(item)
          }

          guardarBlutooth(item: any) {
            const datos = {
              "nombre": JSON.stringify(item)
              }
            this.descargarArchivo(datos)
          }

            modalPrintCualquieraBlu(item:any){

                this.guardarBlu(item)
            }

            guardarBlu(item:any){
                this.imprimirC(item)
                .subscribe((data)=>{
                  this.descargarArchivo(data['_body'])
                })
              }

            imprimirC(item:any) {

                let url = NUBE_AWS ? 'http://localhost:4001' : URL_SERVICIOS_LOCALES;
                const datos = {
                  "nombre": JSON.stringify(item)
                  }
                  let headers = new Headers({
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + this.token
                })

                let options = new RequestOptions({
                    headers: headers
                })



                return this.http.post(`${url}/blue`,datos,options)
                .map((data) => data)

              }

              descargarArchivo(data:any){

                let item = data

               let modal = this.modalControllers.create(ImpresoraBluePage,{item})
                modal.present();

                modal.onDidDismiss(data => {
                    this.limpiarImpresion()
                    this.cancelarVenta()
                    this.reiniciarValores()
                  if (data) {
                    data.name = ""
                    }
                })

            }



            productosAgrupados () {

                this.storage.get('companiasId').then((val) => {

                    this.servicio.productosAgrupados(val).subscribe(
                        res => {
                            this.listaABC = res[0]
                        })

                    })
                }

                mensajeToast(mensaje: string) {
                    let item =    {
                        "duration": 1000,
                        "position": "buttom"
                      }
                      item["message"] = mensaje;
                    let toast = this.toastControllers.create(item);
                    toast.present();
                  }

                  limpiarPorcentajeServicio(){
                    this.CheckPorcentajeServicio = true
                    this.porcentajeServicioValorPedidosSalon = 'N'
                    this.cambiarCheckPorcentajeServicio()
                }

                cambiarCheckPorcentajeServicio(){
                    this.CheckPorcentajeServicio = !this.CheckPorcentajeServicio

                    if(this.valorTotalVenta>0 && this.CheckPorcentajeServicio){
                        this.valorTotalVenta = this.calcularServicio(this.valorTotalProductos + this.valorTotalImpuestos)
                    }
                  }

                  calcularServicio(valorTotalProductos:any){
                    if(this.CheckPorcentajeServicio){

                        let porcentaje = valorTotalProductos * 10 / 100
                        this.valorTotalServicio = porcentaje
                        valorTotalProductos = valorTotalProductos + porcentaje
                        this.CheckPorcentajeServicio = false
                       }else{
                        this.limpiarPorcentajeServicio()
                       }
                    return valorTotalProductos
                  }


                  valoresSelectPorcentaje(data:string){

                    if(data['valor'] === "S"){
                    //   this.cambiarCheckPorcentaje(this.valorTotalProductos + this.valorTotalImpuestos)
                    this.cambiarCheckPorcentaje(this.valorTotalProductos,this.valorTotalProductos + this.valorTotalImpuestos)
                    }else {

                      this.valorTotalServicio = 0
                      this.valorTotalVenta =  this.valorTotalProductos + this.valorTotalImpuestos
                    }
                  }

                  cambiarCheckPorcentaje(valorTotalProductos:any,valorNuevo:any){

                        if(this.porcentajeServicioValor['valor'] =="S"){

                          let cantidad = this.listaProductosSeleccionados.length
                          let valorProducto = 0
                          let valorVenta = 0
                          let valorImpuesto = 0
                          this.listaProductosSeleccionados.forEach((data,item)=>{
                           valorProducto+= data.valorVenta * data.cantidad
                            valorImpuesto+= data.valorImpuesto
                            if(cantidad === item + 1){

                              let porcentaje = valorProducto * 10 / 100
                              this.valorTotalServicio = porcentaje
                              this.valorTotalVenta = valorProducto + this.valorTotalServicio
                            }

                          })
                      }
                    }

                    valoresSelectCantidadImpresiones(data:string){
                      this.cantidadImpresionesEnCaja = data
                    }

                    cambioEnSeleccionFormaDePago(data:string){
                      this.formaPagoSeleccionada = data
                    }

                    ProductosDinamicos(item:any,i:any){
                      let items = item



                      let id = `{"id":${items.productosId}}`
                      this.storage.set('idProductoDinamico',id)
                      // this.listaProductosSeleccionados.splice(i, 1);
                      this.storage.get('datosDinamicos').then((data)=>{
                        if(data){
                          let productosId = items.productosId

                          let dataArray = []
                          let itemArray = JSON.parse(data)
                          for(let y=0;y<itemArray.length;y++){
                            if(itemArray[y].productosElaboradosId === productosId){


                            dataArray.push({
                                cantidad:itemArray[y].cantidad,
                                imagen:itemArray[y].imagen,
                                imagenLocal:itemArray[y].imagenLocal,
                                nombreProducto:itemArray[y].nombreProducto,
                                productosId:itemArray[y].productosId,
                                productosElaboradosId:itemArray[y].productosElaboradosId,
                                tipoProducto:'E',
                                valorImpuesto:itemArray[y].valorImpuesto,
                                valorProducto:itemArray[y].valorProducto,
                                valorVenta:itemArray[y].valorVenta,
                                valorImpuestoCalculo:itemArray[y].valorImpuestoCalculo
                            })
                          }
                        }

                          let valoresReales = JSON.stringify(dataArray)
                          this.storage.set('ProductoDinamicoItemSinModificar',valoresReales)

                          this.storage.set('productoAnterior',items)

                          this.navCtrl.push('ProductoDinamicoPage');
                        }
                      })


                    }

                    ionViewCanEnter(){
                      let manejaCajaDinamica = this.manejaCajaDinamica
                      if(manejaCajaDinamica){
                        this.storage.get('productosElaboradosContenidoDinamicoReemplazar').then((val) => {
                          if(val){

                            let data = val
                            let valoresJson = JSON.parse(data)

                            let item = this.listaProductosSeleccionados
                            if(item.length>0){
                              this.valorTotalVenta = 0
                              this.valorTotalProductos = 0
                              this.valorTotalImpuestos = 0
                            }
                            for(var i =0 ; i< item.length;i++){

                              if(item[i].productosId === valoresJson.productosElaboradosId && item[i].tipoProducto === "E"){

                                   let valorTotalVentaNum =  0
                                   let valorTotalProductosNum =  0
                                   let valorTotalImpuestosNum =  0
                                   this.valorTotalVenta = this.valorTotalVenta + Number(valoresJson.TotalVenta)
                                  this.valorTotalProductos = this.valorTotalProductos + Number(valoresJson.totalProducto)
                                  this.valorTotalImpuestos = Number(this.valorTotalImpuestos)  + valoresJson.valorImpuesto

                                   this.listaProductosSeleccionados[i].valorVenta = valoresJson.TotalVenta / valoresJson.cantidadInicial
                                   this.listaProductosSeleccionados[i].valorImpuesto = valoresJson.valorImpuesto
                                   this.listaProductosSeleccionados[i].valorProducto = valoresJson.totalProducto
                                   this.listaProductosSeleccionados[i].color = "#59595B"
                                   this.listaProductosSeleccionados[i]['productosElaboradosDinamicosId'] =  valoresJson.productosElaboradosDinamicosId

                              } else {

                                this.valorTotalVenta = item[i].productosElaboradosDinamicosId !== undefined ? this.valorTotalVenta + Number(item[i].valorVenta) * item[i].cantidad : this.valorTotalVenta + Number(item[i].valorVenta)
                                this.valorTotalProductos = this.valorTotalProductos + Number(item[i].valorProducto)
                                this.valorTotalImpuestos = Number(this.valorTotalImpuestos)  + item[i].valorImpuesto


                              }

                            }


                          }
                       })
                      }
                    }


    cambiarEstadoProductoDinamico(id:any,index:any) {
      let posicion = index
      this.servicioCompania.devolverVarios(['usuariosId','companiasId'])
      .then((val)=>{
        if(val){
          let companiasId = val['companiasId']
          this.servicio.cancelarProductosElaboradosDinamicos(companiasId,id,posicion)
          .subscribe((data)=>{
            var valorDevolvio = JSON.parse(data['_body'])
            var dataNueva = valorDevolvio[0][0]
            let posicion = dataNueva.posicion
            let TotalVenta = dataNueva.TotalVenta
            let valorImpuesto = dataNueva.valorImpuesto

            let productosElaboradosId = dataNueva.productosElaboradosId
            let dataProducto = this.listaProductos
            for(let i = 0; i < dataProducto.length;i++) {
              if(dataProducto[i].tipoProducto ==="E"){
                if(productosElaboradosId===dataProducto[i].productosId){

                  this.listaProductos[i].valorProducto = TotalVenta - valorImpuesto
                  this.listaProductos[i].valorImpuesto = valorImpuesto
                  this.listaProductos[i].valorVenta = TotalVenta
                  this.listaProductos[i].productosElaboradosDinamicosId = undefined
                  this.listaProductos[i].cantidad = 1
                }
              }
            }
            // console.log(data);
          })
        }
       }
      )

    }


    devolverValoresCajaDinamica(){
      return new Promise((resolve, reject) => {
        let manejaCajaDinamica = this.manejaCajaDinamica

        if(manejaCajaDinamica){

          if(this.listaProductosSeleccionados.length>0){

             let producto = ''
             let datos = this.listaProductosSeleccionados

             let dataNue = ''
             let dataNueProductoDinamico = ''
             let posicionReal = ''

             for(let i=0;i < datos.length;i++){
              let id = datos[i].productoid == undefined ? datos[i].productosId : datos[i].productoid;
              if(datos[i]['productosElaboradosDinamicosId']!== undefined){

               producto+= `"producto": {
                "cantidad":${datos[i].cantidad},
                "productosId":${datos[i].productosId}
              },`
               let productosId = datos[i].productoid == undefined ? datos[i].productosId : datos[i].productoid;
               let productosElaboradosDinamicosId = datos[i].productosElaboradosDinamicosId

              var jsoncadena = producto;
              jsoncadena = jsoncadena.substr(jsoncadena.length - 1, 1) == ',' ? jsoncadena.substring(0, jsoncadena.length - 1) : jsoncadena;

              dataNueProductoDinamico+= `{
                "productosElaboradosDinamicosId": ${productosElaboradosDinamicosId}
              },`

              dataNue = `{"productosElaborados":{
                "productosElaboradosId": ${productosId} ,
                ${jsoncadena}}
                `

              } else {
                posicionReal+= `{
                  "id": ${id}
                },`

              }
             }

            var jsondataNueProductoDinamico = dataNueProductoDinamico
            jsondataNueProductoDinamico = jsondataNueProductoDinamico.substr(jsondataNueProductoDinamico.length - 1, 1) == ',' ? jsondataNueProductoDinamico.substring(0, jsondataNueProductoDinamico.length - 1) : jsondataNueProductoDinamico;

            let armarCadenaProductoDinamicoNormal = `[${jsondataNueProductoDinamico}]`

             let jsonposicionReal = posicionReal
             jsonposicionReal =  jsonposicionReal.substr(jsonposicionReal.length - 1, 1) == ',' ? jsonposicionReal.substring(0, jsonposicionReal.length - 1) : jsonposicionReal;

             let jsonArrayposicionRealCadena = jsonposicionReal
             let jsonArrayp = `[${jsonArrayposicionRealCadena}]`
             let jsonArrayposicionReal = JSON.parse(jsonArrayp)


             let resultadoFinal = []

             for (let i = 0; i < this.listaProductosSeleccionados.length; i++) {
               for(let k = 0; k < jsonArrayposicionReal.length;k++) {
                if (this.listaProductosSeleccionados[i].productosId == jsonArrayposicionReal[k].id) {

                  resultadoFinal.push({
                    cantidad:this.listaProductosSeleccionados[i].cantidad,
                    color:this.listaProductosSeleccionados[i].color,
                    existenciasActuales:this.listaProductosSeleccionados[i].existenciasActuales,
                    gruposProductosId:this.listaProductosSeleccionados[i].gruposProductosId,
                    imagen:this.listaProductosSeleccionados[i].imagen,
                    imagenLocal:this.listaProductosSeleccionados[i].imagenLocal,
                    nombreContenedor:this.listaProductosSeleccionados[i].nombreContenedor,
                    nombreProducto:this.listaProductosSeleccionados[i].nombreProducto,
                    nombreUbicacion:this.listaProductosSeleccionados[i].nombreUbicacion,
                    productosId:this.listaProductosSeleccionados[i].productosId,
                    tipoProducto:this.listaProductosSeleccionados[i].tipoProducto,
                    valorImpuesto:this.listaProductosSeleccionados[i].valorImpuesto ,
                    valorImpuestoCalculo:this.listaProductosSeleccionados[i].valorImpuestoCalculo,
                    valorProducto:this.listaProductosSeleccionados[i].valorProducto ,
                    valorVenta:this.listaProductosSeleccionados[i].valorVenta
                  })
                } else {
                  resultadoFinal.push({
                    cantidad:this.listaProductosSeleccionados[i].cantidad,
                    color:this.listaProductosSeleccionados[i].color,
                    existenciasActuales:this.listaProductosSeleccionados[i].existenciasActuales,
                    gruposProductosId:this.listaProductosSeleccionados[i].gruposProductosId,
                    imagen:this.listaProductosSeleccionados[i].imagen,
                    imagenLocal:this.listaProductosSeleccionados[i].imagenLocal,
                    nombreContenedor:this.listaProductosSeleccionados[i].nombreContenedor,
                    nombreProducto:this.listaProductosSeleccionados[i].nombreProducto,
                    nombreUbicacion:this.listaProductosSeleccionados[i].nombreUbicacion,
                    productosElaboradosDinamicosId:this.listaProductosSeleccionados[i].productosElaboradosDinamicosId,
                    productosId:this.listaProductosSeleccionados[i].productosId,
                    tipoProducto:this.listaProductosSeleccionados[i].tipoProducto,
                    valorImpuesto:this.listaProductosSeleccionados[i].valorImpuesto / this.listaProductosSeleccionados[i].cantidad,
                    valorImpuestoCalculo:this.listaProductosSeleccionados[i].valorImpuestoCalculo,
                    valorProducto:this.listaProductosSeleccionados[i].valorProducto / this.listaProductosSeleccionados[i].cantidad,
                    valorVenta:this.listaProductosSeleccionados[i].valorVenta
                  })
                }
               }
             }

             this.listaProductosSeleccionados = resultadoFinal
             this.setProductosSelect(this.listaProductosSeleccionados);

            this.servicio.BuscarProductosElaboradosDinamicosArmarDataAguardar(armarCadenaProductoDinamicoNormal)
            .subscribe((data)=>{
              let dataNuevaCadenaRealDevolver = ''
              var valorDevolvio = JSON.parse(data['_body'])
              var dataNueva = valorDevolvio[0]
              let productosElaboradosdinamicosIdArray = []
              let cadenaInicial = ''
              console.log('entro a caja dinámica')
              if(dataNueva.length>0){
                for(let i = 0; i < dataNueva.length;i++){
                  if(productosElaboradosdinamicosIdArray.length>0){
                    let existe = 0
                    for(let k = 0;k < productosElaboradosdinamicosIdArray.length;k++){
                      if(dataNueva[i].productosElaboradosdinamicosId == productosElaboradosdinamicosIdArray[k].productosElaboradosdinamicosId){
                        existe = 1
                      }
                      if(k + 1 == productosElaboradosdinamicosIdArray.length){
                        if(existe == 0){
                          productosElaboradosdinamicosIdArray.push({
                            "productosElaboradosdinamicosId":dataNueva[i].productosElaboradosdinamicosId
                          })
                        }
                      }
                    }
                  }else {
                    productosElaboradosdinamicosIdArray.push({
                      "productosElaboradosdinamicosId":dataNueva[i].productosElaboradosdinamicosId
                    })
                  }
                }
                let cadenaRealDevolver = ''
                let jsoncadenaRealDevolver = ''
                let jsoncadenaInicial = ''
                let dataNue = ''
                for(let y = 0; y < productosElaboradosdinamicosIdArray.length;y++){
                  cadenaInicial = ''


                  for(let z = 0; z < dataNueva.length;z++){

                    if(dataNueva[z].productosElaboradosdinamicosId == productosElaboradosdinamicosIdArray[y].productosElaboradosdinamicosId){

                      cadenaInicial+= `"producto": {
                        "cantidad":${dataNueva[z].cantidad},
                        "productosId":${dataNueva[z].productosId}
                      },`
                    }
                    if(z + 1 == dataNueva.length) {
                      jsoncadenaInicial = cadenaInicial
                      jsoncadenaInicial =  jsoncadenaInicial.substr(jsoncadenaInicial.length - 1, 1) == ',' ? jsoncadenaInicial.substring(0, jsoncadenaInicial.length - 1) : jsoncadenaInicial;

                      dataNue = `{"productosElaborados":{
                          "productosElaboradosId": ${productosElaboradosdinamicosIdArray[y].productosElaboradosdinamicosId} ,
                          ${jsoncadenaInicial}}}`
                    }
                  }

                    cadenaRealDevolver+= `${dataNue},`
                    dataNue = ''


                  if(y + 1 == productosElaboradosdinamicosIdArray.length) {

                    jsoncadenaRealDevolver = cadenaRealDevolver == '' ? `${dataNue},` : cadenaRealDevolver
                    jsoncadenaRealDevolver =  jsoncadenaRealDevolver.substr(jsoncadenaRealDevolver.length - 1, 1) == ',' ? jsoncadenaRealDevolver.substring(0, jsoncadenaRealDevolver.length - 1) : jsoncadenaRealDevolver;

                    dataNuevaCadenaRealDevolver = `[${jsoncadenaRealDevolver}]`

                  }
               }

              }

              let dataReal = dataNuevaCadenaRealDevolver

              resolve(dataReal)
            }, (error)=>{

              let datos = []
              reject(datos)
              console.log(error)
            })

            }else{
              let alert = this.alertControllers.create({
                title: 'Advertencia',
                subTitle: 'Debe seleccionar un producto, verifique',
                buttons: ['Cerrar']
              });
              alert.present();
              let data = []
              resolve(data)
            }
          }else {
            resolve('')
          }

      });
    }

    buscarClientes(companiasId) {
      this.servicio.buscarClientesPorCompaniaAll(companiasId)
      .subscribe((data: any)=>{
        let clientes: any = data;
        this.listaClientes = clientes;
      })
    }


    limpiarNombreCliente() {
      this.valoresCliente = ''
    }

    buscarClienteSelect() {
      let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          this.clienteId = []
          this.clienteId.push({value:data.value, display:data.display})
          let cliente: valueDisplay[] = [{
            value:data.value,
            display:data.display
          }]
          // const actionClienteCaja = new fromData.CargarValueDisplaySuccessActions(cliente);
          const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
          this.store.dispatch(actionClienteCaja);
          this.valoresCliente =  data.display;
        }
      })
    }

    async buscarClienteStore() {
     return new Promise((resolve, reject) => {
        this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
          return resolve(clientecaja)
        })
      });
    }

    resetStore() {
      const actionClienteCaja = new fromData.CargarValueDisplaySuccessActions([]);
      this.store.dispatch(actionClienteCaja);
    }
    async abrirWhatsApp(item){
      this.storage.get('companiasId').then((companiasId)=>{
        this.servicio.imprimirComandaBlue(item.factura,companiasId)

       .subscribe(async (data)=>{



       let items = JSON.parse(data['_body']).data
       if(items){
        let dataImprimir = JSON.stringify(items[0])
        let clienteCaja = await this.buscarClienteStore();
        let numeroTelefono = ''

        if(clienteCaja['valuedisplay'] !== undefined && clienteCaja['valuedisplay'][0] !== undefined && clienteCaja['valuedisplay'][0].value !== undefined){
          let displaSplit = clienteCaja['valuedisplay'][0].display.split('-')
          numeroTelefono = displaSplit[1]
          numeroTelefono = numeroTelefono.trim()
        }

        let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: dataImprimir, numeroTelefono: numeroTelefono, espacios: false }
          )
        modal.present();

        modal.onDidDismiss(data => {
          if (data) {
          }
        })
      }
       })
   })
    }

    actualizarPrecioProducto() {
      let modal = this.modalControllers.create(GestionCambioPrecioPorProductoPage, { data: this.listaProductosSeleccionados,
        valorTotalVenta: this.valorTotalVenta,
        cambiarPrecioEnLosProductos: this.cambiarPrecioEnLosProductos,
        refactorizarPedidosSalon: this.refactorizarPedidosSalon}
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          let valorImpuesto = 0
          let valorProducto = 0
          let valorTotalVenta = 0
          for(let k = 0;k < data[0].length;k++){
            valorTotalVenta += Number(data[0][k].valorTotalVenta)
            valorImpuesto += Number(data[0][k]['valorImpuesto']) * Number(data[0][k].cantidad)
            valorProducto += Number(data[0][k]['valorProducto']) * Number(data[0][k].cantidad)
            }
            let porcentaje = valorTotalVenta * 10 / 100
            if(this.porcentajeServicioValor === "S") {
              this.valorTotalServicio = porcentaje
              this.valorTotalVenta = valorTotalVenta + porcentaje
            } else {
              this.valorTotalVenta = valorTotalVenta
              this.porcentajeServicioValor = 'N'
            }
            this.valorTotalImpuestos = valorImpuesto
            this.valorTotalProductos = valorProducto
            this.refactorizarPedidosSalon = data[1].refactorizarPedidosSalon
        }
      })
    }

    formatNumber(value: any): string {
      if (typeof value === 'number' && !isNaN(value)) {
        return value.toLocaleString('en-US');
      } else if (typeof value === 'string' && !isNaN(Number(value))) {
        return Number(value).toLocaleString('en-US');
      } else {
        return '0';
      }
    }

    async simulador(item:any,index:any=0) {
      let val = await this.servicioCompania.devolverVariosAsync(['companiasId','usuariosId', 'nombreCargo'])
      let companiasId = 0
      if(val){
        companiasId = val['companiasId'];
      }
      let cupo = 0
      if(this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        let clientesId = this.clienteId[0].value
        let responseSalario = this.servicioCompania.buscarCupo(clientesId,companiasId)
        let response = (await responseSalario).json()
        if(response && response.data && response.data[0].length>0) {
          let valores = response.data[0][0]
          cupo = valores.cupo
          if(valores.cupo < this.valorTotalVenta) {
            let cupoFormateado: any = this.formatNumber(valores.cupo);
            const elCupo = valores.cupo;
            let elCupoFormateado = cupoFormateado.toLocaleString('en-US');
            const valorTotalVentaFormateado = this.valorTotalVenta.toLocaleString('en-US');
            const diferencia = this.valorTotalVenta - elCupo;
            const diferenciaFormateada = this.formatNumber(diferencia);

            this.utils.mensajeMuestro(
              'Simulador',
              `El cupo aprobado: ${elCupoFormateado} es inferior al total de la venta: ${valorTotalVentaFormateado}. La diferencia es: ${diferenciaFormateada}`,
              'warning'
            );
            return
          }
        }
      }


      let modal = this.modalControllers.create(SimuladorCuentasPorCobrarPage, { data: this.listaProductosSeleccionados,
        valorTotalVenta: this.valorTotalVenta,
        clienteId: this.clienteId,
        companiasId:companiasId,
        index:index,
        cupo:cupo,
        interesesCorrientesVisualizarPlanDePagos:this.interesesCorrientesVisualizarPlanDePagos,
        interesesMoraVisualizarPlanDePagos:this.interesesMoraVisualizarPlanDePagos,
        capitalAtrasadoVisualizarPlanDePagos:this.capitalAtrasadoVisualizarPlanDePagos,
        costosAdicionalesVisualizarPlanDePagos:this.costosAdicionalesVisualizarPlanDePagos,
        fechaVisualizarPlanDePagos:this.fechaVisualizarPlanDePagos,
        visualizaDiaDePago:this.visualizaDiaDePago,
        visualizaExonerarInteresPrimeraCuota:this.visualizaExonerarInteresPrimeraCuota,
        visualizaNumeroDeCuotasExoneradas:this.visualizaNumeroDeCuotasExoneradas,
        montoDeLaCuota:this.montoDeLaCuota,
        montoDeLaCuotaConCostosEintereses:this.montoDeLaCuotaConCostosEintereses,
        cuantoRestaEnLaCuota:this.cuantoRestaEnLaCuota,
      }, {
        cssClass: 'fullscreen-modal',
        enableBackdropDismiss: true
      }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          if(data !== undefined && data[0] !== undefined && data[0].planDePagos.length > 0) {
            let planDePagos:any[] = []
            planDePagos = data[0].planDePagos
            this.manejaInteresCreditos = data[0].manejaInteresCreditos
            let datosAdicionalesCreditos  = data[0].datosAdicionalesCreditos
            this.guardarPlanDePagosEnCuentasPorCobrarSimulador = true
            this.gestionarSimuladorCuotasExtras = planDePagos
            this.valorTotalDevolver = data[0].valorTotal
            this.valorTotalVenta = data[0].valorTotal
            this.listaProductosSeleccionados = data[0].listaProductosSeleccionados
            let costosAdicionalesHeaders = []
            if (this.manejaInteresCreditos) {
              this.gestionarSimuladorCuotasExtras = []
              planDePagos = this.convertKeysToLowerCase(planDePagos);
              costosAdicionalesHeaders = data[0].costosAdicionalesHeaders
              let costosAdicionales = this.convertKeysToLowerCase(costosAdicionalesHeaders)
              this.planDePagosCreditoCompleto = {
                "planDePagosCreditoCompleto" : {
                  "planPagosCapitalInteres" :planDePagos,
                  "planPagosCostosAdicionales": costosAdicionales,
                  "datosAdicionalesCreditos": datosAdicionalesCreditos
                }
              }
              this.planSepare = datosAdicionalesCreditos.length > 0 ? datosAdicionalesCreditos[0].planSepare : 'N'
            }
            this.pagar()
          }
        }
      })
    }

    convertKeysToLowerCase(array) {
      return array.map(obj => {
          const newObj = {};
          for (let key in obj) {
              if (obj.hasOwnProperty(key)) {
                  newObj[key.toLowerCase()] = obj[key];
              }
          }
          return newObj;
      });
  }

    actualizarCliente(item: any) {
      console.log('actualizar cliente' + item.toString())
      let modal = this.modalControllers.create(ClientesVentasComponent, {
        item: item
        }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          console.log('data', data)


        }
      })
    }

    facturasGeneradas() {
      if(this.poselectronico === true) {
        this.poselectronico = false
      } else {
        this.poselectronico = false
        let modal = this.modalControllers.create(FacturaSelectComponent, { data: this.listaClientes }, {
          cssClass: 'fullscreen-modal',
          enableBackdropDismiss: true
        }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {

        }
      })
      }
    }

    async enviarcomandasUtils(listaProductosSeleccionados) {
      this.utils.mensajeConfirmacionDos('Guardar turno','¿Está Seguro de guardar este turno. Si desea atender otro cliente puede guardar un turno, esto le permite hacer otras ventas y volver a este turno en otro momento ?','question','Si','No')
      .then(async (guardandoTurno: boolean) => {
        if (guardandoTurno) {
          let cliente = 0
          // saber si tiene cliente seleccionado
          if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
           // envia el cliente que este seleccionado
           let clienteCaja = await this.buscarClienteStore();
           cliente = clienteCaja['valuedisplay'][0].value
       } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {
           // si tiene un cliente generico seleccionado
           cliente = this.clienteGenerico[0]['clientesId']
       } else {
           // envia un cliente null
           cliente = 0
       }
       let valoresTurno = await this.cargarTurnoAsync(cliente, 0, listaProductosSeleccionados[0]);
       if(valoresTurno.companiasId !== 0) {
         let valorTotalVenta = 0
         for(var k = 0;k < listaProductosSeleccionados.length;k++){
           valorTotalVenta += Number(listaProductosSeleccionados[k].valorVenta) * Number(listaProductosSeleccionados[k].cantidad)
         }
        let response: any = await this.utils.enviarcomandasUtils(valorTotalVenta,this.valorTotalDevolver,
           valoresTurno.usuariosId,valoresTurno.companiasId,false,cliente,listaProductosSeleccionados,
           valoresTurno.turno,this.CheckPorcentajeServicio,this.formaPagoSeleccionada,false
         )
         if(response.length>0) {
           let turnoNuevo = response[1] != undefined &&
           response[1][0] !== undefined && response[1][0].turno !== undefined ? response[1][0].turno : ''

           this.utils.mensajeMuestro('Guardar turno','se guardo el turno # ' + turnoNuevo ,'success')

           this.cancelarVenta()
           this.reiniciarValores()
         }
       } else {
         console.log('mensaje no existe info para guardar el turno')
       }
        }
      })
  }

    async cargarTurnoAsync(clienteId: any, descripcion: any, producto: any) {

      let val = await this.servicioCompania.devolverVariosAsync(['companiasId','usuariosId', 'nombreCargo'])
      if(val){
            let companiasId = val['companiasId'];
            let usuariosId = val['usuariosId'];
            let items = await this.servicio.getComandasVacioAsync(companiasId, usuariosId, clienteId, descripcion)
            if(items) {
              let valoresTurnos = JSON.parse(items['_body'])
              let valoresNuevoTurno = valoresTurnos.data[0][0]
              valoresNuevoTurno.usuariosId = usuariosId
              valoresNuevoTurno.companiasId = companiasId
              return valoresNuevoTurno
            }
          }
          return {
            usuariosId : 0
          }
      }

      descuento() {
        this.CheckDescuento = !this.CheckDescuento
      }

      cambiarCheckDescuento(){
        this.CheckDescuento = !this.CheckDescuento
      }
      async presentPrompt(): Promise<number> {
        return new Promise<number>((resolve) => {
          let alert = this.alertControllers.create({
            title: 'Ingrese el porcentaje que desea descontar a la venta',
            cssClass: 'custom-alert-title',
            inputs: [
              {
                name: 'value',
                placeholder: '%',
                type: 'number',
                // cssClass: 'custom-alert-input',
              },
            ],
            buttons: [
              {
                text: 'Cancelar',
                role: 'cancel',
                cssClass: 'custom-alert-button-cancel',  // Clase personalizada para el botón cancelar
                handler: () => {
                  console.log('Cancel clicked');
                  resolve(null);
                }
              },
              {
                text: 'Aceptar',
                cssClass: 'custom-alert-button-accept',  // Clase personalizada para el botón aceptar
                handler: data => {
                  resolve(Number(data.value));
                }
              }
            ]
          });

          // Presentar la alerta y aplicar estilos después de que se renderice
          alert.present().then(() => {
            let alertElement = document.querySelector('ion-alert');
            if (alertElement) {
              alertElement.classList.add('custom-alert-wrapper');
            }
          });
        });
      }

      async recalcularValorDeLosProductosSeleccionados(items: any[],porcentajeDescuento: number){

      items.forEach(item => {
          let valorProducto = item.valorImpuesto != 0 ?
          (item.valorProducto + item.valorImpuesto) : item.valorProducto
          let valorDescuento = valorProducto * (porcentajeDescuento / 100)
          item.valorProducto = valorProducto

          let valorProductoUnitario = item.valorProducto - valorDescuento
          let valorTotalProducto = (valorProducto - valorDescuento) * item.cantidad;
          let valorImpuestoRecalculado = (valorTotalProducto ) * (porcentajeDescuento / 100);
          item.valorImpuestoRecalculado = valorImpuestoRecalculado
          item.valorImpuesto =  item.valorProducto * (item.valorImpuestoCalculo / 100)
          item.valorProducto = valorProductoUnitario - item.valorImpuesto
          item.valorVenta = valorProductoUnitario + valorDescuento;
          item.porcentajeDescuento = porcentajeDescuento
      });

      return items;
    }
    openFormaPagoPopover(formasDePago) {
      let popover = this.popoverCtrl.create(FormaPagoPopoverComponent, { formasDePago: formasDePago });
      popover.present({
        ev: formasDePago
      });

      popover.onDidDismiss((data) => {
        if (data) {
          this.formaPagoSeleccionada = data.valor;
          this.formaPagoSeleccionadaNombre = data.nombre;
        }
      });
    }

    imprimirGlobal(text:any) {
      let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: text,
        queHago:'imprimirFacturadia',
        cantidadImpresionesEnCaja: this.cantidadImpresionesEnCaja,
        ip:this.ip
      });
      popover.present({
        ev: text
      });

      popover.onDidDismiss((data) => {
        if (data) {

          console.log(data);
        }
      });
    }


    dividirFactura(lista:any) {
      const permiteEliminarPedido= 1;
      const valorTotalVenta= 0;
      const  devolverVenta= 0;
      const  mesaCambio= 0;
      const  turnosArray= [];
      const mesaSeleccionada= 0;
      const descripcion= "";

      const message = {
        type: 'MESSAGE_FROM_IONIC3',
        data: JSON.stringify(lista),
        permiteEliminarPedido,
        valorTotalVenta,
        devolverVenta,
        mesaCambio,
        turnosArray,
        mesaSeleccionada,
        descripcion,
        creaVentaDesdePedidosSalon:this.creaVentaDesdePedidosSalon,
        controlaImpresorasEnRed:this.controlaImpresorasEnRed
      };
        // let url = URL_REDIRECT_IONIC7
        let url = 'http://localhost:4200'
        const jsonData = encodeURIComponent(JSON.stringify(message));
        window.location.href = `${url}?data=${jsonData}`;
    }

    async actualizarPrecioDatosAdicionales(item:any, general:any = undefined) {
      event.stopPropagation();
      let valoresNuevosCampos = []
      let productosId = undefined
      let tipoProducto = undefined
      let nombreProducto = undefined
      if(item == undefined && general === 'G') {
        let companiasId = await localStorage.getItem('companiasId')
        let datosResponse = await this.servicio.buscarProductosCamposAdicionalesCambiarNombre(companiasId)
        let response =  datosResponse.json()
        if(response && response.data && response.data[0].length>0) {
          valoresNuevosCampos = response.data[0]
        } else {
          this.utils.mensajeMuestro('Producto rapido','Debe de agregar un producto que tenga asociado el campo producto rapido, esto le permitirá vender productos cambiandole el nombre y el precio de venta', 'warning')
          return
        }
        productosId = valoresNuevosCampos[0].productosId
        tipoProducto = valoresNuevosCampos[0].tipoProducto
        nombreProducto = valoresNuevosCampos[0].nombreProducto
      } else {
        productosId = item.productosId
        tipoProducto = item.tipoProducto
        nombreProducto = item.nombreProducto
      }

      let modal = this.modalControllers.create(ProductosCamposAdicionalesCambiarValorComponent, { productosId: productosId, tipo: tipoProducto , nombreProducto: nombreProducto,
        data: this.listaProductosSeleccionados,
        valorTotalVenta: this.valorTotalVenta,
        cambiarPrecioEnLosProductos: this.cambiarPrecioEnLosProductos,
        refactorizarPedidosSalon: this.refactorizarPedidosSalon,
        general:general,
        valoresNuevosCampos:valoresNuevosCampos,
        elProducto:item
      }, {
        cssClass: 'fullscreen-modal',
        enableBackdropDismiss: true
    })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {

        let valorImpuesto = 0
        let valorProducto = 0
        let valorTotalVenta = 0
        let valorTotalVentaTemporal = 0
        for(let k = 0;k < data[0].length;k++){

          valorTotalVentaTemporal =  (Number(data[0][k].valorImpuesto) + Number(data[0][k].valorProducto)) * Number(data[0][k].cantidad)
          valorTotalVenta += valorTotalVentaTemporal
          valorTotalVentaTemporal = 0
          valorImpuesto += Number(data[0][k]['valorImpuesto']) * Number(data[0][k].cantidad)
          valorProducto += Number(data[0][k]['valorProducto']) * Number(data[0][k].cantidad)
          this.realizandoUnaVenta = true
        }
          this.setProductosSelect(this.listaProductosSeleccionados);
          let porcentaje = valorTotalVenta * 10 / 100
          if(this.porcentajeServicioValor === "S") {
            this.valorTotalServicio = porcentaje
            this.valorTotalVenta = valorTotalVenta + porcentaje
          } else {
            this.valorTotalVenta = valorTotalVenta
            this.porcentajeServicioValor = 'N'
          }
          this.valorTotalImpuestos = valorImpuesto
          this.valorTotalProductos = valorProducto
          this.refactorizarPedidosSalon = data[1].refactorizarPedidosSalon
      }
    })
    }
    getDatosCreditos(): Promise<any> {
      return new Promise((resolve, reject) => {
        try {
          const datosCreditos = localStorage.getItem('datosCreditos');
          if (datosCreditos) {
            resolve(JSON.parse(datosCreditos)); // Resolver si hay datos
          } else {
            resolve(null); // Resolver como null si no hay datos
          }
        } catch (error) {
          reject(error); // Rechazar en caso de error
        }
      });
    }
  accesosDirectos(ruta:any) {
    switch(ruta){
      case "CuentasPorCobrarCreditosPage":
      this.navCtrl.push(CuentasPorCobrarCreditosPage)
      break;
      case "InteresesCreditosComponent":
      this.navCtrl.push(InteresesCreditosComponent)
      break;
      case "CostosadicionalesPage":
      this.navCtrl.push(CostosadicionalesPage)
      break;
      case "InteresesCreditosPorCostosAdicionalesComponent":
      this.navCtrl.push(InteresesCreditosPorCostosAdicionalesComponent)
      break;
      case "ProductosRapidosComponent":
      this.navCtrl.push(ProductosRapidosComponent)
      break;
      case "ClientesPage":
      this.navCtrl.push(ClientesPage)
      break;
      case "CuadreCajaDiarioValoresPorDenominacionPage":
      this.navCtrl.push(CuadreCajaDiarioValoresPorDenominacionPage)
      break;
      case "ProductosPorGruposDragPage":
      this.navCtrl.push(ProductosPorGruposDragPage)
      break;
      case "InformeReimprimirReciboCajaPage":
      this.navCtrl.push(InformeReimprimirReciboCajaPage)
      break;
    }
  }
      // implements OnInit
      // ngOnInit(): void {

      // }
  // Alternar e

  goToPage(page: string) {
    this.currentPage = page; // Actualiza la página actual
    //this.isMenuOpen = false; // Cierra el menú después de la selección
  }

  atras() {
    // this.viewControllers.dismiss();
    this.navCtrl.push(CreditosComponent)
  }

  onDragStart(event, card, index:any) {
    this.draggedCard = card[index];
    event.dataTransfer.setData('text', card[index]);
  }

  // Permitir que se suelte en la zona de destino
  onDragOver(event, card:any, index:any) {
    event.preventDefault();
  }

  // Evento cuando se suelta la tarjeta
  onDrop(event, card:any) {
    event.preventDefault();
    console.log('Cliente seleccionado', this.seleccionado.nombreCompleto);
    console.log(card)
    this.utils.mensajeMuestro('Drag and Drop',`Cliente seleccionado: ${this.seleccionado.nombreCompleto}`,'success')
  }


    // Método para extraer las compañías de las tareas
    getCompaniesFromTasks(tasks: Task[]): string[] {
      const companies = tasks.map(task => task.company);
      // Elimina duplicados si hay compañías repetidas
      return Array.from(new Set(companies));
    }

  // Función para mostrar/ocultar tareas dentro de un grupo
  toggleGroup(group:any) {
    group.open = !group.open;
  }

  async cargarServicio() {
    let companiasId = await localStorage.getItem('companiasId')
    let datos = this.callcenterProvider.buscarEstadosGestion(companiasId,'C')
    let response = (await datos).json()
    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      this.agruparEstadosGestion(valores);
      return
    }
  }

  agruparEstadosGestion(valores:any) {
    const agrupados = valores.reduce((acc, data) => {
      const descripcion = data.descripcion;
      const imagen = data.imagen;
      const cuantos = data.cuantos;
      if (!acc[descripcion]) {
        acc[descripcion] = { descripcion, imagen, cuantos, gestiones: [], open: false }; // open controla si se muestra el grupo
      }
      acc[descripcion].gestiones.push(data);
      return acc;
    }, {});

    this.estadosGestion = Object.keys(agrupados).map(key => agrupados[key]);
    this.estadosGestion = Object.keys(agrupados)
    .map(key => agrupados[key])
    .sort((a, b) => a.prioridad - b.prioridad);
    // for (let i = 0; i < 10; i++) {
    //   this.estadosGestion = this.estadosGestion.concat(
    //     Object.keys(agrupados)
    //       .map(key => agrupados[key])
    //       .sort((a, b) => a.prioridad - b.prioridad)
    //   );
    // }
    this.estadosGestion.forEach(estado => {
      estado.gestiones.forEach(gestion => {
        gestion.color = this.generateRandomColor();
      });
    });
  }

  toggleEstadosGestion(group:any) {
    group.open = !group.open;
    this.goToPage('Page2')
  }
  getInitials(nombreCompleto: string): string {
    const nombres = nombreCompleto.split(' ');
    const iniciales = nombres.map(nombre => nombre.charAt(0)).join('');
    return iniciales.toUpperCase(); // Devuelve las iniciales en mayúsculas
  }

  generateRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  irAHomePage() {
    this.navCtrl.setRoot(HomePage);
  }
  buscarData() {
    setTimeout(() => {
      // Verifica si la data está cargada
      if (this.listaProductos.length === 0) {
        console.log('La data no se cargó, llamando al método ');
        // this.buscarProductosPorEmpresa()
        this.cargarProductosPaginados()
      } else {
        console.log('Data cargada correctamente:');
      }
    }, 5000);
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    // Guarda el estado actual en localStorage
    localStorage.setItem('isCollapsed', this.isCollapsed.toString());
  }
  actualizarCantidadEnElCarrito() {
    this.contarProductos = this.listaProductosSeleccionados.length;
   }

   setProductos(productos: any[]) {
    this.productosSubject.next(productos);
  }

  getProductos() {
    return this.productosSubject.getValue();
  }

    setProductosSelect(productos: any[]) {
      if (!productos) {
        console.log('setProductosSelect recibió un valor undefined o null');
        return;
      }
      this.productosSelectSubject.next(productos);
      this.contarProductosSelect = productos.length; // Usar la lista que llega como argumento
  }

  getProductosSelect() {
    return this.productosSelectSubject.getValue();
  }

  toggleChatMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  abrirPagina(pagina:any,nombre:string){
    // this.rootPage = pagina

    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        this.utils.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique.', 'warning')
      }else{
        //this.fabVisible = true
        // this.nav.push(pagina,{data:data});
        this.accesosDirectos(pagina)
        // this.menuControllers.close()
      }

    })

  }

  async personalizar(){
    let valorTurno = 0
    if(this.listaProductosSeleccionados.length> 0) {
      let id = Number(this.listaProductosSeleccionados[0].comandasId)
      if(id) {
        valorTurno =   Number(this.listaProductosSeleccionados[0].turno)
      } else {
        valorTurno = await this.enviarcomandasUtilsPersonalizar(this.listaProductosSeleccionados)
      }
    }

    if(valorTurno > 0) {
      this.presentGestionarPedidoModal(valorTurno)
    } else {
      this.utils.mensajeMuestro('Caja','No tiene productos agregados al carrito. Verifique.', 'warning')
    }

  }

  async presentGestionarPedidoModal(valorTurno:any
  ) {
   await this.consultarTurno(valorTurno)
   this.setProductosSelect(this.listaProductosSeleccionados);
   this.listaProductosSeleccionados =  this.getProductosSelect()
   let modal = this.modalControllers.create(
   PersonalizarPage, {
    listaProductosSeleccionados: this.listaProductosSeleccionados,
    listaFormasDePago: this.formasDePago,
    valorTotalVenta:this.valorTotalVenta,
    valorTotalDevolver:this.valorTotalDevolver,
    CheckPorcentajeServicio:this.CheckPorcentajeServicio,
    turnosArray:this.turnosArray,
    mesaSeleccionada:this.mesaSeleccionada,
    deseaImprimir:this.CheckImprimir,
    valorTurno:valorTurno,
    datosAdicionales:this.datosAdicionales
  });
  modal.present();

  modal.onDidDismiss((detail: any) => {
    if (detail !== null) {
    let data:any = detail
    if (data) {
      let dividirCuenta = data.dividirCuenta
      this.formasDePagoSeGenero = data.formasDePagoSeGenero
      if(dividirCuenta) {
        this.cancelarVenta()
        this.reiniciarValores()
        return
      }
      this.groupedProducts = data.groupedProducts
      let productos = data.productos
      this.totals = data.totals
      this.deDondeViene = data.deDondeViene
      // let formasDePago = data.formasDePago
      this.formasDePagoGeneral = data !== undefined && data.formasDePago &&
      data.formasDePago[0] !== undefined && data.formasDePago[0].length > 0 ? data.formasDePago[0] : data.formasDePago
      let valorTotalDevolver = data.valorTotalDevolver
      let valorPagado = data.valorPagado
      if(this.deDondeViene === 'pagar') {
          this.pagarmesasFormasDePago(productos, this.formasDePagoGeneral,valorTotalDevolver,valorPagado)
      } else {
        this.groupedProducts = []
        this.totals = []
        this.deDondeViene = 'sin agrupar'
        this.valorTotalVenta = 0
        for(let i=0;i <this.listaProductosSeleccionados.length;i++){
          this.valorTotalVenta += Number(this.listaProductosSeleccionados[i].valorVenta) * Number(this.listaProductosSeleccionados[i].cantidad)
        }
        if(this.formasDePagoGeneral.length > 0) {
          const sumaTotal = this.formasDePagoGeneral.reduce((acc: number, formaPago: any) => {
            const valor = Number(formaPago.valor);
            return acc + (isNaN(valor) ? 0 : valor);
          }, 0);
          this.price = sumaTotal
          if (isNaN(sumaTotal) || sumaTotal < 0) { // Validamos que `sumaTotal` sea un número válido y positivo.
            this.price = 0;
          } else {
              this.price = sumaTotal;
          }
          this.format(this.price)
        } else {
          this.cancelarVenta()
          this.reiniciarValores()
        }
      }
    }}})
  }

  buscarClientesUnico(companiasId) {
    this.servicio.buscarClientesUltimoRegistro(companiasId)
    .subscribe((items: any)=>{
      let data = items && items.length> 0 ? items[0] : items
      this.clienteId = []
      this.clienteId.push({value:data.value, display:data.display})
      let cliente: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
      this.store.dispatch(actionClienteCaja);
      this.valoresCliente =  data.display;
    })
  }

  traerTodaLaInformacion() {
    this.reiniciarValores()
    setTimeout(() => {
      this.cd.detectChanges(); // Forzar la detección de cambios
    }, 5);
  }

  searchSimpleActualizarPrecio(cantidadafnSimpleActualizarPrecio:any,item,index){
    setTimeout(() => {
        if(Number(cantidadafnSimpleActualizarPrecio['_value'])==0 || isNaN(cantidadafnSimpleActualizarPrecio['_value']) ){
         return
       }
       let cantidadInput = cantidadafnSimpleActualizarPrecio['_value'];

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          cantidadafnSimpleActualizarPrecio['_value'] = 0;
          return
        }

       let cantidad = Number(cantidadafnSimpleActualizarPrecio['_value'])

       let nuevaCantidad = Number(cantidad)

       index = this.buscarIndexActualizarPrecio(item,index,nuevaCantidad)


       let valorImpuesto = 0
        let valorProducto = 0
        let valorTotalVenta = 0
        for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
          valorTotalVenta += Number(this.listaProductosSeleccionados[k].valorTotalVenta)
          valorImpuesto += Number(this.listaProductosSeleccionados[k]['valorImpuesto']) * Number(this.listaProductosSeleccionados[k].cantidad)
          valorProducto += Number(this.listaProductosSeleccionados[k]['valorProducto']) * Number(this.listaProductosSeleccionados[k].cantidad)
          }
          let porcentaje = valorTotalVenta * 10 / 100
          if(this.porcentajeServicioValor === "S") {
            this.valorTotalServicio = porcentaje
            this.valorTotalVenta = valorTotalVenta + porcentaje
          } else {
            this.valorTotalVenta = valorTotalVenta
          }
          this.valorTotalImpuestos = valorImpuesto
          this.valorTotalProductos = valorProducto
       return

     },1000)
   }

   buscarIndexActualizarPrecio(item:any,index:any,nuevaValor: number){
    let id  = Number(index)

    let tipoProducto  = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0
    let valorVentasTotalProductoNuevo = 0
    let ValorProductoVentas = 0
    let ValorSumoImpuesto = 0

            for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
              if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){
                  valorVentasTotalProductoNuevo += Number(nuevaValor) * this.listaProductosSeleccionados[k].cantidad
                  let valorImpuestoCalculado = this.listaProductosSeleccionados[k].valorImpuestoCalculo === undefined ?
                  this.listaProductosSeleccionados[k].valorImpuesto : this.listaProductosSeleccionados[k].valorImpuestoCalculo
                  ValorProductoVentas = Math.round(nuevaValor / ((valorImpuestoCalculado / 100)+1))
                  ValorSumoImpuesto =  nuevaValor - Math.round(nuevaValor / ((valorImpuestoCalculado / 100)+1))
                  this.listaProductosSeleccionados[k].valorTotalVenta = Number(nuevaValor) * this.listaProductosSeleccionados[k].cantidad
                  this.listaProductosSeleccionados[k].valorProducto = ValorProductoVentas
                  this.listaProductosSeleccionados[k].valorVenta = Number(nuevaValor)
                  this.listaProductosSeleccionados[k].valorImpuesto = ValorSumoImpuesto
                  this.refactorizarPedidosSalon = true
              } else {
                valorVentasTotalProductoNuevo += Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
                this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad

                let valorImpuestoCalculado = this.listaProductosSeleccionados[k].valorImpuestoCalculo === undefined ?
                this.listaProductosSeleccionados[k].valorImpuesto : this.listaProductosSeleccionados[k].valorImpuestoCalculo
                ValorProductoVentas = Math.round(this.listaProductosSeleccionados[k].valorVenta / ((valorImpuestoCalculado / 100)+1))
                ValorSumoImpuesto =  this.listaProductosSeleccionados[k].valorVenta - Math.round(this.listaProductosSeleccionados[k].valorVenta / ((valorImpuestoCalculado / 100)+1))
                this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
                this.listaProductosSeleccionados[k].valorProducto = ValorProductoVentas
                this.listaProductosSeleccionados[k].valorVenta = Number(this.listaProductosSeleccionados[k].valorVenta)
                this.listaProductosSeleccionados[k].valorImpuesto = ValorSumoImpuesto
              }
              }
    this.valorTotalVenta = valorVentasTotalProductoNuevo
    return indexNuevo
  }

  objectKeys(obj: { [key: number]: any[] }): number[] {
    return Object.keys(obj).map(key => +key);
  }

  isNumber(value: any): boolean {
    return !isNaN(Number(value));
  }

  calcularDevolucion(total: number, valorPagado: any): number {
    // const valor = typeof valorPagado === 'string' ? parseFloat(valorPagado.replace(/,/g, '')) : valorPagado;

    // return total - (isNaN(valor) ? 0 : valor);
    const valorPago = parseFloat(valorPagado.replace(/,/g, '')); // Convierte a número
    if (isNaN(valorPago)) {
      return 0; // Retorna 0 si el valor es inválido
    }
    return valorPago - total;
  }

  async pagarmesasFormasDePago(listaProductos:any = [], listaFormasDePago:any = [],valorTotalDevolver:any =0,valorPagado:any=0){
    var uuid = require('uuid/v4');
    let VentaUuid = uuid();
    this.datosAdicionales = {
      valorTotalVenta: 0,
      totalPagado: 0,
      valorTotalDevolver: 0,
      usuariosId: 0,
      companiasId: 0,
      clientesId: 0,
      turno:0,
      comandasId: 0,
      ventaDiariaUuid: VentaUuid
  };

  if(this.formasDePagoGeneral.length>0) {
      this.datosAdicionales['formasDePago'] = JSON.stringify(this.formasDePagoGeneral)
      let valorPago = '';
      if (typeof this.priceFormaDePago === 'string' && this.priceFormaDePago.includes(',')) {
        valorPago = this.priceFormaDePago.replace(/,/g, '');
      } else {
        valorPago = this.priceFormaDePago.toString();
      }
      this.valorTotalDevolver = 0
      this.valorTotalVenta = 0
      this.valorTotalVenta = Number(valorPago)

    }

    if(listaProductos.length>0) {
      this.listaProductosSeleccionados = []
      this.listaProductosSeleccionados = listaProductos
      if(listaFormasDePago.length>0) {
        this.valorTotalDevolver = 0
        this.valorTotalVenta = 0
        this.valorTotalDevolver = Number(valorTotalDevolver) - Number(valorPagado)
        this.valorTotalVenta = Number(valorPagado)
        this.datosAdicionales['formasDePago'] = JSON.stringify(listaFormasDePago)
      }
    }
    // this.insertResponse('buscarDatos', true)
    this.datosAdicionales['totalPagado'] = 0
    this.datosAdicionales['totalPagado'] = valorPagado> 0 ? valorPagado : this.valorTotalDevolver
    let valorTotalVentaValidar: number = valorTotalDevolver > 0 ? valorTotalDevolver : Number(this.valorTotalDevolver) - valorPagado > 0 ? valorPagado : Number(this.valorTotalVenta)
    if( valorTotalVentaValidar < 0 ){
      this.utils.mensajeMuestro('Pagar ventas','Valor a devolver no valido!','warning')
      return
    } else if ( this.valorTotalVenta < 0){

      this.utils.mensajeMuestro('Pagar ventas','Valor venta no valido!','warning')
      return
    }
    this.datosAdicionales['valorTotalDevolver'] = valorTotalVentaValidar
    this.datosAdicionales['valorTotalVenta'] = valorPagado> 0 ? valorPagado : this.valorTotalVenta

    this.getMultiple(['usuariosId','companiasId'])
    .then(async (res:any) => {
        let companiasId = res['companiasId'];

        let busquedaGestion = 'G'
        let valoreslistaProductosSeleccionados = []
        valoreslistaProductosSeleccionados = this.listaProductosSeleccionados[0]

        let codigo = valoreslistaProductosSeleccionados['codigo']
        let clienteCaja:any = await this.buscarClienteStore();

        if (clienteCaja['valuedisplay'] !== undefined && clienteCaja['valuedisplay'][0] !== undefined && clienteCaja['valuedisplay'][0].value !== undefined) {
          // envia el cliente que este seleccionado
          this.datosAdicionales['clientesId'] = clienteCaja['valuedisplay'][0].value
        }
        if(!this.CheckPorcentajeServicio && this.datosAdicionales['clientesId'] == 0){
          this.datosAdicionales['clientesId'] = 3
        }
        if(this.datosAdicionales['clientesId'] == 0 && this.formaPagoSeleccionada == 'C') {
          console.log(`Para generar una cuenta por cobrar debe asignar un cliente','Advertencia`)
          return
        }

        this.datosAdicionales['tipoVenta'] = this.formaPagoSeleccionada
        let cantidadActual = this.listaProductosSeleccionados.length
        this.datosAdicionales['servicio'] = this.listaProductosSeleccionados[0].incluirServicio == 'S' ? this.listaProductosSeleccionados[0].incluirServicio : 'N'

        this.datosAdicionales['usuariosId'] = res['usuariosId']
        this.datosAdicionales['companiasId'] = res['companiasId']

        if(this.datosAdicionales['usuariosId']==null){
          this.datosAdicionales['usuariosId'] = 3
        }

        // let desconect = localStorage.getItem('desconect');

        // if(desconect === '0') {

        if(codigo !== undefined) {
          this.servicio.buscarComandasFacturaPorCompaniaFormasDePago(codigo,companiasId)
          .subscribe((data:any)=>{
              data = listaProductos.length> 0 ? listaProductos : data.data[0]
              let cantidadReal = data.length
              if(cantidadReal == cantidadActual){
                if(listaProductos.length>0) {
                  this.generarVentaFormasDePago(listaProductos)
                }else {
                 this.generarVentaFormasDePago()
                }
              } else{
                if ( this.formasDePagoGeneral.length>0) {
                  this.generarVentaFormasDePago()
                } else{
                  this.comandaNoValida()
                }
              }
          },(error)=> console.log(error))
        } else {
          this.generarVentaSinGestionFormasDePago(this.listaProductosSeleccionados)
        }
    })


}

generarVentaFormasDePago(listaProductos:any =  []) {
  let listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(this.listaProductosSeleccionados)
                this.storage.get('fechaSistema').then(async (val) => {

                    if(val!=undefined){
                        this.datosAdicionales['fechaVenta'] = val
                    }
                    let elaboradosContenido:any = ''
                    let turno:any = undefined
                    let comandasId:any = undefined
                    if(this.datosAdicionales.turno != undefined && this.datosAdicionales.turno > 0) {
                      turno = this.datosAdicionales.turno
                      comandasId =  this.datosAdicionales.comandasId
                    }
                    if(comandasId == undefined){
                      let cuantosLista = listaProductosSeleccionadosNuevosValores.length - 1
                      comandasId = listaProductosSeleccionadosNuevosValores[cuantosLista].comandasId
                      this.datosAdicionales['comandasId'] =comandasId
                    }
                    if(this.datosAdicionales['turno'] == 0) {
                      this.datosAdicionales['turno'] =this.turnosArray[0].turno
                    }
                    this.datosAdicionales['codigo'] = listaProductosSeleccionadosNuevosValores[0].codigo
                    let usuarioIngreso = await this.storage.get('usuariosId');
                    let usuarioId = usuarioIngreso;
                    if(usuarioId) {
                      this.datosAdicionales['usuariosId'] = usuarioId
                    }
                    let metodosDePago = '{}'

                      if(listaProductos.length>0 || this.formasDePagoGeneral.length>0){
                        this.datosAdicionales['totalPagado'] = this.datosAdicionales['valorTotalDevolver']
                        this.datosAdicionales['valorTotalDevolver'] = this.datosAdicionales['valorTotalDevolver'] -   this.datosAdicionales['totalPagado']
                        if(this.formasDePagoGeneral.length>0) {
                          this.formasDePagoGeneral = this.formasDePagoGeneral.map((forma:any) => ({
                            persona: forma.persona,
                            codigoFormaPago: forma.codigoFormaPago,
                            formaPago: forma.nombreFormaPago, // renombrar nombreFormaPago a formaPago
                            imagen: forma.imagen,
                            valorFormaPago: forma.valor, // renombrar valor a valorFormaPago
                            formattedValor: forma.formattedValor
                          }));

                          metodosDePago = this.formasDePagoGeneral
                        }
                      }
                    this.servicio.guardarVenta(listaProductosSeleccionadosNuevosValores, this.datosAdicionales,elaboradosContenido,'','', metodosDePago).subscribe(
                        (resVenta:any) => {
                            // this.loader.dismiss()
                                this.mesaSeleccionada = listaProductosSeleccionadosNuevosValores[0].numeromesa
                                for(var k =0;k < listaProductosSeleccionadosNuevosValores.length;k++){
                                    if(this.mesaSeleccionada == listaProductosSeleccionadosNuevosValores[k].numeromesa){
                                        let datosComanda = {
                                            comandasId: listaProductosSeleccionadosNuevosValores[k].comandasId,
                                            estado: 'F',
                                            imagen: null,
                                            color: '#006400',
                                            queHago: "A",
                                            nombreTabla: "comandas",
                                            name: "dataDynamicCrud"
                                           }
                                          this.listaProductosSeleccionados = []
                                          this.servicio.actualizarComandas(datosComanda)
                                          .subscribe((data)=>{
                                          },(error)=>{
                                            console.log('error actualizarComandas', error)
                                          })
                                    } else {
                                      if(this.mesaSeleccionada == turno && listaProductosSeleccionadosNuevosValores[k].comandasId === comandasId){
                                        let consecutivo = JSON.parse(resVenta['_body']).data[0]
                                        let numeroFactura: string = ''; // Variable donde se guardará el número de factura
                                          consecutivo.forEach((item:any) => {
                                          if (item.reciboCaja.includes("Factura de Venta Nro:")) {
                                            // Extraer el número de factura
                                            const regex = /Factura de Venta Nro: (\d+)/;
                                            const match = item.reciboCaja.match(regex);
                                            if (match) {
                                                numeroFactura = match[1]; // El número de factura se guarda en la variable
                                            }
                                        }})
                                          this.servicio.ActualizarComandasPorTurno(this.datosAdicionales.companiasId,turno,numeroFactura)
                                          .subscribe((data:any)=>{
                                          },(error:any)=>{
                                          })
                                    }
                                    }
                                }
                           let dataJson = resVenta.data[0]

                           if(this.platform.is('android') || this.platform.is('ios')){
                          }else{
                            this.mostrarMensajeGeneral(dataJson)
                            let recibo = ''
                            let mensajes =  Object.keys(dataJson).map(key => dataJson[key])
                            for (let index:any = 0; index < mensajes.length; index++) {
                            if(this.deseaImprimir) {

                              this.servicio.imprimirRecibo(recibo).subscribe(
                                res => {

                                },
                                err => {
                                    // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                                    if(this.platform.is('android') || this.platform.is('ios')){
                                        this.mensajeToast(`${recibo}`)

                                    }else{

                                        this.mensajeToast(`${recibo}`)

                                    }

                                })





                            }

                            }
                          }


                        },
                        errVenta => {
                          console.log('error errVenta', errVenta)

                        }
                    )
                })
}

generarVentaSinGestionFormasDePago(listaProductosSeleccionados:any =[]) {
  if(listaProductosSeleccionados.length>0) {
    this.listaProductosSeleccionados = listaProductosSeleccionados
  }
    this.storage.get('fechaSistema').then((val) => {

        if(val!=undefined){
            this.datosAdicionales['fechaVenta'] = val
        }
        let elaboradosContenido = ''
        let turno = undefined
        let comandasId = undefined
        if(this.datosAdicionales.turno != undefined && this.datosAdicionales.turno > 0) {
          turno = this.datosAdicionales.turno
          comandasId =  this.datosAdicionales.comandasId
        }
        if(comandasId == undefined){
          let cuantosLista = this.listaProductosSeleccionados.length - 1
          comandasId = this.listaProductosSeleccionados[cuantosLista].comandasId
          this.datosAdicionales['comandasId'] =comandasId
        }
        if(this.datosAdicionales['turno'] == 0) {
          this.datosAdicionales['turno'] =this.turnosArray[0].turno
        }
        this.servicio.guardarVenta(this.listaProductosSeleccionados, this.datosAdicionales,elaboradosContenido,'').subscribe(
            (resVenta:any) => {
                // this.loader.dismiss()

                if(this.platform.is('android') || this.platform.is('ios')){
                  // this.modalPrintCualquieraBlutoothAndroid(resVenta.data)
                }else{
                  let dataJson = resVenta.data
                  let mensaje = dataJson
                  // this.mostrarMensajeGeneral(mensaje)
                  let recibo = ''
                  let mensajes =  Object.keys(mensaje).map(key => mensaje[key])
                  for (let index:any = 0; index < mensajes[0].length; index++) {
                    recibo += mensajes[0][index]['reciboCaja'] + '\n'
                  }
                  if(this.deseaImprimir) {
                    this.servicio.imprimirRecibo(recibo).subscribe(
                      res => {

                      },
                      err => {
                          // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                          if(this.platform.is('android') || this.platform.is('ios')){
                              this.mensajeToast(`${recibo}`)
                              // this.limpiarImpresion()

                          }else{

                              this.mensajeToast(`${recibo}`)
                              // this.limpiarImpresion()

                          }

                      })
                  }
                  // this.cerrarModalVentaGenerada()
                }


            },
            errVenta => {
              console.log('error errVenta', errVenta)
                // this.loader.dismiss()

            }
        )
    });
}


async generarVentaFormasDePagoSinAsignarTurno(datosAdicionalesResponse:any =  [],listaProductosSeleccionados:any,formasDePagoGeneral:any) {
  let usuarioIngreso = localStorage.getItem('usuariosId');
  let datosAdicionales = datosAdicionalesResponse === undefined ? this.datosAdicionales: datosAdicionalesResponse
  if(formasDePagoGeneral.length>0) {

    // Totaliza el campo "valor"
    const totalValor = formasDePagoGeneral.reduce((acumulador, item) => acumulador + item.valor, 0);

    // Asigna el resultado a una variable
    let valorGeneral = totalValor;
    this.valorTotalDevolver = 0
    this.valorTotalVenta = 0
    this.valorTotalVenta = Number(valorGeneral)
    datosAdicionales['totalPagado'] = valorGeneral
    datosAdicionales['valorTotalDevolver'] = this.valorTotalDevolver

  }


  let listaProductosSeleccionadosNuevosValores = this.refactorizarValoresSinAsignarTurno(listaProductosSeleccionados)
    this.storage.get('fechaSistema').then(async (val) => {
        if(val!==undefined && val!==null){
            datosAdicionales['fechaVenta'] = val
        }
        datosAdicionales['usuariosId'] = usuarioIngreso
        let elaboradosContenido = ''
        let metodosDePago:any = '{}'
          if(formasDePagoGeneral.length>0){
              this.formasDePagoGeneral = formasDePagoGeneral.map((forma:any) => ({
                codigoFormaPago: forma.codigoFormaPago,
                valorFormaPago: forma.valor,
                persona: forma.persona,
                formaPago: forma.nombreFormaPago, // renombrar nombreFormaPago a formaPago
                imagen: forma.imagen,
                formattedValor: forma.formattedValor
                }));

              metodosDePago = formasDePagoGeneral
              datosAdicionales['formasDePago'] = JSON.stringify(metodosDePago)
          }
          let data = listaProductosSeleccionadosNuevosValores
          this.listaProductosSeleccionados = []
          for(let i=0;i <data.length;i++){
            this.listaProductosSeleccionados.push({
              productosId:Number(data[i].productosId),
              tipoProducto:data[i].tipoProducto,
              cantidad:Number(data[i].cantidad),
              valorProducto: data[i].valorProductoIndividual == undefined ? Number(data[i].valorVenta) : Number(data[i].valorProductoIndividual),
              valorImpuesto: data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
              ubicacionesPorSalonesId:data[i].ubicacionesPorSalonesId,
              valorImpuestoCalculo: data[i].valorImpuestoCalculo
           });
        }
        this.servicio.guardarVenta(listaProductosSeleccionados, datosAdicionales,elaboradosContenido,'','', metodosDePago).subscribe(
            (resVenta:any) => {
                this.formasDePagoGeneral = []
                let dataJsonArray = resVenta['_body']
                let dataJson = JSON.parse(dataJsonArray)

                // this.mostrarMensajeGeneral(dataJson)
                let recibo = ''
                let mensajes =  Object.keys(dataJson).map(key => dataJson[key])
                for (let index:any = 0; index < mensajes.length; index++) {
                if(this.deseaImprimir && this.deseaImprimir === true) {

                  this.servicio.imprimirRecibo(recibo).subscribe(
                    res => {
                        // cerrar modal load
                        if (this.loader) {
                          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                        }
                    },
                    err => {
                        // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                        if(this.platform.is('android') || this.platform.is('ios')){
                            this.mensajeToast(`${recibo}`)

                        }else{

                            this.mensajeToast(`${recibo}`)

                        }
                        // cerrar modal load
                        if (this.loader) {
                          this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
                        }
                    })





                }

                }


            },
            errVenta => {
              console.log('error errVenta', errVenta)
              // cerrar modal load
              if (this.loader) {
                this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
              }
            }
        )
    },(eror)=> {
      if (this.loader) {
        this.loader.dismiss().catch(() => {}); // Evita errores si el loader ya fue cerrado
      }
    })
}


refactorizarValoresSinAsignarTurno(data:any){
  this.listaProductosSeleccionados = []

  for(let i=0;i <data.length;i++){
      this.listaProductosSeleccionados.push({
          productosId:Number(data[i].productosId),
          tipoProducto:data[i].tipoProducto,
          cantidad:Number(data[i].cantidad),
          valorProducto: data[i].valorProductoIndividual == undefined ? Number(data[i].valorVenta) : Number(data[i].valorProductoIndividual),
          valorImpuesto: data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          ubicacionesPorSalonesId:data[i].ubicacionesPorSalonesId,
          valorTotalImpuestos : data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          valorTotalVenta : Number(data[i].valorVenta),
          valorTotalProductos :  data[i].valorProductoIndividual == undefined ? Number(data[i].valorProducto) : Number(data[i].valorProductoIndividual),
          valorTotalDevolver: Number(data[i].valorVenta),
          clienteId: data[i].clientesId,
          valormesa: data[i].numeromesa,
          comandasId: 0,
          numeromesa:data[i].numeromesa,
          codigo:data[i].codigo,
          valorImpuestoCalculo: data[i].valorImpuestoCalculo
     });
  }
  this.setProductosSelect(this.listaProductosSeleccionados);
  return this.listaProductosSeleccionados
}


async enviarcomandasUtilsPersonalizar(listaProductosSeleccionados) {
    let valorTurno = 0
    let cliente = 0
    // saber si tiene cliente seleccionado
    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
    // envia el cliente que este seleccionado
    let clienteCaja = await this.buscarClienteStore();
    cliente = clienteCaja['valuedisplay'][0].value
   } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {
       // si tiene un cliente generico seleccionado
       cliente = this.clienteGenerico[0]['clientesId']
   } else {
       // envia un cliente null
       cliente = 0
   }
   let valoresTurno = await this.cargarTurnoAsync(cliente, 0, listaProductosSeleccionados[0]);
   if(valoresTurno.companiasId !== 0) {
     let valorTotalVenta = 0
     for(var k = 0;k < listaProductosSeleccionados.length;k++){
       valorTotalVenta += Number(listaProductosSeleccionados[k].valorVenta) * Number(listaProductosSeleccionados[k].cantidad)
     }
    let response: any = await this.utils.enviarcomandasUtils(valorTotalVenta,this.valorTotalDevolver,
       valoresTurno.usuariosId,valoresTurno.companiasId,false,cliente,listaProductosSeleccionados,
       valoresTurno.turno,this.CheckPorcentajeServicio,this.formaPagoSeleccionada,false
     )
     if(response.length>0) {
       let turnoNuevo = response[1] != undefined &&
       response[1][0] !== undefined && response[1][0].turno !== undefined ? response[1][0].turno : ''

       this.utils.mensajeMuestro('Nuevo turno guardado',
        'La nueva gestión se realizará con el turno # ' + turnoNuevo + '. Ahora puede proceder con la personalización.',
        'success');
       let companiasId = await localStorage.getItem('companiasId')
       valorTurno = await this.traerIdDelTurno(turnoNuevo,companiasId )
       this.turnoPersonalizado = valorTurno
     }
   } else {
     console.log('mensaje no existe info para guardar el turno')
   }
   return valorTurno
}

async traerIdDelTurno(turnoId: string, companiasId: string) {
  let turno = turnoId;
  try {
    let val: any = await this.servicio.buscarComandasturnoPorCompania(turno, companiasId).toPromise();

    this.listaProductosSeleccionados = [];
    this.setProductosSelect([]);
    let entrarDatos = false;
    let dataJson = NUBE_AWS ? JSON.parse(val['_body']) : val;
    let dataResponse = NUBE_AWS ? dataJson.data : val;
    val = dataResponse;

    if (val.length > 0 && val[0].length > 0) {
      this.realizandoUnaVenta = true;

      for (let k = 0; k < val[0].length; k++) {
        this.listaProductosSeleccionados.push(val[0][k]);
        this.valorTotalImpuestos += Number(val[0][k].valorImpuesto);
        this.valorTotalVenta += Number(val[0][k].valorTotalVenta);
        this.valorTotalProductos += Number(val[0][k].valorProducto);
        this.valorTotalDevolver += Number(val[0][k].valorTotalVenta);
        this.listaProductosSeleccionados[k]['valorImpuesto'] += k == 0 ? 0 : Number(val[0][k]['valorImpuestosIndividual']);
        this.listaProductosSeleccionados[k]['valorProducto'] += k == 0 ? 0 : Number(val[0][k]['valorProductoIndividual']);
        this.listaProductosSeleccionados[k]['domicilio'] = val[0][k].domicilio;
        this.listaProductosSeleccionados[k]['formaDePago'] = val[0][k].formaDePago;
        this.listaProductosSeleccionados[k]['incluirServicio'] = val[0][k].incluirServicio;
        this.datosAdicionales = {
          valorTotalVenta: this.valorTotalVenta,
          totalPagado: this.valorTotalDevolver,
          valorTotalDevolver: 0,
          usuariosId: val[0][k].usuariosId,
          companiasId: val[0][k].companiasId,
          clientesId: val[0][k].clientesId,
          turno: val[0][k].turno,
          comandasId: val[0][k].comandasId
        };
      }

      this.setProductosSelect(this.listaProductosSeleccionados);
      this.valormesa = Number(turno);
      entrarDatos = true;
    }
  } catch (error) {
    console.error('Error al traer los datos del turno', error);
  }

  return this.valormesa;
}


  async consultarTurno(id: any) {
    let turno = id
    let companiasId = await localStorage.getItem('companiasId')
    let response = await this.servicio.buscarComandasTurno(companiasId, turno)
    let valoresNuevoTurno = []
    if(response) {
      let valoresTurnos = JSON.parse(response['_body'])
      valoresNuevoTurno = valoresTurnos.data[0]
    }

    this.listaProductosSeleccionados = []
    if (valoresNuevoTurno.length > 0) {
      this.valorTotalImpuestos = 0
      this.valorTotalVenta = 0
      this.valorTotalProductos = 0
      this.valorTotalDevolver = 0
      this.valorTotalVenta = 0
      // tslint:disable-next-line: prefer-for-of
      for (let k = 0; k < valoresNuevoTurno.length; k++) {
          this.listaProductosSeleccionados.push(valoresNuevoTurno[k])
          this.valorTotalImpuestos += Number(valoresNuevoTurno[k].valorImpuesto)
          this.valorTotalVenta += Number(valoresNuevoTurno[k].valorTotalVenta)
          this.valorTotalProductos += Number(valoresNuevoTurno[k].valorProducto)
          this.valorTotalDevolver = Number(valoresNuevoTurno[k].valorTotalVenta)
          this.valorTotalVenta = Number(valoresNuevoTurno[k].valorTotalVenta)
      }
    }

  }
  async cargarProductosPaginados(infiniteScroll?) {
    if (this.cargandoScroll) return; // Evita múltiples llamadas concurrentes
    this.cargandoScroll = true; // Marca que está en proceso de carga

    let companiasId = await localStorage.getItem('companiasId');

    if (this.paginaActual > this.totalPaginas) {
        this.cargandoScroll = false; // Permite futuras cargas
        if (infiniteScroll) {
            infiniteScroll.complete(); // Asegura que el mensaje desaparezca
            infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled` en lugar de `enable(false)`
        }
        return;
    }

    this.servicio.buscarProductosPaginadoInfinito(companiasId, this.paginaActual, this.cantidadPorPagina, this.search, true)
        .subscribe((data: any) => {
            const productoPagina = !NUBE_AWS ? data : JSON.parse(data['_body']).data;

            if (productoPagina.length > 0) {
                let listaProductosCopia = [...this.listaProductos, ...productoPagina];
                this.listaProductos = [];
                this.listaProductos = listaProductosCopia.reduce((acc, productos) => acc.concat(productos), []);

                this.paginaActual++; // Solo incrementa después de recibir la respuesta
                console.log('paginaActual:', this.paginaActual);
            } else {
                if (infiniteScroll) {
                    infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                }
            }

            this.cd.detectChanges();
            this.cargandoScroll = false;

            if (infiniteScroll) {
                setTimeout(() => {
                    if (infiniteScroll) {
                        infiniteScroll.complete();
                        infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                        this.cd.detectChanges();
                    }
                }, 300);
            }
        }, error => {
            console.log(error);
            this.cargandoScroll = false;

            if (infiniteScroll) {
                console.log("Ejecutando infiniteScroll.complete();");
                infiniteScroll.complete(); // Oculta el mensaje en caso de error
                infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                this.cd.detectChanges();
            }
        });
}


onSearch(valor: string) {
  this.codigoBarra = valor.trim(); // Actualiza el valor de búsqueda sin espacios extras
  this.paginaActual = 1; // Reinicia la paginación
  this.listaProductos = []; // Limpia la lista para cargar los nuevos resultados
  this.cargarProductosPaginados(); // Llama al método de carga
}


searchCodigoBarraPaginador(cantidadafn:any,i:any){

  setTimeout(async () => {

    if (typeof cantidadafn['value'] === 'string' && cantidadafn['value'] !== "") {
      const numericValue = Number(cantidadafn['value']);
      if (!isNaN(numericValue)) {
        // El valor es un número, se puede manejar normalmente
        this.codigoBarra = cantidadafn['value'];
      } else {
        // El valor es una cadena alfanumérica
        this.codigoBarra = cantidadafn['value'];
      }
    } else {
      // El valor no es una cadena o está vacío
      cantidadafn['value'] = "";
      return;
    }

    if (this.codigoBarra === "") {
      this.showBuscarProducto = true;
      return false;
    }

    const tiempoActual = new Date().getTime();
    if (this.codigoBarra === this.ultimoCodigoBarra && (tiempoActual - this.ultimoTiempoEscaneo) < 500) {
      console.log("Código escaneado muy rápido, ignorando duplicado:", this.codigoBarra);
      return;
    }

    // Guardar el último código escaneado y el tiempo
    this.ultimoCodigoBarra = this.codigoBarra;
    this.ultimoTiempoEscaneo = tiempoActual;

    if (this.codigoBarra === "") {
      this.showBuscarProducto = true;
      return false;
    }
    let companiasId = await localStorage.getItem('companiasId')
     if(!MODO_DESCONECTADO){
         this.servicioCompania.buscarCodigoBarra(companiasId,this.codigoBarra)
         .debounceTime(3000)
         .subscribe(async (data)=>{

             if(NUBE_AWS){
               let items = JSON.parse(data['_body']).data[0]

               if(items.length){

                 let valores = items[0]
                 if(this.codigoBarra !== ""){
                  this.aumentarUnProductoCodigoBarra(valores)
                 }
                 this.codigoBarra = ""
                 this.search = ""
                 this.showBuscarProducto = false
                 this.cd.detectChanges();
               }else{
                   if (typeof cantidadafn['value'] === 'string') {
                     const numericValue = Number(cantidadafn['value']);
                     if (isNaN(numericValue)) {
                         this.codigoBarra = cantidadafn['value'];
                         if(this.manejaPaginacionEnTendero || this.agrupaProductosEnCaja) {
                          this.paginaActual = 1; // Reinicia la paginación
                          this.listaProductos = []; // Limpia la lista para cargar los nuevos resultados
                          this.cargarProductosPaginados(); // Llama al método de carga
                         } else {
                          let arregloPrincipal = this.listaProductos.filter( item => item.nombreProducto.toLowerCase().includes(this.buscarTexto.toLowerCase()))
                            if(arregloPrincipal.length > 0) {
                              this.showBuscarProducto = true;
                              return false;
                            }
                         }
                     }
                 }
                 this.formState = 'expanded'
                 this.formStatebool = true
                 this.cargarGrupos()
                 if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
                    this.cantidadafnprueba.nativeElement.focus();
                 }
                 this.codigoBarra = cantidadafn['value']
                 this.search = this.codigoBarra
                 this.codigoProducto = cantidadafn['value']
                 this.showBuscarProducto = false
             }
           } else {
             if(data[0].length){

               let valores = data[0][0]
               if(this.codigoBarra !== ""){
                 this.aumentarUnProductoCodigoBarra(valores)
               }
               this.codigoBarra = ""
               this.search = ""
           }else{
               this.formState = 'expanded'
               this.formStatebool = true
               this.codigoBarra = ""
               this.search = ""
               this.cargarGrupos()
               if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
                this.codigoBarra = ""
                this.search = ""
                this.cantidadafnprueba.nativeElement.focus();
              }
           }
           }

         },(error)=>{
           this.startTimerCodigoDeBarras()
           console.log(error)
           this.codigoBarra = ""
           this.search = ""
         })}else{
             this.formState = 'expanded'
             this.formStatebool = true
             this.codigoBarra = ""
             this.llenarGruposProductosDesconect()
             if(this.manejaCodigoDeBarras && this.cantidadafnprueba){
              this.codigoBarra = ""
              this.search = ""
              this.cantidadafnprueba.nativeElement.focus();
            }
         }
 }, 1000);
}

selectInputContent(event: any) {
  const inputElement = event.target;

  if (this.permitirSeleccion && inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}


ionViewDidEnter() {
  setTimeout(() => {
    if (this.shortcutConfigurator) {
      this.shortcutConfigurator.shortcuts[this.shortcutConfigurator.currentPage] =
      this.utils.getShortcuts(this.shortcutConfigurator.currentPage);
      this.applyShortcuts();
    }
  }, 500);
}


applyShortcuts() {
  this.shortcutConfigurator.elements.forEach(element => {
    const currentShortcuts = this.shortcutConfigurator.shortcuts[this.shortcutConfigurator.currentPage];
    if (currentShortcuts) {
      Object.keys(currentShortcuts).forEach(shortcut => {
        if (currentShortcuts[shortcut] === element.id) {
          this.shortcutConfigurator.assignShortcut(element.id, shortcut);
        }
      });
    }
  });
}

abrirCajon(){

  this.servicio.abrirCajon()
  .subscribe(
    rest => {
      console.log('abrir cajon')
    },
    error => {
      console.log(error)
    }
  )
}

async actualizarPrecioDatosAdicionalesDinamico(event: Event) {
  if (event) {
    event.preventDefault(); // 🔹 Evita conflictos si se ejecuta con F1
    event.stopPropagation();
}
  if(this.cambiarNombreYCambiarValorVentaAlProducto) {
    let valoresNuevosCampos = []
    let companiasId = await localStorage.getItem('companiasId')

    const nuevaLista = this.listaProductosSeleccionados.map(item => ({ productosId: item.productosId }));

    let datosResponse = await this.servicio.actualizarPreciosDatosAdicionalesDinamico( nuevaLista,companiasId)
    let response =  datosResponse.json()
    if(response && response.data && response.data[0] && response.data[0].length>0) {
        valoresNuevosCampos = response.data[0]
        let valorImpuesto = 0
        let valorProducto = 0
        let valorTotalVenta = 0
        let valorTotalVentaTemporal = 0
        valoresNuevosCampos[0].cantidad = 1
        valoresNuevosCampos[0].tipoProducto = "P"
        if(valoresNuevosCampos[0].valorProducto == undefined) {
          valoresNuevosCampos[0].valorProducto = valoresNuevosCampos[0].valorVenta
        }
        valoresNuevosCampos[0].editandoNombre = true
        this.toggleTipoImpuestoAsignarValorReal(valoresNuevosCampos[0])
        this.listaProductosSeleccionados.unshift(valoresNuevosCampos[0])
        let data = this.listaProductosSeleccionados
        for(let k = 0;k < data.length;k++){

          valorTotalVentaTemporal =  (Number(data[k].valorImpuesto) + Number(data[k].valorProducto)) * Number(data[k].cantidad)
          valorTotalVenta += valorTotalVentaTemporal
          valorTotalVentaTemporal = 0
          valorImpuesto += Number(data[k]['valorImpuesto']) * Number(data[k].cantidad)
          valorProducto += Number(data[k]['valorProducto']) * Number(data[k].cantidad)
          this.realizandoUnaVenta = true
        }

          this.setProductosSelect(this.listaProductosSeleccionados);
          let porcentaje = valorTotalVenta * 10 / 100
          if(this.porcentajeServicioValor === "S") {
            this.valorTotalServicio = porcentaje
            this.valorTotalVenta = valorTotalVenta + porcentaje
          } else {
            this.valorTotalVenta = valorTotalVenta
            this.porcentajeServicioValor = 'N'
          }
          this.valorTotalImpuestos = valorImpuesto
          this.valorTotalProductos = valorProducto
          this.refactorizarPedidosSalon = false
      }

  } else {
    this.utils.mensajeMuestroConCerrado('Producto nuevo',
      `Si desea agregar un producto nuevo a la venta y poder cambiarle el nombre y/o el valor de venta debe de cambiar la configuración en:
      Parametros Generales > cambiar nombre y Cambiar valor venta al producto
      Parametros Generales > impuesto por defecto al cambiar nombre

      `,
      'warning',true);
      return
  }

}

async actualizarNombreProducto(item:any) {
  let companiasId = await localStorage.getItem('companiasId')

  let datosResponse = await this.servicio.actualizarNombreProducto( companiasId,item.productosId,item.nombreProducto,item.valorProducto == undefined ? item.valorVenta : item.valorProducto,item.tipoImpuesto,item.valorImpuestoNuevo == undefined ? 0: item.valorImpuestoNuevo)
  let response =  datosResponse.json()
  if(response && response.data && response.data[0] && response.data[0].length>0) {
    this.mensajeToast('Producto actualizado con exito.')
  }
}

selectInputContentNombreProducto(event: any) {
  const inputElement = event.target;
  if(inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}
toggleTipoImpuestoAsignarValorReal(item:any) {
  this.tipoImpuesto = item.tipoImpuesto
  if(this.tipoImpuesto === 'I') {
    item.tipoImpuestoTexto = 'Impoconsumo'
  } else {
    item.tipoImpuestoTexto = 'Iva'
  }
}

toggleTipoImpuesto(item: any) {
  // Cambiar el tipo de impuesto solo para el producto actual
  item.tipoImpuesto = item.tipoImpuesto === 'I' ? 'V' : 'I';
  // Actualizar el texto según el tipo de impuesto
  if (item.tipoImpuesto === 'I') {
    item.tipoImpuestoTexto = 'Impoconsumo';
  } else {
    item.tipoImpuestoTexto = 'Iva';
  }

  console.log('Tipo de impuesto actualizado:', item.tipoImpuesto, item.tipoImpuestoTexto);
}

iniciarSocket() {
  this.socket = io(this.urlServerSocket); // Dirección de tu servidor
  this.socket.on('news', (data: any) => {
    if (data && data.serial) {
      this.zone.run(() => {
        this.pesoDesdeSocket = Number(data.serial); // Asignar el peso recibido
        console.log('Peso recibido desde socket:', this.pesoDesdeSocket);
      });
    }
  });
}


  scrollToTop() {
    if (this.inicio) {
      this.content.scrollTo(0, 0,300); // Scroll hasta el inicio (0,0)
    }
  }


}



class Task {
  public company: string;
  public description: string;
  public date: Date;
  public time: string;
  public progress: number; // Para llevar el progreso de cada tarea
}

class PorcentajeServicio {
  public nombre:string;
  public valor:string;
}

class CantidadImpresiones{
  public nombre:string;
  public value:string;
}

class cambioDeFecha {
  public nombre:string;
  public valor:string;
}

class formasDePago {
  public nombre:string;
  public valor:string;
  public imagen:string;
}



// WEBPACK FOOTER //
// ./src/pages/cajavertical/cajavertical.ts